/* eslint-disable no-template-curly-in-string */
export const mLingualDataDT = {
  ara: {
    header: {
      'header.mmt.text': 'ميكما يتريب',
      'header.black.text': 'أسود',
      'header.loyalty.programme': 'برنامج الولاء',
      'header.double.black.text': 'DOUBLEBLACK\n',
      'header.free.cancellation.assured': 'نضمن الإلغاء المجاني',
      'header.biz.pending': 'قيد الانتظار',
      'header.biz.requests': 'الطلبات',
      'header.my.trips': 'رحلاتي',
      'header.24x7': 'الدعم',
      'header.support': 'الدعم',
      'header.helplines.active.text':
          'يعمل مركز خدمة العملاء على مدار الساعة طوال أيام الأسبوع',
      'header.introducing.myBiz': 'نقدم إليكم ماي بيز',
      'header.mmt.for.business': 'ميكما يتريب للأعمال',
      'header.welcome.message': 'مرحبًا {firstName}',
      'header.login.or.create.account': 'تسجيل الدخول أو إنشاء حساب',
      'header.personal.text': 'شخصي',
      'header.myBiz.text': 'ماي بيز',
      'header.free.upgrade': 'ترقية مجانية إلى',
      'header.out.corporate.account': 'حسابنا المتعلق بالشركة',
      'header.corporate.fares': 'أسعار الشركات',
      'header.with.easy.modifications': 'مع تعديلات سهلة',
      'header.curated.hotels': 'فنادق منسقة',
      'header.safety.text': 'لإقامات آمنة وصحية',
      'header.gst.invoice': 'فاتورة ضريبة السلع والخدمات',
      'header.assurance': 'توكيد',
      'header.signup.work.mail': 'اشترك الآن مجانا !',
      'header.know.more': 'اعرف المزيد',
      'header.about.myBiz': 'حول ماي بيز',
      'header.personal.profile.text': 'تشاهد الحين ملفك الشخصي {email}',
      'header.myBiz.profile.text': 'تشاهد الآن ملفك الشخصي الخاص بماي بيز ',
      'header.my.trips.subtitle':
          'شاهد تفاصيل الحجز، طباعة التذكرة الإلكترونية، إلغاء الحجز، تعديل الحجوزات والتحقق من حالة استرداد الأموال والمزيد',
      'header.my.wallet': 'محفظتي ',
      'header.my.wallet.subtitle':
          ' للحصول على خصومات أكبر يرجى استخدام نقود المحفظة الخاصة بك',
      'header.my.mmt.black': 'MMT Black\n',
      'header.my.mmt.black.subtitle':
          'شاهد رحلاتك الماضية والمعالم واطلب المكافآت',
      'header.my.mmt.double.black': 'MMT Double Black\n',
      'header.my.mmt.double.black.inactive':
          'اشتر الآن للحصول على إلغاء حجوزات الطيران والفنادق بدون متاعب',
      'header.my.mmt.double.black.active':
          'شاهد المزايا الخاصة بـ MMTDoubleBlack',
      'header.my.mmt.double.black.expired':
          'انتهت صلاحية عضويتك، يرجى تجديد العضوية للمضي قدما في التمتع بفوائد إم إم تي دابيل بلاك',
      'header.my.profile': 'ملفي الشخصي',
      'header.my.profile.subtitle':
          'إدارة الملف الشخصي الخاص بك وتفاصيل المسافر وتفاصيل تسجيل الدخول وكلمة المرور',
      'header.my.make.payment': 'لإجراء الدفع',
      'header.my.make.payment.subtitle': 'يرجى إتمام عملية الدفع المتبقي هنا',
      'header.logout.text': 'تسجيل الخروج',
      'header.login.signup.for.best.prices':
          'تسجيل الدخول / الاشتراك للحصول على الأسعار التنافسية',
      'header.login.signup.text.cash':
          ' يرجى التسجيل أو الاشتراك للحصول الفوري {currency} على 555  ',
      'header.login.signup.easily.with': 'تسجيل الدخول / الاشتراك بسهولة مع',
      'header.login.with.phone.email':
          'تسجيل الدخول باستخدام الجوال/ عنوان البريد الإلكتروني',
      'header.welcome.text': 'هلا',
      'header.traveller.text': 'مسافر',
      'header.login.success.message':
          'تم تسجيل الدخول بنجاح!\nلا يمكن الربط مع رقم الجوال',
      'header.myBiz.login.message':
          'نحن لا ندعم تسجيل الدخول إلى حساب ماي بيز باستخدام رقم الهاتف بعد، يمكنك الاستمرار في الوصول إلى حسابك باستخدام بريدك الإلكتروني وكلمة المرور',
      'header.mobile.number.linked.message':
          'يحتوي هذا الحساب أصلا على رقم جوال مرتبط بهذا، يرجى زيارة قسم الملف الشخصي لإلغاء ربط رقم الهاتف المرتبط أولاً والمحاولة مرة أخرى.',
      'header.move.back.text': 'العودة',
      'header.skip.text': 'تجاوز',
      'header.login.with.password': 'تسجيل الدخول بكلمة المرور',
      'header.login.signup.text': 'التسجيل/الاشتراك',
      'header.email.placeholder.text': 'أدخل عنوان البريد الإلكتروني',
      'header.for.account.text': 'للحساب {username}',
      'header.email.or.mobile.placeholder.text':
          'أدخل عنوان البريد الإلكتروني أو رقم الجوال',
      'header.email.label.text': 'البريد الإلكتروني',
      'header.email.or.mobile.label.text': ' البريد الإلكتروني أو رقم الجوال',
      'header.continue.text': 'متابعة',
      'header.login.with.text': 'أو تسجيل الدخول بـ',
      'header.company.login.portal.text': 'بوابة الدخول للشركات',
      'header.login.to.myBiz.account':
          'يمكنك القيام بتسجيل الدخول إلى حسابك ماي بيز باستخدام بيانات الشركة',
      'header.login.text': 'تسجيل الدخول',
      'header.login.via.otp': 'أو تسجيل الدخول باستخدام كلمة المرور',
      'header.otp.on.mail.message':
          'ستتلقى كلمة المرور لمرة واحدة في عنوان البريد الخاص بك',
      'header.login.signup.with.text': 'أو تسجيل الدخول / الاشتراك باستخدام',
      'header.no.myBiz.account.message': 'ليس لديك حساب خاص بماي بيز؟',
      'header.create.account.here.message': 'إنشاء حساب هنا',
      'header.saving.on.business.travel.message':
          'وابدأ في التوفير في رحلات العمل',
      'header.personal.account.text': 'الحساب الشخصي',
      'header.myBiz.account.text': 'حساب ماي بيز',
      'header.reset.password.text': 'إعادة تعيين كلمة المرور',
      'header.mobile.not.registered.text': 'يبدو أن رقم الجوال',
      'header.mobile.not.registered.action.text':
          'غير مسجل في MakeMyTrip، ماذا تريد أن تفعل بعد ذلك؟',
      'header.create.personal.account.message':
          'إنشاء حساب شخصي جديد باستخدام رقم الجوال هذا',
      'header.link.existing.account': 'اربط مع حساب موجود',
      'header.link.user.to.existing.account':
          'ربط {displayUserName} بحساب موجود',
      'header.dismiss.text': 'إلغاء',
      'header.account.already.exists.message':
          '{accountType} حساب موجود بالفعل',
      'header.registered.account.action.message':
          'يبدو أنك تحاول تسجيل الدخول بحساب {accountType} حساب مسجل بالفعل باستخدام البريد الإلكتروني: {username}، ماذا تريد أن تفعل بعد ذلك؟',
      'header.login.with.email':
          'تسجيل الدخول إلى {accountType} باستخدام هذا البريد الإلكتروني ',
      'header.create.new.account':
          'إنشاء حساب {accountType} جديد باسم {username}',
      'header.get.otp.for.mobile.login':
          'للحصول على كلمة المرور من أجل التسجيل باستخدام رقم الجوال',
      'header.access.myBiz.account': 'الدخول إلى ماي بيز عبر حساب الشركة',
      'header.company.registered.myBiz.account':
          'نرى أن شركتك قد سجلت بالفعل حساب myBiz لك باستخدام البريد الإلكتروني الشخصي: {username} ، ماذا تريد أن تفعل بعد ذلك؟',
      'header.login.myBiz.with.company.portal':
          'تسجيل الدخول إلى ماي بيز باستخدام بوابة تسجيل الخاصة بالشركة',
      'header.password.placeholder.text': 'الحد الأدنى 6 أحرف.',
      'header.password.text': 'كلمة المرور',
      'header.remember.me.text': 'تذكرنى',
      'header.agent.id.text': 'معرف الوكيل',
      'header.enter.mobile.number.text': 'أدخل رقم الجوال',
      'header.send.otp.text': 'أرسل كلمة المرور (أو تي بي)',
      'header.verify.mobile.number.title': 'تحقق من رقم الجوال',
      'header.verify.mobile.number.subtitle':
          'يرجى التأكد من رقم الجوال من أجل المتابعة',
      'header.and.word.text': 'و',
      'header.or.use.text': 'أو يرجى استخدام',
      'header.create.account.with': 'أو إنشاء حساب مع',
      'header.resend.otp.text': 'إعادة إرسال كلمة المرور',
      'header.verify.text': 'تحقق من',
      'header.otp.text': 'كلمة المرور ',
      'header.enter.otp.sent.to.text': 'أدخل كلمة المرور الموجهة إلى',
      'header.add.mobile.number.text': 'لإضافة رقم الجوال',
      'header.enter.myBiz.account.password':
          'أدخل كلمة المرور الخاصة بحساب ماي بيز',
      'header.create.account.text': 'إنشاء حساب',
      'header.signup.agree.text': 'إنك توافق من خلال الاشتراك على',
      'header.terms.and.conditions.text': 'الأحكام والشروط',
      'header.email.or.phone.placeholder':
          'أدخل عنوان البريد الإلكتروني أو رقم الجوال',
      'header.password.same.message':
          "ستكون كلمة مرور حسابك الشخصي مماثلة لكلمة مرور حساب ماي بيز <span class='latoBold'> (abhinav.mittal@go-mmt.com)</span>",
      'header.create.personal.account.text': 'إنشاء حساب شخصي جديد',
      'header.enter.username.for.linking.mobile':
          'أدخل اسم المستخدم للحساب الذي تريد ربط رقم الجوال {displayUserName} به.',
      'header.continue.text.capitalized': 'متابعة ',
      'header.login.via.password.text': 'أو تسجيل الدخول عبر كلمة المرور',
      'header.verify.emailId.message':
          'تحقق من عنوان البريد الإلكتروني الخاص بك',
      'header.verify.mobile.message': 'تحقق من رقم الجوال',
      'header.enter.otp.on.email.text':
          'يرجى إدخال كلمة المرور (او تي بي) الموجهة إلى {username} او عنوان البريد الإلكتروي المسجل من أجل التسجيل',
      'header.enter.otp.on.mobile.text':
          'الرجاء إدخال كلمة المرور الموجهة إلى {username} أو رقم هاتفك الجوال المسجل عند تسجيل الدخول',
      'header.enter.otp.sent.to.username.text':
          'الرجاء إدخال كلمة المرور الموجهة إلى {username} لتسجيل الدخول',
      'header.login.to.your.account.text': 'لتسجيل الدخول إلى حسابك.',
      'header.reset.the.password.text': 'لإعادة تعيين كلمة المرور.',
      'header.to.continue.text': 'للمواصلة',
      'header.send.reset.otp.on.email.mobile':
          'سنبعث كلمة المرور الخاصة بإعادة تعيين إلى عنوان البريد الإلكتروني المسجل أو رقم الجوال',
      'header.send.reset.otp.on.email':
          'سيتم بعث كلمة المرور  الجديدة إلى عنوان البريد الإلكتروني المسجل',
      'header.register.email.or.mobile.text':
          'البريد الإلكتروني المسجل أو رقم الجوال',
      'header.register.email.text': 'البريد الإلكتروني المسجل',
      'header.username.not.exist.message': 'اسم المستخدم هذا غير متوفر.',
      'header.trying.to.create.new.account':
          'إذا كنت تحاول إنشاء حساب {accountType} جديد',
      'header.google.business.account.text': 'حساب جوجل للأعمال',
      'header.new.password.text': 'كلمة المرور الجديدة',
      'header.create.new.password.text': 'إنشاء كلمة مرور جديدة',
      'header.new.password.validations.text':
          'يجب ألا تقل عن 8 أحرف كما يجب أن تحتوي على أبجدية واحدة على الأقل ورقم واحد وحرف خاص واحد @ $!٪ * #؟ &',
      'header.redirect.to.login.text': 'توجّه الى التسجيل',
      'header.password.changed.successfully.message':
          'تم تعديل كلمة المرور بنجاح',
      'header.do.not.share.password.message':
          'لا تشارك كلمة المرور الخاصة بك مع أي شخص آخر، وذلك لمنع سوء استخدامها',
      'header.login.successful.message': 'تم تسجيل الدخول بنجاح',
      'header.A.letter.text': 'أ',
      'header.successful.logged.in.message':
          'لقد تم تسجيل الدخول إلى حسابك بنجاح ',
      'header.account.creation.unsuccessful': 'إنشاء الحساب غير ناجح',
      'header.account.creation.unsuccessful.message':
          'لم نتمكن من إنشاء حسابك بسبب عدم التحقق من رقم الهاتف المحمول بنجاح',
      'header.continue.creating.account': 'المضي قدماً في إنشاء الحساب',
      'header.reset.your.password.text': 'لإعادة تحديد كلمة المرور الخاصة بك',
      'header.enter.otp.sent.text': 'أدخل كلمة المرور الموجهة إلى',
      'header.verify.and.link.account': 'للتحقق وربط نفسه بالحساب',
      'header.enter.otp.placeholder': 'أدخل كلمة المرور ',
      'header.create.next.account.text': 'انشاء حساب جديد',
      'header.already.a.member.text': 'عضوا أصلاً؟',
      'header.verify.number.and.create.account': 'التحقق من الرقم وإنشاء حساب',
      'header.login.myBiz.with.email':
          'تسجيل الدخول إلى ماي بيز باستخدام عنوان البريد الإلكتروني هذا',
      'header.already.registered.email.message':
          'يبدو أنك تحاول التسجيل باستخدام حساب myBiz مسجل بالفعل باستخدام  البريد الإلكتروني: {username}، ماذا تريد أن تفعل بعد ذلك؟',
      'header.myBiz.account.exists': 'يوجد حساب ماي بيز أصلاً',
      'header.congratulations.message': 'مبروك !',
      'header.account.created.successfully': 'تم إنشاء الحساب بنجاح',
      'header.save.and.continue.text': 'حفظ ومتابعة',
      'header.save.and.verify.mobile.text': 'احفظ وتحقق من رقم الجوال',
      'header.account.created.successfully.message':
          'مبروك! تم إنشاء حسابك بنجاح! يمكنك مباشرة الحجز الآن للحصول على \n الأسعار التنافسية',
      'header.unlocked.bonus.reward.message': 'مبروك! لقد نجحت في فتح مكافأة ',
      'header.wallet.money.rewarded': ' نقود المحفظة  555 ',
      'header.verify.and.create.account': 'للتحقق وإنشاء الحساب',
      'header.verify.and.link.account.text': 'يرجى التأكد والربط مع الحساب',
      'header.incorrect.otp.entered.text':
          'تم إدخال كلمة مرور غير صحيحة، يرجى المحاولة مرة أخرى',
      'header.enter.otp.label': 'أدخل كلمة المرور ',
      'header.enter.otp.here.placeholder': 'أدخل كلمة المرور (أو تي بي)',
      'header.numeric.validation': 'يجب أن يكون رقما',
      'header.min.characters.validation':
          'يجب أن يكون عدد الأحرف {min} أو أكثر',
      'header.max.characters.validation': 'يجب أن يكون عدد الأحرف {max} أو أقل',
      'header.min.value.validation': 'يجب ألا يقل عن  {min}',
      'header.email.format.message':
          ' يجب أن يكون عنوان البريد الإلكتروني بشكل abc@xyz.com',
      'header.aol.email.message':
          'حقاً هل أنت تستخدم نظام إي أو إل لتشغيل البريد الإلكتروني؟',
      'header.alphanumeric.validation': 'الأحرف الأبجدية الرقمية فقط ',
      'header.mobile.number.validation':
          'رقم الهاتف غير صحيح، يجب أن يتكوّن من 10 أرقام',
      'header.required.validation': 'مطلوب',
      'header.privacy.policy.text': 'سياسة الخصوصية\n',
      'header.user.agreement.text': 'اتفاقية المستخدم',
      'header.terms.of.service.text': 'الشروط والأحكام',
      'header.invalid.phone.number': 'رقم الهاتف غير صحيح',
      'header.your.username.message': 'سيكون هذا اسم المستخدم الخاص بك',
      'header.otp.verification.completed':
          'يتم التحقق من \n<b> كلمة المرور\n<b> عندما يتم إنشاء الحساب باستخدام رقم الجوال',
      'header.click.here.text': 'اضغط هنا',
      'header.attempting.login.text': 'إذا كنت تحاول تسجيل الدخول.',
      'header.enter.password.placeholder': 'أدخل كلمة المرور',
      'header.enter.work.email': 'أدخل عنوان البريد الإلكتروني للعمل الخاص بك',
      'header.agreement.text.on.mmt': 'بالمتابعة فإنك توافق ميك ماي تريب على ',
      'header.policy.text': 'الخصوصية',
      'header.login.expired': 'انتهت وقت صلاحية تسجيل الدخول',
      'header.click.to.login.again':
          "لا داعى للقلق! نقوم بتسجيل خروج المستخدمين بانتظام لحماية حساباتهم بشكل أفضل. فقط <a className='latoBold'>انقر هنا لتسجيل الدخول مرة أخرى</a> والاستمتاع بتجربة MMT.",
      'header.signup.with.facebook': 'اشترك عبر حساب فيسبوك',
      'header.login.with.facebook': 'تسجيل الدخول باستخدام الفيسبوك',
      'header.signup.with.google': 'اشترك باستخدام جوجل',
      'header.login.with.google': 'تسجيل الدخول باستخدام جوجل',
      'header.login.or.signup.message': 'تسجيل الدخول/ الاشتراك',
      'header.work.email.text': ' البريد الإلكتروني الخاص بالعمل',
      'header.verification.successful.text': 'تم التأكد بنجاح',
      'header.mobile.number.verified.message':
          'مبروك! تم التحقق  من رقم الجوال {username} بنجاح وتم ربطه بالحساب {emailId}',
      'header.cruise': 'رحلة بحرية',
      'header.new.text': 'جديد',
      'header.admin.text': 'مدير',
      'header.ACTIVITIES': 'أنشطة',
      'header.NEARBY_GETAWAYS': 'أماكن السياحة القريبة',
      'header.TRIP_MONEY': 'تريب موني',
      'header.FLIGHTS': 'رحلات',
      'header.CHARTER_FLIGHTS': 'رحلات الطيران التشارتر',
      'header.CHARTER_FLIGHTS_CLASS': 'الطائرات التشارتر ',
      'header.HOTELS': 'الفنادق',
      'header.HOLIDAYS': 'أيام العطلات',
      'header.HOLIDAY_PACKAGES': 'حزمة لأيام العطلة',
      'header.BUSES': 'الحافلات',
      'header.CABS': 'سيارات الأجرة',
      'header.BIZ_CABS': 'تاكسي المطار',
      'header.TRAINS': 'القطارات',
      'header.GIFTCARDS': 'بطاقات الهدايا',
      'header.MORE': 'المزيد',
      'header.LOGIN_AGENT': 'تسجيل دخول الوكيل',
      'header.MMT_LOGO_ALT': 'شعار ميكما يتريب',
      'header.ACTIVE': 'نشط',
      'header.IN_YOUR_WALLET': 'في محفظتك',
      'header.YOUR_WALLET': 'محفظتك',
      'header.LOGIN_OR': 'تسجيل الدخول أو',
      'header.CREATE_ACCOUNT_TEXT': 'إنشاء حساب',
      'header.MY_BIZ': 'ماي بيز',
      'header.INT_FLIGHT': 'الرحلات الجوية الدولية',
      'header.INT_HOTEL': 'الفنادق الدولية ',
      'header.REFER_EARN': 'تحيل وتكسب',
      'header.BLOG': 'المدونة',
      'header.Deals': 'صفقات',
      'header.VENUES': 'الأماكن',
      'header.ADMIN_SITE': 'مدير',
      'header.HOME_STAYS': 'الفلل والشقق',
      'header.HOME_STAYS_CLASS': 'منازل',
      'header.VISA': 'تأشيرة',
      'header.MICE': 'الفئران',
      'header.TRIP_IDEAS': 'أفكار الرحلة',
      'header.LOGIN_ENTER_VALID_EMAIL_ERROR_MESSAGE':
          'الرجاء إدخال البريد الإلكتروني أو رقم الهاتف المتحرك الصالح.',
      'header.LOGIN_ENTER_VALID_AGENT_ERROR_MESSAGE':
          'الرجاء إدخال رقم وكيل صالح.',
      'header.LOGIN_ENTER_VALID_ONLY_EMAIL_ERROR_MESSAGE':
          'يرجى إدخال عنوان البريد الإلكتروني الصحيح.',
      'header.LOGIN_ENTER_PASSWORD_ERROR_MESSAGE': 'الرجاء إدخال كلمة المرور.',
      'header.LOGIN_ENTER_VALID_PASSWORD_ERROR_MESSAGE':
          'لا يمكن أن تكون كلمة المرور أقل من 6 أحرف.',
      'header.LOGIN_ENTER_VALID_OTP_ERROR_MESSAGE':
          ' الرجاء إدخال كلمة المرور (أو تي بي)',
      'header.SIGNUP_ENTER_VALID_CHARACTER_PASSWORD_ERROR_MESSAGE':
          'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل كما يجب أن تحتوي على أبجدية واحدة على الأقل ورقم واحد وحرف خاص واحد @ $!٪ * #؟ &',
      'header.OTP_LOGIN_VALID_OTP_ERROR':
          'كلمة المرور غير صحيحة! يرجى إدخال كلمة المرور  الموجهة إليك',
      'header.LOGIN_ACCOUNT_BLOCKED_ERROR_MESSAGE':
          'لقد تجاوزت الحد الأقصى لمحاولات تسجيل الدخول. يرجى المحاولة مرة أخرى بعد',
      'header.LOGIN_INCORRECT_EMAIL_PASSWORD_ERROR_MESSAGE':
          'اسم المستخدم أو كلمة المرور غير صحيحة',
      'header.LOGIN_DEFAULT_ERROR_MESSAGE':
          'يبدو أننا نواجه بعض المشكلات التقنية، يرجى المحاولة مرة أخرى بعد.',
      'header.FORGOT_PASSWORD_USER_NOT_EXISTS_ERROR_MESSAGE':
          'اسم المستخدم غير متوفر، الرجاء إدخال عنوان البريد الإلكتروني الصالح أو رقم الجوال',
      'header.FORGOT_PASSWORD_DEFAULT_ERROR_MESSAGE':
          'حدث خطأ ما، الرجاء المحاولة مرة أخرى ',
      'header.VERIFY_OTP_LIMIT_CROSSED_ERROR_MESSAGE':
          'لقد تجاوزت الحد الأقصى لمحاولة إرسال كلمة المرور، يرجى المحاولة مرة أخرى لاحقاً',
      'header.VERIFY_OTP_INCORRECT_OTP_ERROR_MESSAGE':
          'كلمة المرور غير الصحيحة، يرجى المحاولة مرة اخرى',
      'header.FORGOT_PASSWORD_OTP_INVALID_TOKEN_ERROR_MESSAGE':
          'كلمة المرور غير الصحيحة، يرجى المحاولة مرة اخرى',
      'header.FORGOT_PASSWORD_OTP_DEFAULT_ERROR_MESSAGE':
          'حدث خطأ ما، الرجاء المحاولة مرة أخرى ',
      'header.FORGOT_PASSWORD_OTP_INCORRECT_OTP_ERROR_MESSAGE':
          'كلمة المرور غير الصحيحة، يرجى المحاولة مرة اخرى',
      'header.LOGIN_CREDENTIALS_EXPIRED_ERROR_MESSAGE':
          'لقد انتهت صلاحية كلمة المرور الخاصة بك. الرجاء الضغط فوق إعادة تعيين كلمة المرور لإعادة تعيين كلمة المرور الخاصة بك.',
      'header.PLACEHOLDER_COUNTRY_CODE': 'اسم البلد أو الرمز',
      'header.NOT_VALID_USER': 'لا يوجد حساب شخصي مرتبط بهذا البريد الإلكتروني',
      'header.ACCOUNT_ALREADY_LINKED': 'هذا الحساب لديه رقم هاتف مرتبط أصلا',
      'header.PROCEED_TO_LOGIN_MSG': 'بالمضي قدماً فإنك توافق ميكما يتريب على ',
      'header.TOS_MSG': 'الشروط والأحكام',
      'header.PRIVACY_POLICY_MSG': 'سياسة الخصوصية\n',
      'header.USER_AGREEMENT_MSG': 'اتفاقية المستخدم',
      'header.PHONE_NUMBER_ALREADY_LINKED': 'رقم الهاتف مرتبط بحساب آخر.',
      'header.GOOGLE_ERROR': 'فشل تسجيل الدخول باستخدام جوجل',
      'header.FB_ERROR': 'فشل تسجيل الدخول بفيسبوك',
      'header.NO_MATCH_FOUND': 'لا يوجد تطابق',
      'header.facebook.text': 'الفيسبوك',
      'header.google.text': 'جوجل',
      'header.enter.fullname.text': ' الاسم الكامل',
      'header.enter.valid.name.message': 'رجاء إدخال اسما صحيحا',
      'header.incorrect.format.message': 'صيغة غير صحيحة',
      'header.invalid.phone.number.message': 'رقم الهاتف غير صحيح',
      'header.enter.full.name.placeholder': 'أدخل اسمك الكامل',
      'header.country.ad.376.name': 'أندورا',
      'header.country.ae.971.name': 'الإمارات العربية المتحدة',
      'header.country.af.93.name': 'أفغانستان',
      'header.country.ag.1.name': 'أنتيغوا وبربودا',
      'header.country.ai.1.name': 'أنغيلا',
      'header.country.al.355.name': 'ألبانيا',
      'header.country.am.374.name': 'أرمينيا',
      'header.country.ao.244.name': 'جمهورية أنغولا',
      'header.country.aq.672.name': 'أنتاركتيكا',
      'header.country.ar.54.name': 'الأرجنتين',
      'header.country.as.1.name': 'ساموا الأمريكية',
      'header.country.at.43.name': 'النمسا',
      'header.country.au.61.name': 'أستراليا',
      'header.country.aw.297.name': 'أروبا',
      'header.country.az.358.name': 'جزر آلاند',
      'header.country.az.994.name': 'أذربيجان',
      'header.country.ba.387.name': 'البوسنة والهرسك',
      'header.country.bb.1.name': 'باربادوس',
      'header.country.bd.880.name': 'بنغلاديش',
      'header.country.be.32.name': 'بلجيكا',
      'header.country.bf.226.name': 'بوركينا فاسو',
      'header.country.bg.359.name': 'بلغاريا',
      'header.country.bh.973.name': 'مملكة البحرين',
      'header.country.bi.257.name': 'بوروندي',
      'header.country.bj.229.name': 'جمهورية بنين',
      'header.country.bl.590.name': 'سانت بارتيليمي',
      'header.country.bm.1.name': 'برمودا',
      'header.country.bn.673.name': 'بروناي دار السلام',
      'header.country.bo.591.name': 'بلوريناشانال ستايت اوف بوليفيا',
      'header.country.br.55.name': 'البرازيل',
      'header.country.bs.1.name': 'جزر البهاما',
      'header.country.bt.975.name': 'بوتان',
      'header.country.bw.267.name': 'بوتسوانا',
      'header.country.by.375.name': 'بيلاروس',
      'header.country.bz.501.name': 'بليز',
      'header.country.ca.1.name': 'كندا',
      'header.country.cc.61.name': 'جزر كوكوس',
      'header.country.cd.243.name': 'جمهورية الكونغو الديمقراطية',
      'header.country.cf.236.name': 'جمهورية افريقيا الوسطى',
      'header.country.cg.242.name': 'جمهورية الكونغو',
      'header.country.ch.41.name': 'سويسرا',
      'header.country.ci.225.name': 'ساحل العاج',
      'header.country.ck.682.name': 'جزر كوك',
      'header.country.cl.56.name': 'تشيلي',
      'header.country.cm.237.name': 'الكاميرون',
      'header.country.cn.86.name': 'الصين',
      'header.country.co.57.name': 'كولومبيا',
      'header.country.cr.506.name': 'كوستا ريكا',
      'header.country.cv.238.name': 'جمهورية كابو فيردي / الرأس الأخضر',
      'header.country.cx.61.name': 'جزيرة كريسماس',
      'header.country.cy.357.name': 'قبرص',
      'header.country.cz.420.name': 'جمهورية التشيك',
      'header.country.de.49.name': 'ألمانيا',
      'header.country.dj.253.name': 'جيبوتي',
      'header.country.dk.45.name': 'الدنمارك',
      'header.country.dm.1.name': 'دومينيكا',
      'header.country.do.1.name': 'جمهورية الدومنيكان',
      'header.country.dz.213.name': 'الجزائر',
      'header.country.ec.593.name': 'الاكوادور',
      'header.country.ee.372.name': 'إستونيا',
      'header.country.eg.20.name': ' مصر',
      'header.country.er.291.name': 'إريتريا',
      'header.country.es.34.name': 'إسبانيا',
      'header.country.et.251.name': 'أثيوبيا',
      'header.country.fi.358.name': 'فنلندا',
      'header.country.fj.679.name': 'فيجي',
      'header.country.fk.500.name': 'جزر فوكلاند',
      'header.country.fm.691.name': 'ولايات ميكرونيزيا الموحدة',
      'header.country.fo.298.name': 'جزر فارو',
      'header.country.fr.33.name': 'فرنسا',
      'header.country.ga.241.name': 'الغابون',
      'header.country.gb.44.name': 'بريطانيا',
      'header.country.gd.1.name': 'غرينادا',
      'header.country.ge.995.name': 'جورجيا',
      'header.country.gf.594.name': 'غيانا الفرنسية',
      'header.country.gh.233.name': 'غانا',
      'header.country.gi.350.name': 'جبل طارق',
      'header.country.gl.299.name': 'جرينلاند',
      'header.country.gm.220.name': 'غامبيا',
      'header.country.gn.224.name': 'غينيا',
      'header.country.gp.450.name': 'غوادلوب',
      'header.country.gq.240.name': 'غينيا الإستوائية',
      'header.country.gr.30.name': 'اليونان',
      'header.country.gt.502.name': 'غواتيمالا',
      'header.country.gu.1.name': 'غوام',
      'header.country.gw.245.name': 'غينيا بيساو',
      'header.country.gy.592.name': 'غيانا',
      'header.country.hk.852.name': 'هونغ كونغ',
      'header.country.hn.504.name': 'هندوراس',
      'header.country.hr.385.name': 'كرواتيا',
      'header.country.ht.509.name': 'جمهورية هايتي',
      'header.country.hu.36.name': 'هنغاريا',
      'header.country.id.62.name': 'إندونيسيا',
      'header.country.ie.353.name': 'أيرلندا',
      'header.country.il.972.name': 'إسرائيل',
      'header.country.im.44.name': 'جزيرة مان',
      'header.country.is.354.name': 'أيسلندا',
      'header.country.in.91.name': 'الهند',
      'header.country.io.246.name': 'إقليم المحيط البريطاني الهندي',
      'header.country.iq.964.name': 'جمهورة العراق',
      'header.country.it.39.name': 'إيطاليا',
      'header.country.je.44.name': 'جيرسي',
      'header.country.jm.1.name': 'جامايكا',
      'header.country.jo.962.name': 'الأردن',
      'header.country.jp.81.name': 'اليابان',
      'header.country.ke.254.name': 'كينيا',
      'header.country.kg.996.name': 'قيرغيزستان',
      'header.country.kh.855.name': 'جمهورية كمبوديا',
      'header.country.ki.686.name': 'كيريباتي',
      'header.country.km.269.name': 'جزر القمر',
      'header.country.kn.1.name': 'سانت كيتس ونيفيس',
      'header.country.kr.82.name': 'كوريا الجنوبية',
      'header.country.kw.965.name': 'الكويت',
      'header.country.ky.1.name': 'جزر كايمان',
      'header.country.kz.7.name': 'كازاخستان',
      'header.country.la.856.name': 'جمهورية لاو الديمقراطية الشعبية',
      'header.country.lb.961.name': 'لبنان',
      'header.country.lc.1.name': 'سانت لوسيا',
      'header.country.li.423.name': 'ليختنشتاين',
      'header.country.lk.94.name': 'سيريلانكا',
      'header.country.lr.231.name': 'ليبيريا',
      'header.country.ls.266.name': 'ليسوتو',
      'header.country.lt.370.name': 'ليتوانيا',
      'header.country.lu.352.name': 'لوكسمبورغ',
      'header.country.lv.371.name': 'لاتفيا',
      'header.country.ly.218.name': 'ليبيا',
      'header.country.ma.212.name': 'المملكة المغربية',
      'header.country.mc.377.name': 'موناكو',
      'header.country.md.373.name': 'جمهورية مولدوفا',
      'header.country.me.382.name': 'الجبل الأسود',
      'header.country.mf.590.name': 'سانت مارتن',
      'header.country.mg.261.name': 'مدغشقر',
      'header.country.mh.692.name': 'جزر مارشال',
      'header.country.mk.389.name': 'جمهورية مقدونيا اليوغوسلافية السابقة',
      'header.country.ml.223.name': 'مالي',
      'header.country.mm.95.name': 'ميانمار',
      'header.country.mn.976.name': 'منغوليا',
      'header.country.mo.853.name': 'ماكاو',
      'header.country.mp.1.name': 'جزر مريانا الشمالية',
      'header.country.mq.596.name': 'مارتينيك',
      'header.country.mr.222.name': 'موريتانيا',
      'header.country.ms.1.name': 'مونتسرات',
      'header.country.mt.356.name': 'مالطا',
      'header.country.mu.230.name': 'موريشيوس',
      'header.country.mv.960.name': 'جزر المالديف',
      'header.country.mw.265.name': 'ملاوي',
      'header.country.mx.52.name': 'المكسيك',
      'header.country.my.60.name': 'ماليزيا',
      'header.country.mz.258.name': 'موزمبيق',
      'header.country.na.264.name': 'ناميبيا',
      'header.country.nc.687.name': 'كاليدونيا الجديدة',
      'header.country.ne.227.name': 'النيجر',
      'header.country.nf.672.name': 'جزر نورفولك',
      'header.country.ng.234.name': 'نيجيريا',
      'header.country.ni.505.name': 'نيكاراغوا',
      'header.country.nl.31.name': 'هولندا',
      'header.country.no.47.name': 'النرويج',
      'header.country.np.977.name': 'نيبال',
      'header.country.nr.674.name': 'ناورو',
      'header.country.nu.683.name': 'نيوي',
      'header.country.nz.64.name': 'نيوزيلندا',
      'header.country.om.968.name': 'سلطنة عمان',
      'header.country.pa.507.name': 'بنما',
      'header.country.pe.51.name': 'بيرو',
      'header.country.pf.689.name': 'بولينيزيا الفرنسية',
      'header.country.pg.675.name': 'بابوا غينيا الجديدة',
      'header.country.ph.63.name': 'الفلبين',
      'header.country.pk.92.name': 'جمهورية باكستان الإسلامية',
      'header.country.pl.48.name': 'بولندا',
      'header.country.pm.508.name': 'سان بيار وميكلون',
      'header.country.pn.870.name': 'جزر بيتكيرن',
      'header.country.pr.1.name': 'بورتوريكو',
      'header.country.ps.970.name': 'فلسطين',
      'header.country.pt.351.name': 'البرتغال',
      'header.country.pw.680.name': 'بالاو',
      'header.country.py.595.name': 'باراغواي',
      'header.country.qa.974.name': ' قطر',
      'header.country.re.262.name': 'جزر ريونيون',
      'header.country.ro.40.name': 'رومانيا',
      'header.country.rs.381.name': 'صربيا',
      'header.country.ru.7.name': 'روسيا',
      'header.country.rw.250.name': 'رواندا',
      'header.country.sa.966.name': 'المملكة العربية السعودية',
      'header.country.sb.677.name': 'جزر سليمان',
      'header.country.sc.248.name': 'سيشيل',
      'header.country.se.46.name': 'السويد',
      'header.country.sg.65.name': 'سنغافورة',
      'header.country.sh.290.name': 'سانت هيلانة ، وأسنشن وتريستان دا كونها',
      'header.country.si.386.name': 'سلوفينيا',
      'header.country.sk.421.name': 'سلوفاكيا',
      'header.country.sl.232.name': 'سيراليون',
      'header.country.sm.378.name': 'سان مارينو',
      'header.country.sn.221.name': 'السنغال',
      'header.country.so.252.name': 'الصومال',
      'header.country.sr.597.name': 'سورينام',
      'header.country.st.239.name': 'ساو تومي وبرينسيبي',
      'header.country.sv.503.name': 'جمهورية السلفادور',
      'header.country.sx.1.name': 'سينت مارتن',
      'header.country.sz.268.name': 'سويسرا',
      'header.country.tc.1.name': 'جزر تركس وكايكوس',
      'header.country.td.235.name': 'تشاد',
      'header.country.tg.228.name': 'توجو',
      'header.country.th.66.name': 'تايلاند',
      'header.country.tj.992.name': 'طاجيكستان',
      'header.country.tk.690.name': 'توكلو',
      'header.country.tl.670.name': 'تيمور الشرقية',
      'header.country.tm.993.name': 'تركمانستان',
      'header.country.tn.216.name': 'تونس',
      'header.country.to.676.name': 'تونغا',
      'header.country.tr.90.name': 'تركيا',
      'header.country.tt.1.name': 'ترينيداد وتوباغو',
      'header.country.tv.688.name': 'توفالو',
      'header.country.tw.886.name': 'تايوان',
      'header.country.tz.255.name': 'جمهورية تنزانيا المتحدة',
      'header.country.ug.256.name': 'أوغندا',
      'header.country.us.1.name': 'الولايات المتحدة الأمريكية',
      'header.country.uy.598.name': 'أوروغواي',
      'header.country.uz.998.name': 'أوزبكستان',
      'header.country.va.379.name': 'الكرسي الرسولي',
      'header.country.vc.1.name': 'سانت فنسنت وجزر غرينادين',
      'header.country.ve.58.name': ' جمهورية البوليفارية فنزويلا',
      'header.country.vg.1.name': 'جزر العذراء البريطانية',
      'header.country.vi.1.name': 'يو ايس ويرجين ايلاند',
      'header.country.vn.84.name': 'فييتنام',
      'header.country.vu.678.name': 'فانواتو',
      'header.country.wf.681.name': 'واليس وفوتونا',
      'header.country.ws.685.name': 'ساموا',
      'header.country.xk.383.name': 'كوسوفو',
      'header.country.ye.967.name': 'اليمن',
      'header.country.yt.262.name': 'مايوت',
      'header.country.za.27.name': 'جنوب أفريقيا',
      'header.country.zm.260.name': 'زامبيا',
      'header.country.zw.263.name': 'زيمبابوي',
      'header.TOP_COUNTRIES_LABEL': 'أهم الدول',
      'header.OTHER_COUNTRIES_LABEL': 'بلدان اخرى',
      'header.switch.to.english.text': 'التبديل إلى اللغة الإنجليزية',
      'header.hotels.message.for.arabic':
          'سيتوفر دعم تصفح الفنادق باللغة العربية قريبًا',
      'header.please.proceed.text': 'نعم، الرجاء المتابعة',
      'header.cancel.text': 'إلغاء',
      'header.not.supporting.arabic':
          'سيتوفر دعم تصفح الفنادق باللغة العربية قريبًا. سنقوم بتحويلك إلى موقع الويب باللغة الإنجليزية',
      'header.ENGLISH': 'الإنجليزية',
      'header.ARABIC': 'العربية',
      'header.cancel.capitalised.text': 'إلغاء',
      'header.country.dropdown': {
        IN: 'الهند',
        AE: 'الإمارات العربية المتحدة',
        US: 'الولايات المتحدة الأمريكية',
        KW: 'الكويت',
        SA: 'المملكة العربية السعودية',
        OM: 'سلطنة عمان',
      },
      'header.currency.text': 'عملة',
      'header.country.text': 'بلد',
      'header.language.text': 'لغة',
      'header.available.in.arabic.text':
          "متوفر الآن باللغة <span class='latoBold'>العربية</span>",
      'header.coming.soon.text': 'سيأتي قريباً',
      'header.select.currency.text': 'اختر العملة',
      'header.select.language.text': 'اختار اللغة',
      'header.select.country.text': 'اختر الدولة',
      'header.apply.text': 'تطبيق',
      'header.manage.your.bookings.text': 'إدارة حجوزاتك',
    },
    FLIGHTS_UI_MESSAGES: {
      searchWidget: {
        tripType: {
          inputLabel: 'نوع الرحلة',
          options: {
            O: 'اتجاه واحد',
            R: 'رحلة الذهاب والعودة',
            M: 'مدن متعددة',
          },
        },
        src: {
          inputLabel: 'من ',
          placeholder: 'أدخل اسم المدينة',
        },
        dest: {
          inputLabel: 'إلى',
          placeholder: 'أدخل اسم المدينة',
        },
        departure: {
          inputLabel: 'المغادرة',
        },
        return: {
          inputLabel: 'العودة',
          placeholder: 'حدد العودة',
        },
        pnc: {
          inputLabel: 'المسافرون ودرجة السفر',
          inputValues: {
            Adults: 'بالغين',
            Travellers: 'المسافرون',
            Adult: 'البالغون',
            Traveller: 'مسافر',
            'Group Booking': 'حجز المجموعة',
          },
          options: {
            adults: {
              inputLabel: 'البالغون (سنة 12+)',
              groupBookingTooltip: 'وفّر جراء الحجوزات لأكثر من 9 مسافرين',
              ontheDayTravelText: ' يوم السفر',
            },
            children: {
              inputLabel: 'الأطفال (2 سنة - 12 سنة)',
              ontheDayTravelText: ' يوم السفر',
            },
            infants: {
              inputLabel: 'الرضع (أقل من عامين)',
              ontheDayTravelText: ' يوم السفر',
            },
            travelClass: {
              inputLabel: 'اختر درجة السفر',
              optionsLabels: {
                Economy: 'سياحية',
                'Economy / Premium Economy': 'سياحية/ سياحية مميزة',
                'Premium Economy': 'سياحية مميزة',
                Business: 'درجة الأعمال',
                'First Class': 'الدرجة الأولى',
              },
            },
          },
          btnLabel: 'تمام',
        },
        ctaButtonText: 'بحث',
        tripPrefix: 'رحلة ',
        addCityBtnText: '+ اضافة مدينة',
        'SEARCH RESULTS': 'نتائج البحث',
        'NEARBY CITIES': 'المدن القريبة',
        errMessages: {
          guestCount: 'لا يمكن أن يتجاوز إجمالي عدد الضيوف على 9',
          infantCount: 'لا يمكن أن يتجاوز عدد الرضع عدد البالغين',
          returnDate: 'الرجاء تحديد تاريخ العودة',
        },
      },
      searchLoadingMessage: 'انتظر من فضلك، نجلب لكم الرحلات',
      defaultErrorMessages: {
        NWE: {
          title: 'مشكلة شبكة',
          subtitle:
              'لا يمكننا الاتصال بأنظمتنا من جهازك. يرجى المحاولة مرة أخرى لاحقاً',
        },
        STREMPTY: {
          title: 'تبا شيء ما حدث بشكل خاطئ!',
          subtitle:
              'نحن غير قادرين على الاتصال بأنظمتنا. يرجى تحديث الصفحة أو المحاولة مرة أخرى بعد فترة',
        },
        JSE: {
          title: 'استثناء برنامج العميل',
          subtitle: 'سنحل هذا في أسرع وقت ممكن. يرجى المحاولة مرة أخرى لاحقاً.',
        },
        DEFAULT: {
          title: 'آسف! كانت هناك مشكلة في تحميل الصفحة',
          subtitle:
              'يبدو أن أنظمتنا واجهت مشكلة. نحن نعمل على حلها في أسرع وقت ممكن. يرجى تحديث الصفحة أو العودة إلى الصفحة السابقة',
        },
        rightCtaText: 'تحديث',
      },
      flightDetails: {
        title: 'تفاصيل الرحلة',
        hideDtls: 'إخفاء تفاصيل الرحلة',
        viewDtls: 'عرض تفاصيل الرحلة',
        baggageLabel: 'الأمتعة :',
        checkinLabel: 'تسجيل الدخول',
        cabinLabel: 'الأمتعة اليدوية',
        tabs: {
          'FLIGHT DETAILS': 'تفاصيل الرحلة',
          'FARE SUMMARY': 'ملخص الأسعار',
          CANCELLATION: 'إلغاء',
          'DATE CHANGE': 'تغيير التاريخ',
        },
        loaderText: 'يتم إحضار التفاصيل ...',
        hideShowBtn: 'شاهد',
        notAvlText: 'المعلومات غير متوفرة',
        exitText: 'مخرج',
      },
      flightsListing: {
        sorterTitle: 'مرتبة حسب:',
        bookNowCTAText: 'احجز الآن',
        multiFareHidePricesText: 'إخفاء الأسعار',
        plusDayTemplate: '+ {{count}} يوم',
        loadersText: {
          selectingFlight: 'يتم تحديد رحلتك ...',
          moreFaresSplit: 'الحصول على المزيد من الأسعار لك ...',
          moreFares: 'يتم الحصول على المزيد من الأسعار ...',
          gettingFlights: 'انتظر، نبحث عن الرحلات ..',
          submitting: 'تقديم...',
        },
        splitFooter: {
          fareDetailsText: 'تفاصيل السعر',
        },
        mcTripTxt: 'الرحلة {{index}}',
        otherFlightsHeading: 'رحلات أخرى',
        selectFareText: 'حدد الأسعار',
        discountsTitle: {
          boldText: 'الصفقات',
          normalText: 'الصفقات',
        },
        hideShowTimingsOptions: {
          more: 'المزيد من خيارات التوقيت',
          less: 'خيارات توقيت أقل',
        },
      },
      flightsFilters: {
        FILTERED_OUT_TEXT: {
          TITLE: 'تم تطبيق عدد كبير من المرشحات!',
          DESC: 'لم نتمكن من العثور على أي رحلات جوية توافق جميع المرشحات التي حددتها. حاول إزالة بعض المرشحات',
          OrText: 'أو',
        },
        clearAllFiltersText: 'امسح جميع المرشحات',
        appliedFiltersText: 'المرشحات المطبقة',
        clearAppliedFiltersText: 'امسح الكل',
        loadersText: {
          'Popular filters': 'المرشحات الشائعة',
          Price: 'الأسعار',
          Departure: 'المغادرة',
          Airlines: 'الخطوط الجوية',
          Arrival: 'الوصول',
        },
      },
      flightsFiltersOld: {
        moreFiltersText: 'المزيد من المرشحات',
        resetBtnText: 'إعادة تعيين',
        applyBtnText: 'تطبيق',
        cancelBtnText: 'إلغاء',
        moreAirlinesText: '+ {{count}} خطوط جوية',
        FILTERED_OUT_TEXT: {
          TITLE: 'تم تطبيق عدد كبير من المرشحات!',
          DESC: 'جرّب مجموعة مختلفة من المرشحات.',
        },
        clearAllFiltersText: 'امسح كافة المرشحات',
        mcFiltersTitle: 'المرشحات:',
      },
      reviewOnwardHeader: {
        pageNames: {
          'Review your booking': 'مراجعة حجزك',
          'Traveller & Addons': 'المسافر والملحقون',
          'Booking Summary': 'ملخص الحجز',
        },
        timelineSteps: {
          flight: 'الرحلة المختارة',
          review: 'مراجعة',
          traveller: 'تفاصيل المسافر',
          itinerary: 'ملخص الحجز',
          pay: 'ادفع ',
        },
      },
      itineraryTitle: 'التذكرة',
      flightSummaryTitle: 'ملخص الرحلة',
      fareSummaryTitle: 'ملخص الأسعار',
      reviewLoaderTexts: {
        itLoaderText: 'يتم إحضار التفاصيل ...',
        fareDetailsLoaderText: 'يتم إحضار تفاصيل الأسعار...',
        submitReviewLoaderText: 'تقديم المراجعة',
        submitTravellerLoaderText: 'تقديم بيانات المسافر',
        layoverInfoLoaderText: 'إحضار معلومات عن محطات التوقف.....',
        headingLoaderText: '51 مليون مستخدم والعدد في ازدياد',
      },
      review: {
        continueCTA: 'متابعة',
        outOfPolicyTooltip: {
          title: 'مهم',
        },
      },
      fareRules: {
        title: 'قوانين السعر',
        loaderText: 'إحضار قواعد السعر',
        noDataText: 'المعلومات غير متوفرة',
        tabs: {
          'Cancellation Charges': 'رسوم الإلغاء',
          'Date change charges': 'رسوم تغيير التاريخ',
        },
      },
      fastForward: {
        ctaText: 'تمام',
        selectedTemplate: 'تم اختيار {{fraction}} ',
      },
      impInfo: {
        title: 'معلومات مهمة',
      },
      addOnsHeading: 'الإضافات',
      coupons: {
        inputPlaceholder: 'أدخل رمز القسيمة',
        applyBtnText: 'تطبيق',
        removeBtnText: 'إزالة',
        'VIEW ALL OFFERS': 'شاهد جميع العروض',
        'SHOW LESS': 'عرض أقل',
        OR: 'أو',
        toastLinkText: 'حسناً حصلت عليه!',
      },
      travellerForm: {
        tags: {
          COMPLETE: 'أكمل',
          INCOMPLETE: 'غير مكتمل',
        },
        travellerTypes: {
          ADULT: 'البالغون',
          CHILD: 'طفل',
          INFANT: 'رضيع',
        },
        selectedTemplate: 'تم تحديد {{ratio}}',
        nameConfirmation: {
          title: 'تأكيد الاسم',
          fnLabel: 'الاسم الاول:',
          lnLabel: 'اسم العائلة:',
          closeBtnText: 'تمام',
        },
        dateDropdownPlaceholders: {
          date: 'تاريخ',
          month: 'شهر',
          year: 'عام',
        },
        loaderText: {
          submitting: 'تقديم...',
          selecting: 'يتم تحديد ...',
        },
        errMessage:
            'لقد قمت بالفعل بتحديد {{criteria}}. قم بالإزالة قبل إضافة واحدة جديدة.',
      },
      flightDetailsText: 'تفاصيل الرحلة',
      insurance: {
        editBtnText: 'تعديل',
        showMoreText: 'المزيد',
        showLessText: 'عرض أقل',
        daysInputPlaceholder: 'أدخل عدد الأيام',
        daysDoneCtaText: 'تمام',
        toastLinkText: 'حسناً حصلت عليه!',
        benefitPrefix: 'مطالبة تصل الى',
      },
      acknowledgement: {
        title: 'الموافقة',
        ctaBtnText: {
          createQuote: 'إنشاء اقتراح',
          continue: 'متابعة',
        },
      },
      ancillaries: {
        loaderText: {
          fetching: 'في انتظار المعلومات الإضافية ',
          updating: 'تحديث برامج المساعدة المختارة',
          submit: 'تقديم تفاصيل المرافق',
        },
        SKIP_TO_PAYMENT: 'تخطي إلى عملية الدفع',
        SKIP_ADD_ONS: 'تخطي الإضافات',
        tabs: {
          Meals: 'وجبات',
          Seats: 'مقاعد',
          Baggage: 'الأمتعة',
        },
        addMealBtnText: 'أضف',
        flightSummaryText: 'ملخص الرحلة',
        continueBtnLabel: {
          next: 'التالى',
          continue: 'متابعة',
          nextSeats: 'التالي: المقاعد',
          newFlowPreAttach: 'تأكيد المقعد (المقاعد)',
        },
        totalFareText: 'مجموع الأسعار',
        clearSelectionOverlay: {
          title: 'هل أنت متأكد؟',
          subTitle:
              'بالضغط على "موافق" ، سيتم تجاهل جميع اختياراتك من المقاعد والوجبات والأمتعة الإضافية.',
          rcaText: 'حسناً',
          lcaText: 'إلغاء',
        },
        tooltip: {
          seatTaken: 'عذراً، هذا المقعد محجوز أصلاً',
        },
      },
      thankyou: {
        loaderText: 'نجلب تفاصيل الشكر',
        hotelCrossSellTitle: 'احجز فندقك الآن',
        hotelOffPercent: 'خصم  {{offPercent}} %',
        refundBreakupText: 'تفاصيل المبلغ المسترد',
        fallBack: {
          title: 'حجزك على قيد التقدم!',
          msg1: 'نأسف، لقد يستغرق الأمر وقتًا أطول من المعتاد ولكن لا تقلق ، لقد تلقينا المبلغ وبالتالي حجزك تحت الإجراء.',
          msg2: 'سنقوم بإخطارك عقب تأكيد ذلك. يمكنك أيضًا تتبع الحالة عبر إدارة الحجز.',
          ctaText: 'إدارة الحجز',
        },
      },
      utils: {
        MONTHS: [
          'يناير',
          'فبراير',
          'مارس',
          'أبريل',
          'مايو',
          'يونيو',
          'يوليو',
          'أغسطس',
          'سبتمبر',
          'أكتوبر',
          'نوفمبر',
          'ديسمبر',
        ],
        DAYS: [
          'الإثنين',
          'الثلاثاء',
          'الأربعاء',
          'الخميس',
          'الجمعة',
          'السبت',
          'الاحد',
        ],
        TIME: {
          hoursShort: 'ساعة',
          minutesShort: 'شهر',
        },
        genericInputMessage: 'يرجى الكتابة باللغة الإنجليزية',
      },
      loginPopup: {
        b2b: {
          title: 'مبارك عليك! لقد قمت بتسجيل الدخول إلى ماي بيز.',
          subtitle:
              'استمتع بمجموعة من الأسعار ووسائل الراحة المجانية * ومزايا ضريبة السلع والخدمات وغير ذلك الكثير على رحلات ماي بيز',
          leftCtaText: 'حسناً',
        },
        ctaFlow: {
          title: 'تهانينا! لقد قمت بتسجيل الدخول كشريك تابع.',
          subtitle: 'يتم إعادة توجيهك إلى الصفحة الرئيسية',
          leftCtaText: 'حسناً',
        },
      },
      logoutPopup: {
        b2b: {
          title: 'لقد سجلت خروجك!',
          subtitle: 'نوجه بك إلى الصفحة الرئيسية، يرجى البحث مرة أخرى.',
          leftCtaText: 'حسناً، فهمت',
        },
        normalFlow: {
          title: 'لقد قمت بتسجيل الخروج بنجاح',
          subtitle:
              'نظرًا لأنك قمت بتسجيل الخروج ، فقد يتغير السعر الإجمالي على صفحة الدفع. هذا بسبب ريفاد بونوس أو أي عرض آخر ربما تم تطبيقه والذي كان ساريًا فقط على حسابك الذي قمت بتسجيل الدخول إليه.',
          leftCtaText: 'حسناً، فهمت',
        },
      },
      reviewDetails: {
        addBaggagePopup: {
          addText: 'أضف',
          footer: {
            addedPriceText: '(يضاف إلى إجمالي المبلغ)',
            ctaText: 'تمام',
          },
        },
      },
    },
    IF_DESTINATION_PICKER: {
      searchField: {
        tripType: 'نوع الرحلة',
        from: 'من ',
        to: 'إلى',
        dateDuration: 'التواريخ والمدة',
        departure: 'المغادرة',
        search: 'بحث',
      },
      loaderTexts: {
        fareCalendarLoaderText: 'نجلب لك الرحلات بأفضل الأسعار',
        flightSearchLoaderText: 'نجلب لك الرحلات بأفضل الأسعار',
        mapLoaderText: 'وجهات التحميل',
        listingLoaderHeader: 'وجهات التحميل',
        sortText: 'مرتبة حسب:',
        sortValue: 'الأسعار',
        filtersLoaderText: {
          'Visa & Documents': 'التأشيرة والوثائق',
          'Flight Duration': 'مدة السفر',
          Price: 'الأسعار',
          'COVID Restrictions': 'قيود تتعلق بكوفيد',
          Stops: 'محطات التوقف',
          'Popular Filters': 'مرشحات شائعة',
        },
      },
    },
  },
  eng: {
    header: {
      'header.mmt.text': 'MMT',
      'header.black.text': 'Black',
      'header.loyalty.programme': 'Loyalty Programme',
      'header.double.black.text': 'DOUBLEBLACK',
      'header.free.cancellation.assured': 'Free Cancellation Assured',
      'header.biz.pending': 'Pending',
      'header.biz.requests': 'Requests',
      'header.my.trips': 'My Trips',
      'header.24x7': '24x7',
      'header.support': 'Support',
      'header.helplines.active.text': 'Our helplines are active 24x7',
      'header.introducing.myBiz': 'Introducing myBiz',
      'header.mmt.for.business': 'MakeMyTrip for Business',
      'header.welcome.message': 'Hey {firstName}',
      'header.login.or.create.account': 'Login or Create Account',
      'header.personal.text': 'PERSONAL',
      'header.myBiz.text': 'MYBIZ',
      'header.free.upgrade': 'Free Upgrade to',
      'header.out.corporate.account': 'Our Corporate Account',
      'header.corporate.fares': 'Corporate Fares',
      'header.with.easy.modifications': 'with Easy Modifications',
      'header.curated.hotels': 'Curated Hotels',
      'header.safety.text': 'for Safe & Hygienic Stays',
      'header.gst.invoice': 'GST Invoice',
      'header.assurance': 'Assurance',
      'header.signup.work.mail': 'Signup now for free !',
      'header.know.more': 'Know more',
      'header.about.myBiz': 'about myBiz.',
      'header.personal.profile.text':
          'You are viewing your personal profile {email}',
      'header.myBiz.profile.text': 'You are viewing your MyBiz profile {email}',
      'header.my.trips.subtitle':
          'See booking details, Print e-ticket, Cancel Booking, Modify Booking, Check Refund Status & more.',
      'header.my.wallet': 'My Wallet',
      'header.my.wallet.subtitle':
          'Use your wallet money to avail even greater discounts',
      'header.my.mmt.black': 'MMT Black',
      'header.my.mmt.black.subtitle':
          'View your spend journey, milestones and claim rewards!',
      'header.my.mmt.double.black': 'MMT Double Black',
      'header.my.mmt.double.black.inactive':
          'Buy now to get hassle free cancellations on your flight and hotel bookings',
      'header.my.mmt.double.black.active': 'View your MMTDoubleBlack benefits',
      'header.my.mmt.double.black.expired':
          'Your membership has expired, renew to continue enjoying benefits from MMTDoubleBlack',
      'header.my.profile': 'My Profile',
      'header.my.profile.subtitle':
          'Manage your profile, traveller details, login details and  password',
      'header.my.make.payment': 'Make a payment',
      'header.my.make.payment.subtitle': 'Complete your pending payments here',
      'header.logout.text': 'Logout',
      'header.login.signup.for.best.prices': 'Login/Signup for Best Prices',
      'header.login.signup.text.cash':
          'Login/Signup to earn {currency}555 instantly',
      'header.login.signup.easily.with': 'LOGIN/ SIGNUP EASILY WITH',
      'header.login.with.phone.email': 'Login with Phone/Email',
      'header.welcome.text': 'Hey',
      'header.traveller.text': 'Traveller',
      'header.login.success.message':
          'Login Success! Mobile number could not be linked',
      'header.myBiz.login.message':
          'We do not support login via mobile number for myBiz accounts yet. You can continue accessing your account using your email and password.',
      'header.mobile.number.linked.message':
          'This account already has a mobile number linked with this, please visit the profile section to unlink the linked phone number first and try again.',
      'header.move.back.text': 'Back',
      'header.skip.text': 'Skip',
      'header.login.with.password': 'Login With Password',
      'header.login.signup.text': 'Login/Signup',
      'header.email.placeholder.text': 'Enter email',
      'header.for.account.text': 'For account {username}',
      'header.email.or.mobile.placeholder.text': 'Enter email or mobile number',
      'header.email.label.text': 'Email',
      'header.email.or.mobile.label.text': 'Email or Mobile Number',
      'header.continue.text': 'Continue',
      'header.login.with.text': 'OR LOGIN WITH',
      'header.company.login.portal.text': 'COMPANY LOGIN PORTAL',
      'header.login.to.myBiz.account':
          'You can use your company credentials to login to your myBiz account.',
      'header.login.text': 'Login',
      'header.login.via.otp': 'or Login via OTP',
      'header.otp.on.mail.message': 'You will receive the OTP on e-mail',
      'header.login.signup.with.text': 'Or Login/Signup With',
      'header.no.myBiz.account.message': 'Dont have a myBiz account?',
      'header.create.account.here.message': 'Create an account here',
      'header.saving.on.business.travel.message':
          '& start saving on your business travel',
      'header.personal.account.text': 'Personal Account',
      'header.myBiz.account.text': 'MyBiz Account',
      'header.reset.password.text': 'Reset Password',
      'header.mobile.not.registered.text': 'It seems that the mobile number',
      'header.mobile.not.registered.action.text':
          'is not registered with MakeMyTrip, what would you like to do next?',
      'header.create.personal.account.message':
          'Create a New Personal Account with this mobile number',
      'header.link.existing.account': 'Link with an existing account',
      'header.link.user.to.existing.account':
          'Link {displayUserName} with an existing account',
      'header.dismiss.text': 'Dismiss',
      'header.account.already.exists.message':
          'A {accountType} account already exists',
      'header.registered.account.action.message':
          'It seems you are trying to login with an already registered {accountType} account with Email ID: {username}, what would you like to do next?',
      'header.login.with.email': 'Login to {accountType} with this Email ID',
      'header.create.new.account':
          'Create a New {accountType} Account with {username}',
      'header.get.otp.for.mobile.login': 'Get OTP to login with mobile number',
      'header.access.myBiz.account': 'Access myBiz with company login',
      'header.company.registered.myBiz.account':
          'We see your company has already registered a myBiz account for you with personal Email ID:{username}, what would you like to do next?',
      'header.login.myBiz.with.company.portal':
          'Login to myBiz with Company Login Portal',
      'header.password.placeholder.text': 'Minimum 6 characters.',
      'header.password.text': 'Password',
      'header.remember.me.text': 'Remember Me',
      'header.agent.id.text': 'Agent Id',
      'header.enter.mobile.number.text': 'Enter Mobile Number',
      'header.send.otp.text': 'Send OTP',
      'header.verify.mobile.number.title': 'Verify Mobile Number',
      'header.verify.mobile.number.subtitle':
          'To continue, please verify your Mobile Number',
      'header.and.word.text': 'and',
      'header.or.use.text': 'OR USE',
      'header.create.account.with': 'or create account with',
      'header.resend.otp.text': 'Resend OTP',
      'header.verify.text': 'Verify',
      'header.otp.text': 'OTP',
      'header.enter.otp.sent.to.text': 'Please enter the OTP sent to',
      'header.add.mobile.number.text': 'to add your Mobile Number.',
      'header.enter.myBiz.account.password': 'Enter myBiz Account Password',
      'header.create.account.text': 'Create Account',
      'header.signup.agree.text': 'By signing up, you agree to the',
      'header.terms.and.conditions.text': 'Terms and Conditions',
      'header.email.or.phone.placeholder': 'Enter email or phone no.',
      'header.password.same.message':
          "Your Personal account password will be same as MyBiz account <span class='latoBold'> (abhinav.mittal@go-mmt.com) </span> password",
      'header.create.personal.account.text': 'Create New Personal Account',
      'header.enter.username.for.linking.mobile':
          'Enter username of the account you want your mobile number {displayUserName} to be linked with.',
      'header.continue.text.capitalized': 'CONTINUE',
      'header.login.via.password.text': 'or Login via Password',
      'header.verify.emailId.message': 'Verify Your E-mail ID',
      'header.verify.mobile.message': 'Verify Your Mobile Number',
      'header.enter.otp.on.email.text':
          'Please enter the OTP sent to {username} or your registered e-mail ID to login',
      'header.enter.otp.on.mobile.text':
          'Please enter the OTP sent to {username} or your registered mobile number to login',
      'header.enter.otp.sent.to.username.text':
          'Please enter the OTP sent to {username} to login',
      'header.login.to.your.account.text': 'to login to your account.',
      'header.reset.the.password.text': 'to reset the password.',
      'header.to.continue.text': 'to continue.',
      'header.send.reset.otp.on.email.mobile':
          'We will send you a reset OTP on your registered E-mail ID or Mobile Number',
      'header.send.reset.otp.on.email':
          'We will send you a reset OTP on your registered E-mail ID',
      'header.register.email.or.mobile.text':
          'Registered Email or Mobile Number',
      'header.register.email.text': 'Registered Email',
      'header.username.not.exist.message': 'This username does not exist.',
      'header.trying.to.create.new.account':
          'If your are trying to create a new ${accountType} account',
      'header.google.business.account.text': 'Google Business Account',
      'header.new.password.text': 'New Password',
      'header.create.new.password.text': 'Create New Password',
      'header.new.password.validations.text':
          'Must be atleast 8 characters in length and should contain at least one alphabet, one number and one special character @$!%*#?&',
      'header.redirect.to.login.text': 'Go To Login',
      'header.password.changed.successfully.message':
          'Password Changed Successfully',
      'header.do.not.share.password.message':
          'To prevent misuse, don’t share your password with anyone.',
      'header.login.successful.message': 'Login Successful',
      'header.A.letter.text': 'A',
      'header.successful.logged.in.message':
          'You have successfully logged in your account',
      'header.account.creation.unsuccessful': 'Account Creation Unsuccessful',
      'header.account.creation.unsuccessful.message':
          'We were unable to create your account as the mobile number verification was unsuccessful.',
      'header.continue.creating.account': 'CONTINUE CREATING ACCOUNT HERE',
      'header.reset.your.password.text': 'to reset your passsword',
      'header.enter.otp.sent.text': 'Enter the OTP sent to',
      'header.verify.and.link.account':
          'to verify and link the same to account',
      'header.enter.otp.placeholder': 'Enter OTP',
      'header.create.next.account.text': 'Create New Account',
      'header.already.a.member.text': 'Already a member?',
      'header.verify.number.and.create.account':
          'Verify Number & Create Account',
      'header.login.myBiz.with.email': 'Login to myBiz with this Email ID',
      'header.already.registered.email.message':
          'It seems you are trying to signup with an already registered myBiz account with Email ID: {username}, what would you like to do next?',
      'header.myBiz.account.exists': 'A myBiz account already exists',
      'header.congratulations.message': 'Congratulations!',
      'header.account.created.successfully': 'Account created successfully',
      'header.save.and.continue.text': 'Save and Continue',
      'header.save.and.verify.mobile.text': 'Save and Verify Mobile Number',
      'header.account.created.successfully.message':
          'Congrats! Your account is created successfully! You can start booking now to get best prices.',
      'header.unlocked.bonus.reward.message':
          'Congrats! You have successfully unlocked a bonus reward of',
      'header.wallet.money.rewarded': '555 wallet money',
      'header.verify.and.create.account': 'Verify & Create Account',
      'header.verify.and.link.account.text': 'Verify & Link Account',
      'header.incorrect.otp.entered.text':
          'Incorrect OTP Entered. Please try again.',
      'header.enter.otp.label': 'Enter OTP',
      'header.enter.otp.here.placeholder': 'Enter OTP here',
      'header.numeric.validation': 'Must be a number',
      'header.min.characters.validation': 'Must be {min} characters or more',
      'header.max.characters.validation': 'Must be {max} characters or less',
      'header.min.value.validation': 'Must be at least {min}',
      'header.email.format.message':
          "Email ID should be in 'abc@xyz.com' format",
      'header.aol.email.message': 'Really? You still use AOL for your email?',
      'header.alphanumeric.validation': 'Only alphanumeric characters',
      'header.mobile.number.validation':
          'Invalid phone number, must be 10 digits',
      'header.required.validation': 'Required',
      'header.privacy.policy.text': 'Privacy Policy',
      'header.user.agreement.text': 'User Agreement',
      'header.terms.of.service.text': 'Terms of Service',
      'header.invalid.phone.number': 'Invalid phone number',
      'header.your.username.message': 'This will be your username',
      'header.otp.verification.completed':
          '<b> OTP verification </b> is done when account is created using mobile number',
      'header.click.here.text': 'CLICK HERE',
      'header.attempting.login.text': 'If you are trying to login.',
      'header.enter.password.placeholder': 'Enter password',
      'header.enter.work.email': 'Enter your work email id',
      'header.agreement.text.on.mmt':
          "By proceeding, you agree to MakeMyTrip's",
      'header.policy.text': 'Privacy',
      'header.login.expired': 'Login Expired',
      'header.click.to.login.again':
          "No need to worry! We regularly logout users to better safeguard their account. Just <a className='latoBold'>click here to login again</a>  &amp; enjoy the MMT experience.",
      'header.signup.with.facebook': 'Sign up with Facebook',
      'header.login.with.facebook': 'Login with Facebook',
      'header.signup.with.google': 'Sign up with Google',
      'header.login.with.google': 'Login with Google',
      'header.login.or.signup.message': 'Login/Sign up',
      'header.work.email.text': 'Work Email',
      'header.verification.successful.text': 'Verification Successful',
      'header.mobile.number.verified.message':
          'Congrats! Your mobile number {username} is successfully verified and has been linked to the account {emailId}',
      'header.cruise': 'Cruise',
      'header.new.text': 'NEW',
      'header.admin.text': 'Admin',
      'header.ACTIVITIES': 'Activities',
      'header.NEARBY_GETAWAYS': 'Nearby Getaways',
      'header.TRIP_MONEY': 'Trip Money',
      'header.FLIGHTS': 'Flights',
      'header.CHARTER_FLIGHTS': 'Charter Flights',
      'header.HOTELS_APTS': 'Hotels & Apts',
      'header.CHARTER_FLIGHTS_CLASS': 'CharterFlights',
      'header.HOTELS': 'Hotels',
      'header.HOLIDAYS': 'Holidays',
      'header.HOLIDAY_PACKAGES': 'Holiday Packages',
      'header.BUSES': 'Buses',
      'header.CABS': 'Cabs',
      'header.BIZ_CABS': 'Airport Cabs',
      'header.TRAINS': 'Trains',
      'header.GIFTCARDS': 'Giftcards',
      'header.MORE': 'More',
      'header.LOGIN_AGENT': 'Agent Login',
      'header.MMT_LOGO_ALT': "MMT's LOGO",
      'header.ACTIVE': 'active',
      'header.IN_YOUR_WALLET': 'in your wallet',
      'header.YOUR_WALLET': 'Your Wallet',
      'header.LOGIN_OR': 'Login or',
      'header.CREATE_ACCOUNT_TEXT': 'Create Account',
      'header.MY_BIZ': 'My Biz',
      'header.INT_FLIGHT': 'International Flights',
      'header.INT_HOTEL': 'International Hotels',
      'header.REFER_EARN': 'Refer & Earn',
      'header.BLOG': 'Blog',
      'header.Deals': 'Deals',
      'header.VENUES': 'Venues',
      'header.ADMIN_SITE': 'Admin',
      'header.HOME_STAYS': 'Villas & Apts',
      'header.HOME_STAYS_CLASS': 'Homestays',
      'header.VISA': 'Visa',
      'header.MICE': 'MICE',
      'header.TRIP_IDEAS': 'Trip Ideas',
      'header.LOGIN_ENTER_VALID_EMAIL_ERROR_MESSAGE':
          'Please enter a valid Email Id or Mobile Number.',
      'header.LOGIN_ENTER_VALID_AGENT_ERROR_MESSAGE':
          'Please enter a valid Agent Id.',
      'header.LOGIN_ENTER_VALID_ONLY_EMAIL_ERROR_MESSAGE':
          'Please enter a valid Email.',
      'header.LOGIN_ENTER_PASSWORD_ERROR_MESSAGE': 'Please enter password.',
      'header.LOGIN_ENTER_VALID_PASSWORD_ERROR_MESSAGE':
          'Password cannot be less than 6 characters.',
      'header.LOGIN_ENTER_VALID_OTP_ERROR_MESSAGE': 'Please enter valid OTP',
      'header.SIGNUP_ENTER_VALID_CHARACTER_PASSWORD_ERROR_MESSAGE':
          'The password must have atleast 8 characters & should contain at least one alphabet, one number and one special character @$!%*#?&',
      'header.OTP_LOGIN_VALID_OTP_ERROR':
          'Incorrect OTP! Please enter the OTP delivered to you.',
      'header.LOGIN_ACCOUNT_BLOCKED_ERROR_MESSAGE':
          'You have crossed the maximum limit of login attempts. Please try again after ',
      'header.LOGIN_INCORRECT_EMAIL_PASSWORD_ERROR_MESSAGE':
          'Either Username or Password is incorrect.',
      'header.LOGIN_DEFAULT_ERROR_MESSAGE':
          'Looks like we are facing some technical issues, please try again in some time.',
      'header.FORGOT_PASSWORD_USER_NOT_EXISTS_ERROR_MESSAGE':
          "Username doesn't exist, Please enter a valid Email Id or Mobile Number",
      'header.FORGOT_PASSWORD_DEFAULT_ERROR_MESSAGE':
          'Something went wrong, Please try again.',
      'header.VERIFY_OTP_LIMIT_CROSSED_ERROR_MESSAGE':
          'You have crossed the maximum limit for send OTP attempts. Please try again after ',
      'header.VERIFY_OTP_INCORRECT_OTP_ERROR_MESSAGE':
          'Incorrect OTP, Please try again',
      'header.FORGOT_PASSWORD_OTP_INVALID_TOKEN_ERROR_MESSAGE':
          'Incorrect OTP, Please try again',
      'header.FORGOT_PASSWORD_OTP_DEFAULT_ERROR_MESSAGE':
          'Something went wrong, Please try again.',
      'header.FORGOT_PASSWORD_OTP_INCORRECT_OTP_ERROR_MESSAGE':
          'Incorrect OTP, Please try again',
      'header.LOGIN_CREDENTIALS_EXPIRED_ERROR_MESSAGE':
          'Your password has expired. Please click on Reset Password to reset your password.',
      'header.PLACEHOLDER_COUNTRY_CODE': 'Country Name or Code',
      'header.NOT_VALID_USER':
          'There is no personal account associated with this email ID',
      'header.ACCOUNT_ALREADY_LINKED':
          'This account already has a phone number associated',
      'header.PROCEED_TO_LOGIN_MSG':
          "By proceeding, you agree to MakeMyTrip's ",
      'header.TOS_MSG': 'T&Cs',
      'header.PRIVACY_POLICY_MSG': 'Privacy Policy',
      'header.USER_AGREEMENT_MSG': 'User Agreement',
      'header.PHONE_NUMBER_ALREADY_LINKED':
          'Phone number is associated with another account.',
      'header.GOOGLE_ERROR': 'Google Login Failed',
      'header.FB_ERROR': 'Facebook Login Failed',
      'header.NO_MATCH_FOUND': 'No match found',
      'header.facebook.text': 'Facebook',
      'header.google.text': 'Google',
      'header.enter.fullname.text': 'Enter full name',
      'header.enter.valid.name.message': 'Please enter a valid name',
      'header.incorrect.format.message': 'Incorrect Format',
      'header.invalid.phone.number.message': 'Invalid phone number',
      'header.enter.full.name.placeholder': 'Enter Your Full Name',
      'header.country.ad.376.name': 'Andorra',
      'header.country.ae.971.name': 'United Arab Emirates',
      'header.country.af.93.name': 'Afghanistan',
      'header.country.ag.1.name': 'Antigua and Barbuda',
      'header.country.ai.1.name': 'Anguilla',
      'header.country.al.355.name': 'Albania',
      'header.country.am.374.name': 'Armenia',
      'header.country.ao.244.name': 'Angola',
      'header.country.aq.672.name': 'Antarctica',
      'header.country.ar.54.name': 'Argentina',
      'header.country.as.1.name': 'American Samoa',
      'header.country.at.43.name': 'Austria',
      'header.country.au.61.name': 'Australia',
      'header.country.aw.297.name': 'Aruba',
      'header.country.az.358.name': 'Aland Islands',
      'header.country.az.994.name': 'Azerbaijan',
      'header.country.ba.387.name': 'Bosnia And Herzegovina',
      'header.country.bb.1.name': 'Barbados',
      'header.country.bd.880.name': 'Bangladesh',
      'header.country.be.32.name': 'Belgium',
      'header.country.bf.226.name': 'Burkina Faso',
      'header.country.bg.359.name': 'Bulgaria',
      'header.country.bh.973.name': 'Bahrain',
      'header.country.bi.257.name': 'Burundi',
      'header.country.bj.229.name': 'Benin',
      'header.country.bl.590.name': 'Saint Barthélemy',
      'header.country.bm.1.name': 'Bermuda',
      'header.country.bn.673.name': 'Brunei Darussalam',
      'header.country.bo.591.name': 'Bolivia, Plurinational State Of',
      'header.country.br.55.name': 'Brazil',
      'header.country.bs.1.name': 'Bahamas',
      'header.country.bt.975.name': 'Bhutan',
      'header.country.bw.267.name': 'Botswana',
      'header.country.by.375.name': 'Belarus',
      'header.country.bz.501.name': 'Belize',
      'header.country.ca.1.name': 'Canada',
      'header.country.cc.61.name': 'Cocos Islands',
      'header.country.cd.243.name': 'Congo, The Democratic Republic Of The',
      'header.country.cf.236.name': 'Central African Republic',
      'header.country.cg.242.name': 'Congo',
      'header.country.ch.41.name': 'Switzerland',
      'header.country.ci.225.name': "Côte D'ivoire",
      'header.country.ck.682.name': 'Cook Islands',
      'header.country.cl.56.name': 'Chile',
      'header.country.cm.237.name': 'Cameroon',
      'header.country.cn.86.name': 'China',
      'header.country.co.57.name': 'Colombia',
      'header.country.cr.506.name': 'Costa Rica',
      'header.country.cv.238.name': 'Cape Verde',
      'header.country.cx.61.name': 'Christmas Island',
      'header.country.cy.357.name': 'Cyprus',
      'header.country.cz.420.name': 'Czech Republic',
      'header.country.de.49.name': 'Germany',
      'header.country.dj.253.name': 'Djibouti',
      'header.country.dk.45.name': 'Denmark',
      'header.country.dm.1.name': 'Dominica',
      'header.country.do.1.name': 'Dominican Republic',
      'header.country.dz.213.name': 'Algeria',
      'header.country.ec.593.name': 'Ecuador',
      'header.country.ee.372.name': 'Estonia',
      'header.country.eg.20.name': 'Egypt',
      'header.country.er.291.name': 'Eritrea',
      'header.country.es.34.name': 'Spain',
      'header.country.et.251.name': 'Ethiopia',
      'header.country.fi.358.name': 'Finland',
      'header.country.fj.679.name': 'Fiji',
      'header.country.fk.500.name': 'Falkland Islands',
      'header.country.fm.691.name': 'Micronesia, Federated States Of',
      'header.country.fo.298.name': 'Faroe Islands',
      'header.country.fr.33.name': 'France',
      'header.country.ga.241.name': 'Gabon',
      'header.country.gb.44.name': 'United Kingdom',
      'header.country.gd.1.name': 'Grenada',
      'header.country.ge.995.name': 'Georgia',
      'header.country.gf.594.name': 'French Guyana',
      'header.country.gh.233.name': 'Ghana',
      'header.country.gi.350.name': 'Gibraltar',
      'header.country.gl.299.name': 'Greenland',
      'header.country.gm.220.name': 'Gambia',
      'header.country.gn.224.name': 'Guinea',
      'header.country.gp.450.name': 'Guadeloupe',
      'header.country.gq.240.name': 'Equatorial Guinea',
      'header.country.gr.30.name': 'Greece',
      'header.country.gt.502.name': 'Guatemala',
      'header.country.gu.1.name': 'Guam',
      'header.country.gw.245.name': 'Guinea-bissau',
      'header.country.gy.592.name': 'Guyana',
      'header.country.hk.852.name': 'Hong Kong',
      'header.country.hn.504.name': 'Honduras',
      'header.country.hr.385.name': 'Croatia',
      'header.country.ht.509.name': 'Haiti',
      'header.country.hu.36.name': 'Hungary',
      'header.country.id.62.name': 'Indonesia',
      'header.country.ie.353.name': 'Ireland',
      'header.country.il.972.name': 'Israel',
      'header.country.im.44.name': 'Isle Of Man',
      'header.country.is.354.name': 'Iceland',
      'header.country.in.91.name': 'India',
      'header.country.io.246.name': 'British Indian Ocean Territory',
      'header.country.iq.964.name': 'Iraq',
      'header.country.it.39.name': 'Italy',
      'header.country.je.44.name': 'Jersey ',
      'header.country.jm.1.name': 'Jamaica',
      'header.country.jo.962.name': 'Jordan',
      'header.country.jp.81.name': 'Japan',
      'header.country.ke.254.name': 'Kenya',
      'header.country.kg.996.name': 'Kyrgyzstan',
      'header.country.kh.855.name': 'Cambodia',
      'header.country.ki.686.name': 'Kiribati',
      'header.country.km.269.name': 'Comoros',
      'header.country.kn.1.name': 'Saint Kitts and Nevis',
      'header.country.kr.82.name': 'South Korea',
      'header.country.kw.965.name': 'Kuwait',
      'header.country.ky.1.name': 'Cayman Islands',
      'header.country.kz.7.name': 'Kazakhstan',
      'header.country.la.856.name': "Lao People's Democratic Republic",
      'header.country.lb.961.name': 'Lebanon',
      'header.country.lc.1.name': 'Saint Lucia',
      'header.country.li.423.name': 'Liechtenstein',
      'header.country.lk.94.name': 'Sri Lanka',
      'header.country.lr.231.name': 'Liberia',
      'header.country.ls.266.name': 'Lesotho',
      'header.country.lt.370.name': 'Lithuania',
      'header.country.lu.352.name': 'Luxembourg',
      'header.country.lv.371.name': 'Latvia',
      'header.country.ly.218.name': 'Libya',
      'header.country.ma.212.name': 'Morocco',
      'header.country.mc.377.name': 'Monaco',
      'header.country.md.373.name': 'Moldova, Republic Of',
      'header.country.me.382.name': 'Montenegro',
      'header.country.mf.590.name': 'Saint Martin',
      'header.country.mg.261.name': 'Madagascar',
      'header.country.mh.692.name': 'Marshall Islands',
      'header.country.mk.389.name':
          'Macedonia, The Former Yugoslav Republic Of',
      'header.country.ml.223.name': 'Mali',
      'header.country.mm.95.name': 'Myanmar',
      'header.country.mn.976.name': 'Mongolia',
      'header.country.mo.853.name': 'Macao',
      'header.country.mp.1.name': 'Northern Mariana Islands',
      'header.country.mq.596.name': 'Martinique',
      'header.country.mr.222.name': 'Mauritania',
      'header.country.ms.1.name': 'Montserrat',
      'header.country.mt.356.name': 'Malta',
      'header.country.mu.230.name': 'Mauritius',
      'header.country.mv.960.name': 'Maldives',
      'header.country.mw.265.name': 'Malawi',
      'header.country.mx.52.name': 'Mexico',
      'header.country.my.60.name': 'Malaysia',
      'header.country.mz.258.name': 'Mozambique',
      'header.country.na.264.name': 'Namibia',
      'header.country.nc.687.name': 'New Caledonia',
      'header.country.ne.227.name': 'Niger',
      'header.country.nf.672.name': 'Norfolk Islands',
      'header.country.ng.234.name': 'Nigeria',
      'header.country.ni.505.name': 'Nicaragua',
      'header.country.nl.31.name': 'Netherlands',
      'header.country.no.47.name': 'Norway',
      'header.country.np.977.name': 'Nepal',
      'header.country.nr.674.name': 'Nauru',
      'header.country.nu.683.name': 'Niue',
      'header.country.nz.64.name': 'New Zealand',
      'header.country.om.968.name': 'Oman',
      'header.country.pa.507.name': 'Panama',
      'header.country.pe.51.name': 'Peru',
      'header.country.pf.689.name': 'French Polynesia',
      'header.country.pg.675.name': 'Papua New Guinea',
      'header.country.ph.63.name': 'Philippines',
      'header.country.pk.92.name': 'Pakistan',
      'header.country.pl.48.name': 'Poland',
      'header.country.pm.508.name': 'Saint Pierre And Miquelon',
      'header.country.pn.870.name': 'Pitcairn',
      'header.country.pr.1.name': 'Puerto Rico',
      'header.country.ps.970.name': 'Palestine',
      'header.country.pt.351.name': 'Portugal',
      'header.country.pw.680.name': 'Palau',
      'header.country.py.595.name': 'Paraguay',
      'header.country.qa.974.name': 'Qatar',
      'header.country.re.262.name': 'Réunion',
      'header.country.ro.40.name': 'Romania',
      'header.country.rs.381.name': 'Serbia',
      'header.country.ru.7.name': 'Russian Federation',
      'header.country.rw.250.name': 'Rwanda',
      'header.country.sa.966.name': 'Saudi Arabia',
      'header.country.sb.677.name': 'Solomon Islands',
      'header.country.sc.248.name': 'Seychelles',
      'header.country.se.46.name': 'Sweden',
      'header.country.sg.65.name': 'Singapore',
      'header.country.sh.290.name':
          'Saint Helena, Ascension And Tristan Da Cunha',
      'header.country.si.386.name': 'Slovenia',
      'header.country.sk.421.name': 'Slovakia',
      'header.country.sl.232.name': 'Sierra Leone',
      'header.country.sm.378.name': 'San Marino',
      'header.country.sn.221.name': 'Senegal',
      'header.country.so.252.name': 'Somalia',
      'header.country.sr.597.name': 'Suriname',
      'header.country.st.239.name': 'Sao Tome And Principe',
      'header.country.sv.503.name': 'El Salvador',
      'header.country.sx.1.name': 'Sint Maarten',
      'header.country.sz.268.name': 'Swaziland',
      'header.country.tc.1.name': 'Turks and Caicos Islands',
      'header.country.td.235.name': 'Chad',
      'header.country.tg.228.name': 'Togo',
      'header.country.th.66.name': 'Thailand',
      'header.country.tj.992.name': 'Tajikistan',
      'header.country.tk.690.name': 'Tokelau',
      'header.country.tl.670.name': 'Timor-leste',
      'header.country.tm.993.name': 'Turkmenistan',
      'header.country.tn.216.name': 'Tunisia',
      'header.country.to.676.name': 'Tonga',
      'header.country.tr.90.name': 'Turkey',
      'header.country.tt.1.name': 'Trinidad &amp; Tobago',
      'header.country.tv.688.name': 'Tuvalu',
      'header.country.tw.886.name': 'Taiwan',
      'header.country.tz.255.name': 'Tanzania, United Republic Of',
      'header.country.ug.256.name': 'Uganda',
      'header.country.us.1.name': 'United States',
      'header.country.uy.598.name': 'Uruguay',
      'header.country.uz.998.name': 'Uzbekistan',
      'header.country.va.379.name': 'Holy See',
      'header.country.vc.1.name': 'Saint Vincent &amp; The Grenadines',
      'header.country.ve.58.name': 'Venezuela, Bolivarian Republic Of',
      'header.country.vg.1.name': 'British Virgin Islands',
      'header.country.vi.1.name': 'US Virgin Islands',
      'header.country.vn.84.name': 'Viet Nam',
      'header.country.vu.678.name': 'Vanuatu',
      'header.country.wf.681.name': 'Wallis And Futuna',
      'header.country.ws.685.name': 'Samoa',
      'header.country.xk.383.name': 'Kosovo',
      'header.country.ye.967.name': 'Yemen',
      'header.country.yt.262.name': 'Mayotte',
      'header.country.za.27.name': 'South Africa',
      'header.country.zm.260.name': 'Zambia',
      'header.country.zw.263.name': 'Zimbabwe',
      'header.TOP_COUNTRIES_LABEL': 'TOP COUNTRIES',
      'header.OTHER_COUNTRIES_LABEL': 'OTHER COUNTRIES',
      'header.switch.to.english.text': 'Switch to English',
      'header.hotels.message.for.arabic':
          'Support for browsing Hotels in Arabic will be coming soon',
      'header.please.proceed.text': 'Yes Please proceed',
      'header.cancel.text': 'cancel',
      'header.not.supporting.arabic':
          'Support for browsing Hotels in Arabic will be coming soon. We will switch you to the English website',
      'header.ENGLISH': 'ENGLISH',
      'header.ARABIC': 'ARABIC',
      'header.cancel.capitalised.text': 'cancel',
      'header.country.dropdown': {
        IN: 'India',
        AE: 'UAE',
        US: 'US',
        KW: 'Kuwait',
        SA: 'Saudi Arabia',
        OM: 'Oman',
      },
      'header.currency.text': 'Currency',
      'header.country.text': 'Country',
      'header.language.text': 'Language',
      'header.available.in.arabic.text':
          "Now also available in <span class='latoBold'>Arabic</span>",
      'header.coming.soon.text': 'COMING SOON',
      'header.select.currency.text': 'Select Currency',
      'header.select.language.text': 'Select Language',
      'header.select.country.text': 'Select Country',
      'header.apply.text': 'Apply',
      'header.manage.your.bookings.text': 'Manage your bookings',
    },
    FLIGHTS_UI_MESSAGES: {
      searchWidget: {
        tripType: {
          inputLabel: 'TRIP TYPE',
          options: {
            O: 'One Way',
            R: 'Round Trip',
            M: 'Multi City',
          },
        },
        src: {
          inputLabel: 'FROM',
          placeholder: 'Enter City',
        },
        dest: {
          inputLabel: 'TO',
          placeholder: 'Enter City',
        },
        departure: {
          inputLabel: 'DEPART',
        },
        return: {
          inputLabel: 'RETURN',
          placeholder: 'Select Return',
        },
        pnc: {
          inputLabel: 'PASSENGERS & CLASS',
          inputValues: {
            Adults: 'Adults',
            Travellers: 'Travellers',
            Adult: 'Adult',
            Traveller: 'Traveller',
            'Group Booking': 'Group Booking',
          },
          options: {
            adults: {
              inputLabel: 'ADULTS (12y +)',
              groupBookingTooltip:
                  'Save on bookings with more than 9 travellers',
              ontheDayTravelText: 'on the day of travel',
            },
            children: {
              inputLabel: 'CHILDREN (2y - 12y )',
              ontheDayTravelText: 'on the day of travel',
            },
            infants: {
              inputLabel: 'INFANTS (below 2y)',
              ontheDayTravelText: 'on the day of travel',
            },
            travelClass: {
              inputLabel: 'CHOOSE TRAVEL CLASS',
              optionsLabels: {
                Economy: 'Economy',
                'Economy / Premium Economy': 'Economy / Premium Economy',
                'Premium Economy': 'Premium Economy',
                Business: 'Business',
                'First Class': 'First Class',
              },
            },
          },
          btnLabel: 'DONE',
        },
        ctaButtonText: 'SEARCH',
        tripPrefix: 'TRIP',
        addCityBtnText: '+ Add City',
        'SEARCH RESULTS': 'SEARCH RESULTS',
        'NEARBY CITIES': 'NEARBY CITIES',
        errMessages: {
          guestCount: 'Total guest count cannot exceed 9',
          infantCount: 'Infant count cannot exceed adult count',
          returnDate: 'Please select return date',
        },
      },
      searchLoadingMessage: 'Hold on, we’re fetching flights for you',
      defaultErrorMessages: {
        NWE: {
          title: 'NETWORK PROBLEM',
          subtitle:
              'We are unable to connect to our systems from your device. Please try again after a while',
        },
        STREMPTY: {
          title: 'Oops, Something Went Wrong!',
          subtitle:
              'We are unable to connect to our systems. Please refresh the page or try again after a while',
        },
        JSE: {
          title: 'Client software exception',
          subtitle: 'We will resolve this asap. Please try again in a while.',
        },
        DEFAULT: {
          title: 'Oops! There was a problem loading the page',
          subtitle:
              'Our systems seem to be experiencing an issue. We are working on resolving it asap. Please refresh the page or go back to the earlier page',
        },
        rightCtaText: 'Refresh',
      },
      flightDetails: {
        title: 'Flight Details',
        hideDtls: 'Hide Flight Details',
        viewDtls: 'View Flight Details',
        baggageLabel: 'BAGGAGE : ',
        checkinLabel: 'CHECK IN',
        cabinLabel: 'CABIN',
        tabs: {
          'FLIGHT DETAILS': 'FLIGHT DETAILS',
          'FARE SUMMARY': 'FARE SUMMARY',
          CANCELLATION: 'CANCELLATION',
          'DATE CHANGE': 'DATE CHANGE',
        },
        loaderText: 'Fetching Details...',
        hideShowBtn: 'Show',
        notAvlText: 'Information not available',
        exitText: 'Exit',
      },
      flightsListing: {
        sorterTitle: 'Sorted By:',
        bookNowCTAText: 'Book Now',
        multiFareHidePricesText: 'Hide Prices',
        plusDayTemplate: '+ {{count}} DAY',
        loadersText: {
          selectingFlight: 'Selecting your flight...',
          moreFaresSplit: 'Getting more fares for you...',
          moreFares: 'Getting More Fares...',
          gettingFlights: 'Hold on, we’re getting flights..',
          submitting: 'Submitting...',
        },
        splitFooter: {
          fareDetailsText: 'Fare Details',
        },
        mcTripTxt: 'Trip {{index}}',
        otherFlightsHeading: 'Other Flights',
        selectFareText: 'Select Fare',
        discountsTitle: {
          boldText: 'Hot',
          normalText: 'DEALS',
        },
        hideShowTimingsOptions: {
          more: 'More Timing Options',
          less: 'Less Timing Options',
        },
      },
      flightsFilters: {
        FILTERED_OUT_TEXT: {
          TITLE: 'Too many filters applied!',
          DESC: "We couldn't find any flights with all the filters you’ve selected. Try removing some filters",
          OrText: 'Or',
        },
        clearAllFiltersText: 'Clear all filters',
        appliedFiltersText: 'Applied Filters',
        clearAppliedFiltersText: 'CLEAR ALL',
        loadersText: {
          'Popular filters': 'Popular filters',
          Price: 'Price',
          Departure: 'Departure',
          Airlines: 'Airlines',
          Arrival: 'Arrival',
        },
      },
      flightsFiltersOld: {
        moreFiltersText: 'More Filters',
        resetBtnText: 'Reset',
        applyBtnText: 'Apply',
        cancelBtnText: 'Cancel',
        moreAirlinesText: '+ {{count}} airlines',
        FILTERED_OUT_TEXT: {
          TITLE: 'Too many filters applied!',
          DESC: 'Try a different combination of filters.',
        },
        clearAllFiltersText: 'Clear All Filters',
        mcFiltersTitle: 'Filters:',
      },
      reviewOnwardHeader: {
        pageNames: {
          'Review your booking': 'Review your booking',
          'Traveller & Addons': 'Traveller & Addons',
          'Booking Summary': 'Booking Summary',
        },
        timelineSteps: {
          flight: 'Flight Selected',
          review: 'Review',
          traveller: 'Traveller Details',
          itinerary: 'Booking Summary',
          pay: 'Make Payment',
        },
      },
      itineraryTitle: 'Itinerary',
      flightSummaryTitle: 'Flight Summary',
      fareSummaryTitle: 'Fare Summary',
      reviewLoaderTexts: {
        itLoaderText: 'Fetching Details...',
        fareDetailsLoaderText: 'Fetching fare details...',
        submitReviewLoaderText: 'Submitting Review',
        submitTravellerLoaderText: 'Submitting Traveller Details',
        layoverInfoLoaderText: 'Fetching layover information...',
        headingLoaderText: '51 Million users and Counting',
      },
      review: {
        continueCTA: 'Continue',
        outOfPolicyTooltip: {
          title: 'IMPORTANT',
        },
      },
      fareRules: {
        title: 'Fare Rules',
        loaderText: 'Fetching Fare Rules',
        noDataText: 'Info not available',
        tabs: {
          'Cancellation Charges': 'Cancellation Charges',
          'Date change charges': 'Date change charges',
        },
      },
      fastForward: {
        ctaText: 'DONE',
        selectedTemplate: '{{fraction}} selected',
      },
      impInfo: {
        title: 'Important information',
      },
      addOnsHeading: 'Add-ons',
      coupons: {
        inputPlaceholder: 'Enter Coupon Code',
        applyBtnText: 'Apply',
        removeBtnText: 'Remove',
        'VIEW ALL OFFERS': 'VIEW ALL OFFERS',
        'SHOW LESS': 'SHOW LESS',
        OR: 'OR',
        toastLinkText: 'Okay,Got it!',
      },
      travellerForm: {
        tags: {
          COMPLETE: 'COMPLETE',
          INCOMPLETE: 'INCOMPLETE',
        },
        travellerTypes: {
          ADULT: 'ADULT',
          CHILD: 'CHILD',
          INFANT: 'INFANT',
        },
        selectedTemplate: '{{ratio}} selected',
        nameConfirmation: {
          title: 'Name Confirmation',
          fnLabel: 'First Name:',
          lnLabel: 'Last Name:',
          closeBtnText: 'Done',
        },
        dateDropdownPlaceholders: {
          date: 'Date',
          month: 'Month',
          year: 'Year',
        },
        loaderText: {
          submitting: 'Submitting...',
          selecting: 'Selecting...',
        },
        errMessage:
            'You have already selected {{criteria}}. Remove before adding a new one.',
      },
      flightDetailsText: 'Flight Details',
      insurance: {
        editBtnText: 'Edit',
        showMoreText: 'More',
        showLessText: 'Less',
        daysInputPlaceholder: 'Enter number of days',
        daysDoneCtaText: 'DONE',
        toastLinkText: 'Okay,Got it!',
        benefitPrefix: 'Claim upto',
      },
      acknowledgement: {
        title: 'Acknowledgement',
        ctaBtnText: {
          createQuote: 'Create Quote',
          continue: 'Continue',
        },
      },
      ancillaries: {
        loaderText: {
          fetching: 'Fetching ancillaries and add-on information',
          updating: 'Updating Selected Ancillary',
          submit: 'Submitting Ancillary Details',
        },
        SKIP_TO_PAYMENT: 'Skip to Payment',
        SKIP_ADD_ONS: 'SKIP ADD-ONS',
        tabs: {
          Meals: 'Meals',
          Seats: 'Seats',
          Baggage: 'Baggage',
        },
        addMealBtnText: 'Add',
        flightSummaryText: 'Flight summary',
        continueBtnLabel: {
          next: 'Next',
          continue: 'Continue',
          nextSeats: 'Next: Seats',
          newFlowPreAttach: 'CONFIRM SEAT(S)',
        },
        totalFareText: 'Total fare',
        clearSelectionOverlay: {
          title: 'Are you sure ?',
          subTitle:
              'By clicking on Okay, all your seat, meal and extra baggage selections will be discarded.',
          rcaText: 'Okay',
          lcaText: 'Cancel',
        },
        tooltip: {
          seatTaken: 'Sorry, this seat is taken',
        },
      },
      thankyou: {
        loaderText: 'Fetching Thank You Details',
        hotelCrossSellTitle: 'Book your Hotel now',
        hotelOffPercent: '{{offPercent}}% off',
        refundBreakupText: 'Refund breakup',
        fallBack: {
          title: 'Your booking is under progress! ',
          msg1: 'We are sorry, It’s taking longer than usual but don’t worry we have recieved your payment and your booking is under process.',
          msg2: 'We’ll notify you as soon as it’s confirmed. You can also track the status via manage booking. ',
          ctaText: 'manage booking',
        },
      },
      utils: {
        MONTHS: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        DAYS: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        TIME: {
          hoursShort: 'h',
          minutesShort: 'm',
        },
        genericInputMessage: 'Request you to type in English',
      },
      loginPopup: {
        b2b: {
          title: 'Congratulations! You’re logged into myBiz.',
          subtitle:
              'Enjoy a choice of fares, free amenities*, GST benefits and a lot more on myBiz flights',
          leftCtaText: 'Okay',
        },
        ctaFlow: {
          title: 'Congratulations! You’re logged in as an Affiliate.',
          subtitle: "You're being redirected to the homepage",
          leftCtaText: 'Okay',
        },
      },
      logoutPopup: {
        b2b: {
          title: 'You’ve logged out!',
          subtitle: 'We’re taking you to homepage, please search again.',
          leftCtaText: 'Okay, got it',
        },
        normalFlow: {
          title: 'You have logged out successfully',
          subtitle:
              'Since you have logged out, your total fare might change on the payment page. This is due to your reward bonus or any other offer which may have been applied which was applicable only for your logged in account.',
          leftCtaText: 'Okay, got it',
        },
      },
      reviewDetails: {
        addBaggagePopup: {
          addText: 'Add',
          footer: {
            addedPriceText: '(Added to total fare)',
            ctaText: 'DONE',
          },
        },
      },
    },
    IF_DESTINATION_PICKER: {
      searchField: {
        tripType: 'TRIP TYPE',
        from: 'FROM',
        to: 'TO',
        dateDuration: 'DATES & DURATION',
        departure: 'DEPARTURE',
        search: 'Search',
      },
      loaderTexts: {
        fareCalendarLoaderText: 'Fetching Cheapest Flights',
        flightSearchLoaderText: 'Fetching Cheapest Flights',
        mapLoaderText: 'Loading Destinations',
        listingLoaderHeader: 'Loading Destinations',
        sortText: 'Sort By:',
        sortValue: 'Price',
        filtersLoaderText: {
          'Visa & Documents': 'Visa & Documents',
          'Flight Duration': 'Flight Duration',
          Price: 'Price',
          'COVID Restrictions': 'COVID Restrictions',
          Stops: 'Stops',
          'Popular Filters': 'Popular Filters',
        },
      },
    },
  },
  hin: {
    header: {
      'header.mmt.text': 'MMT',
      'header.black.text': 'Black',
      'header.loyalty.programme': 'लॉयल्टी प्रोग्राम ',
      'header.double.black.text': 'DOUBLEBLACK',
      'header.free.cancellation.assured': 'निशुल्क कैंसिलेशन का आश्वासन',
      'header.biz.pending': 'बाकी है ',
      'header.biz.requests': 'निवेदन ',
      'header.my.trips': 'माय ट्रिप',
      'header.24x7': '24x7',
      'header.support': 'सहायता ',
      'header.helplines.active.text': 'हमारी हेल्पलाइन 24x7 सक्रिय हैं',
      'header.introducing.myBiz': 'पेश है MyBiz',
      'header.mmt.for.business': 'MakeMyTrip बिज़नेस के लिए',
      'header.welcome.message': 'हैलो  {firstName}',
      'header.login.or.create.account': 'लॉगिन करें या खाता बनाएं',
      'header.personal.text': 'व्यक्तिगत',
      'header.myBiz.text': 'MYBIZ',
      'header.free.upgrade': 'निशुल्क अपग्रेड ',
      'header.out.corporate.account': 'हमारा कॉर्पोरेट खाता',
      'header.corporate.fares': 'कॉर्पोरेट किराए ',
      'header.with.easy.modifications': 'आसान बदलावों के साथ',
      'header.curated.hotels': 'सुझाए गए होटल',
      'header.safety.text': 'सुरक्षित और स्वच्छ स्टे के लिए',
      'header.gst.invoice': 'GST चालान',
      'header.assurance': 'बीमा',
      'header.signup.work.mail': 'अभी मुफ्त में साइन अप करें !',
      'header.know.more': 'अधिक जानिए',
      'header.about.myBiz': 'myBiz के बारे में।',
      'header.personal.profile.text':
          'आप अपनी व्यक्तिगत प्रोफ़ाइल देख रहे हैं {email}',
      'header.myBiz.profile.text':
          'आप अपनी MyBiz प्रोफ़ाइल {email} देख रहे हैं',
      'header.my.trips.subtitle':
          'बुकिंग डिटेल देखें, ई-टिकट प्रिंट करें, बुकिंग कैंसिल करें, बुकिंग बदलें, रिफंड की स्थिति आदि चेक करें।',
      'header.my.wallet': 'माय वॉलेट',
      'header.my.wallet.subtitle':
          'और अधिक छूट पाने के लिए अपने वॉलेट मनी का उपयोग करें',
      'header.my.mmt.black': 'MMT Black',
      'header.my.mmt.black.subtitle':
          'अपनी अब तक की गई यात्रा, माइलस्टोन देखें और रिवॉर्ड क्लेम करें!',
      'header.my.mmt.double.black': 'MMT Double Black',
      'header.my.mmt.double.black.inactive':
          'अपनी उड़ान और होटल बुकिंग को बिना किसी परेशानी के कैंसल करने के लिए अभी खरीदें',
      'header.my.mmt.double.black.active': 'अपने MMTDoubleBlack के लाभ देखें',
      'header.my.mmt.double.black.expired':
          'आपकी सदस्यता समाप्त हो गई है, MMTDoubleBlack के लाभ चालु रखने के लिए रिन्यू करें',
      'header.my.profile': 'My Profile',
      'header.my.profile.subtitle':
          'अपनी प्रोफ़ाइल, यात्री डिटेल, लॉगिन डिटेल और पासवर्ड मैनेज करें',
      'header.my.make.payment': 'भुगतान करें ',
      'header.my.make.payment.subtitle': 'अपने बकाया भुगतान यहां पूरा करें',
      'header.logout.text': 'लॉग आउट',
      'header.login.signup.for.best.prices':
          'बेस्ट कीमतों के लिए लॉगिन / साइनअप करें ',
      'header.login.signup.text.cash':
          'तुरंत {currency}555 पाने के लिए लॉगिन/साइनअप करें',
      'header.login.signup.easily.with': 'आसानी से लॉगिन / साइन अप करें  ',
      'header.login.with.phone.email': 'फोन / ईमेल से लॉगिन करें',
      'header.welcome.text': 'हेलो ',
      'header.traveller.text': 'यात्री',
      'header.login.success.message':
          'लॉगिन सफल हुआ! मोबाइल नंबर लिंक नहीं हो सका',
      'header.myBiz.login.message':
          'हम अभी तक myBiz खातों के लिए मोबाइल नंबर से लॉगिन सपोर्ट  नहीं करते हैं। आप अपने ईमेल और पासवर्ड के द्वारा अपने खाते में जा सकते हैं।',
      'header.mobile.number.linked.message':
          'इस खाते में पहले से ही एक मोबाइल नंबर जुड़ा हुआ है, कृपया पहले प्रोफाइल में जाकर उस फ़ोन नंबर को अनलिंक करें और उसके बाद फिर से प्रयास करें।',
      'header.move.back.text': 'वापस जाएं',
      'header.skip.text': 'स्किप करें',
      'header.login.with.password': 'पासवर्ड से लॉगिन करें',
      'header.login.signup.text': 'साइन अप/ लॉग इन करें',
      'header.email.placeholder.text': 'ईमेल डालें ',
      'header.for.account.text': '{username}  के लिए ',
      'header.email.or.mobile.placeholder.text': 'ईमेल या मोबाइल नंबर डालें ',
      'header.email.label.text': 'ईमेल',
      'header.email.or.mobile.label.text': 'ईमेल या मोबाइल नंबर से ',
      'header.continue.text': 'जारी रखें',
      'header.login.with.text': 'या लॉगिन करें',
      'header.company.login.portal.text': 'कंपनी लॉग इन पोर्टल',
      'header.login.to.myBiz.account':
          'आप अपने myBiz खाते में अपनी कंपनी के कोड से लॉगिन कर सकते हैं।',
      'header.login.text': 'लॉग इन करें',
      'header.login.via.otp': 'या OTP से लॉगिन करें',
      'header.otp.on.mail.message': 'आपको ई-मेल पर OTP प्राप्त होगा',
      'header.login.signup.with.text': 'या लॉगिन / साइन अप करें',
      'header.no.myBiz.account.message': 'आपका myBiz खाता नहीं है?',
      'header.create.account.here.message': 'यहां एक खाता बनाएं',
      'header.saving.on.business.travel.message':
          'और अपनी बिज़नेस यात्रा पर बचत शुरू करें',
      'header.personal.account.text': 'व्यक्तिगत खाता',
      'header.myBiz.account.text': 'MyBiz खाता',
      'header.reset.password.text': 'पासवर्ड रीसेट करें ',
      'header.mobile.not.registered.text': 'लगता है कि मोबाइल नंबर',
      'header.mobile.not.registered.action.text':
          'MakeMyTrip के साथ रजिस्टर्ड नहीं है, आप आगे क्या करना चाहेंगे?',
      'header.create.personal.account.message':
          'इस मोबाइल नंबर के साथ एक नया व्यक्तिगत खाता बनाएँ',
      'header.link.existing.account': 'किसी मौजूदा खाते से लिंक करें',
      'header.link.user.to.existing.account':
          'एक मौजूदा खाते के साथ {displayUserName} को लिंक करें',
      'header.dismiss.text': 'खारिज करें ',
      'header.account.already.exists.message':
          'एक {accountType} खाता पहले से मौजूद है',
      'header.registered.account.action.message':
          'लगता है कि आप पहले से ही रजिस्टर्ड {accountType} खाते, जिसकी ईमेल: {username} है, के साथ लॉगिन करने की कोशिश कर रहे हैं, आप आगे क्या करना चाहेंगे?',
      'header.login.with.email':
          '{accountType} खाते में इस Email ID से लॉग इन करें ',
      'header.create.new.account':
          'एक नया {accountType} खाता  {username} से बनायें ',
      'header.get.otp.for.mobile.login':
          'मोबाइल नंबर से लॉगिन करने के लिए OTP प्राप्त करें',
      'header.access.myBiz.account': 'MyBiz में कंपनी लॉगिन से जाएँ ',
      'header.company.registered.myBiz.account':
          'आपकी कंपनी ने आपके लिए पहले ही आपके निजी ईमेल आईडी: {उपयोगकर्ता नाम} से आपके लिए myBiz खाता रजिस्टर कर दिया  है, आप आगे क्या करना चाहेंगे?',
      'header.login.myBiz.with.company.portal':
          'कंपनी लॉगिन पोर्टल से myBiz में लॉगिन करें',
      'header.password.placeholder.text': 'कम से कम 6 केरैक्टर।',
      'header.password.text': 'पासवर्ड',
      'header.remember.me.text': 'मुझे याद रखना',
      'header.agent.id.text': 'एजेंट ID ',
      'header.enter.mobile.number.text': 'मोबाइल नंबर डालें ',
      'header.send.otp.text': 'OTP भेजें',
      'header.verify.mobile.number.title': 'मोबाइल नंबर वेरीफाई  करें',
      'header.verify.mobile.number.subtitle':
          'जारी रखने के लिए, कृपया अपना मोबाइल नंबर वेरीफाई करें',
      'header.and.word.text': 'और ',
      'header.or.use.text': 'या उपयोग करें',
      'header.create.account.with': 'या इससे खाता बनाएं',
      'header.resend.otp.text': 'OTP फिर से भेजें',
      'header.verify.text': 'वेरीफाई करें ',
      'header.otp.text': 'OTP',
      'header.enter.otp.sent.to.text': 'कृपया भेजे गए OTP को डालें ',
      'header.add.mobile.number.text': 'अपना मोबाइल नंबर जोड़ने के लिए।',
      'header.enter.myBiz.account.password': 'MyBiz खाते का पासवर्ड डालें ',
      'header.create.account.text': 'खाता बनाएं',
      'header.signup.agree.text': 'साइन अप करने से, आप सहमति देते हैं',
      'header.terms.and.conditions.text': 'नियम और शर्तें',
      'header.email.or.phone.placeholder': 'ईमेल या फोन नं डालें।',
      'header.password.same.message':
          "आपका पर्सनल अकाउंट पासवर्ड और MyBiz  <span class='latoBold'>(abhinav.mittal@go-mmt.com)</span> खाते वाला पासवर्ड एक ही होंगें",
      'header.create.personal.account.text': 'नया व्यक्तिगत खाता बनाएं',
      'header.enter.username.for.linking.mobile':
          'उस खाते का यूजरनेम डालें, जिसे आप मोबाइल नंबर {displayUserName} से जोड़ना चाहते हैं।',
      'header.continue.text.capitalized': 'जारी रखें',
      'header.login.via.password.text': 'या पासवर्ड से लॉगिन करें',
      'header.verify.emailId.message': 'अपनी ई-मेल ID  वेरीफाई करें',
      'header.verify.mobile.message': 'अपना मोबाइल नंबर वेरीफाई करें',
      'header.enter.otp.on.email.text':
          'लॉगिन करने के लिए {username} या अपनी रजिस्टर्ड ई-मेल पर भेजा गया OTP डालें',
      'header.enter.otp.on.mobile.text':
          'लॉगिन करने के लिए {username} या अपने रजिस्टर्ड मोबाइल नंबर पर भेजा गया OTP डालें ',
      'header.enter.otp.sent.to.username.text':
          'लॉगिन करने के लिए {username} पर भेजे गए OTP को डालें ',
      'header.login.to.your.account.text': 'अपने खाते में लॉग इन करने के लिए।',
      'header.reset.the.password.text': 'पासवर्ड रिसेट करने के लिए।',
      'header.to.continue.text': 'जारी रखने के लिए।',
      'header.send.reset.otp.on.email.mobile':
          'हम आपको आपके रजिस्टर्ड ई-मेल या मोबाइल नंबर पर एक रिसेट OTP भेजेंगे',
      'header.send.reset.otp.on.email':
          'हम आपकी रजिस्टर्ड ई-मेल पर एक रिसेट OTP भेजेंगे',
      'header.register.email.or.mobile.text': 'रजिस्टर्ड ईमेल या मोबाइल नंबर',
      'header.register.email.text': 'रजिस्टर्ड ईमेल',
      'header.username.not.exist.message': 'यह यूज़र नेम मौजूद नहीं है।',
      'header.trying.to.create.new.account':
          'अगर आप नया ${accountType} खाता बनाने की कोशिश कर रहे हैं ',
      'header.google.business.account.text': 'Google बिज़नेस खाता ',
      'header.new.password.text': 'नया पासवर्ड',
      'header.create.new.password.text': 'नया पासवर्ड बनाएं',
      'header.new.password.validations.text':
          'ये कम से कम 8 केरैक्टर लम्बा और इसमें कम से कम एक अक्षर, एक नंबर और एक विशेष सिंबल @ $!% * # होना चाहिए',
      'header.redirect.to.login.text': 'लॉगिन पर जाएं',
      'header.password.changed.successfully.message':
          'पासवर्ड सफलतापूर्वक बदल गया है',
      'header.do.not.share.password.message':
          'दुरुपयोग रोकने के लिए, अपना पासवर्ड किसी के साथ शेयर न करें।',
      'header.login.successful.message': 'लॉग इन सफल हुआ ',
      'header.A.letter.text': 'A',
      'header.successful.logged.in.message':
          'आपने अपने खाते में सफलतापूर्वक लॉग इन कर लिया है',
      'header.account.creation.unsuccessful': 'खाता बनाना असफल हुआ ',
      'header.account.creation.unsuccessful.message':
          'हम आपका खाता नहीं बना पाए क्योंकि मोबाइल नंबर वेरीफाई नहीं हो सका।',
      'header.continue.creating.account': 'यहां खाता बनाना जारी रखें ',
      'header.reset.your.password.text': 'अपना पासवर्ड रिसेट करने के लिए',
      'header.enter.otp.sent.text': 'इस पर भेजा गया OTP डालें ',
      'header.verify.and.link.account':
          'उसे वेरीफाई करने और खाते से जोड़ने के लिए ',
      'header.enter.otp.placeholder': 'OTP डालें',
      'header.create.next.account.text': 'नया खाता बनाएं',
      'header.already.a.member.text': 'आप पहले से सदस्य हैं?',
      'header.verify.number.and.create.account':
          'नंबर सत्यापित करें और खाता बनाएं',
      'header.login.myBiz.with.email': 'इस ईमेल id से myBiz पर लॉगिन करें',
      'header.already.registered.email.message':
          'लगता है आप पहले से रजिस्टर्ड myBiz  खाते में, जिसकी ईमेल: {username} है, के साथ साइनअप करने की कोशिश कर रहे हैं, आप आगे क्या करना चाहेंगे?',
      'header.myBiz.account.exists': 'एक MyBiz खाता पहले से मौजूद है',
      'header.congratulations.message': 'बधाई हो!',
      'header.account.created.successfully': 'खाता सफलतापूर्वक बन गया है ',
      'header.save.and.continue.text': 'सेव करें और जारी रखें',
      'header.save.and.verify.mobile.text': 'मोबाइल नंबर सेव और वेरीफाई करें',
      'header.account.created.successfully.message':
          'बधाई हो! आपका खाता सफलतापूर्वक बन गया है! आप सर्वोत्तम कीमतें  पाने के लिए अभी से बुकिंग शुरू कर सकते हैं।',
      'header.unlocked.bonus.reward.message':
          'बधाई हो! आपने सफलतापूर्वक बोनस रिवार्ड अनलॉक किया है',
      'header.wallet.money.rewarded': '555 वॉलेट मनी',
      'header.verify.and.create.account': 'वेरीफाई करें और खाता बनाएं ',
      'header.verify.and.link.account.text': 'वेरीफाई करें और खाता लिंक करें',
      'header.incorrect.otp.entered.text':
          'गलत  OTP है। कृपया फिर से प्रयास करें।',
      'header.enter.otp.label': 'OTP डालें',
      'header.enter.otp.here.placeholder': 'यहां  OTP डालें',
      'header.numeric.validation': 'एक नंबर होना चाहिए',
      'header.min.characters.validation':
          'कम से कम  {min} या अधिक केरैक्टर होने चाहिए ',
      'header.max.characters.validation':
          ' {max} केरैक्टर या उससे कम होने चाहिए',
      'header.min.value.validation': 'कम से कम  {min}',
      'header.email.format.message':
          "ईमेल 'abc@xyz.com' फॉर्मेट में होनी चाहिए",
      'header.aol.email.message':
          'वास्तव में? आप अभी भी अपने ईमेल के लिए AOL प्रयोग करते हैं?',
      'header.alphanumeric.validation': 'केवल अल्फान्यूमेरिक केरैक्टर डालें ',
      'header.mobile.number.validation':
          'फ़ोन नंबर अमान्य है, 10 अंकों का होना चाहिए',
      'header.required.validation': 'आवश्यक है',
      'header.privacy.policy.text': 'प्राइवेसी पॉलिसी',
      'header.user.agreement.text': 'यूज़र एग्रीमेंट ',
      'header.terms.of.service.text': 'सेवा की शर्तें',
      'header.invalid.phone.number': 'अमान्य फोन नंबर',
      'header.your.username.message': 'यह आपका यूज़र नेम होगा',
      'header.otp.verification.completed':
          'मोबाइल नंबर से खाता बनाते समय <b> OTP वेरिफिकेशन </b> किया जाता है',
      'header.click.here.text': 'यहां क्लिक करें',
      'header.attempting.login.text': 'अगर आप लॉगिन करने की कोशिश कर रहे हैं।',
      'header.enter.password.placeholder': 'पासवर्ड डालें ',
      'header.enter.work.email': 'अपनी कार्य ईमेल id डालें ',
      'header.agreement.text.on.mmt':
          'आगे बढ़ने से, आप सहमति देते हैं MakeMyTrip के ',
      'header.policy.text': 'प्राइवेसी',
      'header.login.expired': 'लॉगइन एक्सपायर हो गया है',
      'header.click.to.login.again':
          "चिंता ना करें! हम नियमित रूप से यूजरों को लॉगआउट करते हैं  ताकि उनके खाते को सुरक्षित रखा जा सके। बस <a className='latoBold'>यहां क्लिक करके फिर से लॉगिन करें</a> और MMT अनुभव का आनंद लें ",
      'header.signup.with.facebook': 'फेसबुक से साइन अप करें ',
      'header.login.with.facebook': 'फेसबुक से लॉग इन करें ',
      'header.signup.with.google': 'Google से साइन अप करें',
      'header.login.with.google': 'Google से लॉगिन करें',
      'header.login.or.signup.message': 'साइन अप/लॉग इन करें',
      'header.work.email.text': 'कार्य ईमेल',
      'header.verification.successful.text': 'जांच सफल हुई',
      'header.mobile.number.verified.message':
          'बधाई हो! आपका मोबाइल नंबर {username} सफलतापूर्वक वेरीफाई हो गया है और {emailId} खाते से लिंक किया गया है',
      'header.cruise': 'क्रूज',
      'header.new.text': 'नया',
      'header.admin.text': 'एडमिन ',
      'header.ACTIVITIES': 'गतिविधियां ',
      'header.NEARBY_GETAWAYS': 'आसपास की छुट्टी ',
      'header.TRIP_MONEY': 'TripMoney ',
      'header.FLIGHTS': 'उड़ानें ',
      'header.CHARTER_FLIGHTS': 'चार्टर उड़ानें',
      'header.HOTELS_APTS': 'होटल और अप्स',
      'header.CHARTER_FLIGHTS_CLASS': 'चार्टर उड़ानें',
      'header.HOTELS': 'होटल',
      'header.HOLIDAYS': 'छुट्टियां',
      'header.HOLIDAY_PACKAGES': 'छुट्टी के पैकेज',
      'header.BUSES': 'बसें',
      'header.CABS': 'कैब',
      'header.BIZ_CABS': 'एयरपोर्ट के कैब',
      'header.TRAINS': 'ट्रेनें',
      'header.GIFTCARDS': 'गिफ्ट कार्ड',
      'header.MORE': 'और देखें ',
      'header.LOGIN_AGENT': 'एजेंट लॉगिन',
      'header.MMT_LOGO_ALT': "MMT's LOGO",
      'header.ACTIVE': 'एक्टिव ',
      'header.IN_YOUR_WALLET': 'आपके वॉलेट में',
      'header.YOUR_WALLET': 'आपका वॉलेट ',
      'header.LOGIN_OR': 'लॉगिन या',
      'header.CREATE_ACCOUNT_TEXT': 'खाता बनाएं',
      'header.MY_BIZ': 'My Biz',
      'header.INT_FLIGHT': 'अंतरराष्ट्रीय उड़ानें',
      'header.INT_HOTEL': 'अंतरराष्ट्रीय होटल',
      'header.REFER_EARN': 'रेफेर करें और कमाएं',
      'header.BLOG': 'ब्लॉग',
      'header.Deals': 'डील ',
      'header.VENUES': 'स्थान',
      'header.ADMIN_SITE': 'एडमिन ',
      'header.HOME_STAYS': 'विला और अपार्टमेंट ',
      'header.HOME_STAYS_CLASS': 'होमस्टे',
      'header.VISA': 'वीज़ा',
      'header.MICE': 'MICE',
      'header.TRIP_IDEAS': 'ट्रिप के सुझाव ',
      'header.LOGIN_ENTER_VALID_EMAIL_ERROR_MESSAGE':
          'कृपया एक वैध ईमेल या मोबाइल नंबर डालें।',
      'header.LOGIN_ENTER_VALID_AGENT_ERROR_MESSAGE':
          'कृपया एक वैध एजेंट आईडी डालें',
      'header.LOGIN_ENTER_VALID_ONLY_EMAIL_ERROR_MESSAGE':
          'कृपया वैध ईमेल डालें।',
      'header.LOGIN_ENTER_PASSWORD_ERROR_MESSAGE': 'कृपया पासवर्ड डालें ',
      'header.LOGIN_ENTER_VALID_PASSWORD_ERROR_MESSAGE':
          'पासवर्ड 6 केरैक्टर से कम नहीं हो सकता।',
      'header.LOGIN_ENTER_VALID_OTP_ERROR_MESSAGE': 'कृपया वैध OTP डालें ',
      'header.SIGNUP_ENTER_VALID_CHARACTER_PASSWORD_ERROR_MESSAGE':
          'पासवर्ड कम से कम 8 करैक्टर लम्बा और उसमें कम से कम एक अक्षर, एक नंबर और एक विशेष सिंबल  @ $!% * # & होना चाहिए',
      'header.OTP_LOGIN_VALID_OTP_ERROR':
          'गलत OTP! कृपया आप को भेजा गया OTP डालें।',
      'header.LOGIN_ACCOUNT_BLOCKED_ERROR_MESSAGE':
          'आपने अधिकतम लॉगिन प्रयासों की सीमा पार कर ली है। कृपया - कुछ समय बाद फिर से प्रयास करें',
      'header.LOGIN_INCORRECT_EMAIL_PASSWORD_ERROR_MESSAGE':
          'यूज़र नेम या पासवर्ड गलत है।',
      'header.LOGIN_DEFAULT_ERROR_MESSAGE':
          'लगता है कि कोई तकनीकी समस्या है, कृपया कुछ समय बाद फिर से प्रयास करें।',
      'header.FORGOT_PASSWORD_USER_NOT_EXISTS_ERROR_MESSAGE':
          'यूज़र नेम मौजूद नहीं है, कृपया एक वैध ईमेल id या मोबाइल नंबर डालें',
      'header.FORGOT_PASSWORD_DEFAULT_ERROR_MESSAGE':
          'कुछ गड़बड़ी हो गई है, कृपया फिर से प्रयास करें।',
      'header.VERIFY_OTP_LIMIT_CROSSED_ERROR_MESSAGE':
          'आपने OTP भेजने की अधिकतम सीमा पार कर ली है। कृपया कुछ देर बाद फिर प्रयास करें',
      'header.VERIFY_OTP_INCORRECT_OTP_ERROR_MESSAGE':
          'गलत OTP, कृपया फिर से प्रयास करें',
      'header.FORGOT_PASSWORD_OTP_INVALID_TOKEN_ERROR_MESSAGE':
          'गलत OTP, कृपया फिर से प्रयास करें',
      'header.FORGOT_PASSWORD_OTP_DEFAULT_ERROR_MESSAGE':
          'कुछ गड़बड़ी हो गई है, कृपया फिर से प्रयास करें।',
      'header.FORGOT_PASSWORD_OTP_INCORRECT_OTP_ERROR_MESSAGE':
          'गलत OTP, कृपया फिर से प्रयास करें',
      'header.LOGIN_CREDENTIALS_EXPIRED_ERROR_MESSAGE':
          'आपका पासवर्ड एक्सपायर हो गया है। अपना पासवर्ड रिसेट करने के लिए कृपया रिसेट पासवर्ड पर क्लिक करें।',
      'header.PLACEHOLDER_COUNTRY_CODE': 'देश का नाम या कोड',
      'header.NOT_VALID_USER':
          'इस ईमेल id के साथ कोई व्यक्तिगत खाता संबंधित नहीं है',
      'header.ACCOUNT_ALREADY_LINKED':
          'इस खाते से दूसरा फ़ोन नंबर जुड़ा हुआ है',
      'header.PROCEED_TO_LOGIN_MSG':
          'आगे बढ़ने से आप सहमति देते हैं MakeMyTrip के ',
      'header.TOS_MSG': 'नियम एवं शर्तें',
      'header.PRIVACY_POLICY_MSG': 'प्राइवेसी पॉलिसी',
      'header.USER_AGREEMENT_MSG': 'यूज़र एग्रीमेंट ',
      'header.PHONE_NUMBER_ALREADY_LINKED':
          'फ़ोन नंबर किसी अन्य खाते से जुड़ा है।',
      'header.GOOGLE_ERROR': 'Google लॉगिन असफल हुआ ',
      'header.FB_ERROR': 'फेसबुक लॉगिन असफल ',
      'header.NO_MATCH_FOUND': 'कोई मेल नहीं मिला',
      'header.facebook.text': 'फेसबुक',
      'header.google.text': 'गूगल',
      'header.enter.fullname.text': 'पूरा नाम डालें ',
      'header.enter.valid.name.message': 'कृपया एक वैध नाम डालें ',
      'header.incorrect.format.message': 'गलत फॉर्मेट ',
      'header.invalid.phone.number.message': 'अमान्य फोन नंबर',
      'header.enter.full.name.placeholder': 'अपना पूरा नाम डालें ',
      'header.country.ad.376.name': 'अंडोरा',
      'header.country.ae.971.name': 'संयुक्त अरब अमीरात',
      'header.country.af.93.name': 'अफ़ग़ानिस्तान',
      'header.country.ag.1.name': 'अंतिगुआ और बार्बूडा',
      'header.country.ai.1.name': 'एंगीला',
      'header.country.al.355.name': 'अल्बानिया',
      'header.country.am.374.name': 'आर्मीनिया',
      'header.country.ao.244.name': 'अंगोला',
      'header.country.aq.672.name': 'अंटार्कटिका',
      'header.country.ar.54.name': 'अर्जेंटीना',
      'header.country.as.1.name': 'अमरीकी समोआ',
      'header.country.at.43.name': 'ऑस्ट्रिया',
      'header.country.au.61.name': 'ऑस्ट्रेलिया',
      'header.country.aw.297.name': 'अरूबा',
      'header.country.az.358.name': 'एलैंड आइलैंड ',
      'header.country.az.994.name': 'आज़रबाइजान',
      'header.country.ba.387.name': 'बोस्निया और हर्जेगोविना',
      'header.country.bb.1.name': 'बारबाडोस',
      'header.country.bd.880.name': 'बांग्लादेश',
      'header.country.be.32.name': 'बेल्जियम',
      'header.country.bf.226.name': 'बुर्किना फासो',
      'header.country.bg.359.name': 'बुल्गारिया',
      'header.country.bh.973.name': 'बाहरीन',
      'header.country.bi.257.name': 'बुस्र्न्दी',
      'header.country.bj.229.name': 'बेनिन',
      'header.country.bl.590.name': 'सेंट बार्थेलेमी',
      'header.country.bm.1.name': 'बरमूडा',
      'header.country.bn.673.name': 'ब्रुनेई दारुस्सलाम',
      'header.country.bo.591.name': 'बोलीविया, बहुराष्ट्रीय राज्य ',
      'header.country.br.55.name': 'ब्राज़िल',
      'header.country.bs.1.name': 'बहामास ',
      'header.country.bt.975.name': 'भूटान',
      'header.country.bw.267.name': 'बोत्सवाना',
      'header.country.by.375.name': 'बेलारूस',
      'header.country.bz.501.name': 'बेलीज',
      'header.country.ca.1.name': 'कनाडा',
      'header.country.cc.61.name': 'कोकोस द्वीप',
      'header.country.cd.243.name': 'कांगो, लोकतांत्रिक गणराज्य',
      'header.country.cf.236.name': 'सेंट्रल अफ्रीकन गणराज्य',
      'header.country.cg.242.name': 'कांगो',
      'header.country.ch.41.name': 'स्विट्जरलैंड',
      'header.country.ci.225.name': 'आइवरी कोस्ट ',
      'header.country.ck.682.name': 'कुक आइलैंड ',
      'header.country.cl.56.name': 'चिली',
      'header.country.cm.237.name': 'कैमरून',
      'header.country.cn.86.name': 'चीन',
      'header.country.co.57.name': 'कोलम्बिया',
      'header.country.cr.506.name': 'कोस्टा रिका',
      'header.country.cv.238.name': 'केप वर्द',
      'header.country.cx.61.name': 'क्रिसमस आइलैंड ',
      'header.country.cy.357.name': 'साइप्रस',
      'header.country.cz.420.name': 'चेक रिपब्लिक ',
      'header.country.de.49.name': 'जर्मनी',
      'header.country.dj.253.name': 'जिबूती',
      'header.country.dk.45.name': 'डेनमार्क',
      'header.country.dm.1.name': 'डोमिनिका',
      'header.country.do.1.name': 'डोमिनिकन रिपब्लिक ',
      'header.country.dz.213.name': 'एलजीरिया',
      'header.country.ec.593.name': 'इक्वेडोर',
      'header.country.ee.372.name': 'एस्तोनिया',
      'header.country.eg.20.name': 'मिस्र',
      'header.country.er.291.name': 'इरिट्रिया',
      'header.country.es.34.name': 'स्पेन',
      'header.country.et.251.name': 'इथियोपिया',
      'header.country.fi.358.name': 'फिनलैंड',
      'header.country.fj.679.name': 'फ़िजी',
      'header.country.fk.500.name': 'फ़ॉकलैंड आइलैंड',
      'header.country.fm.691.name': 'माइक्रोनेशिया, संघीय राज्य',
      'header.country.fo.298.name': 'फ़ैरो आइलैंड ',
      'header.country.fr.33.name': 'फ्रांस',
      'header.country.ga.241.name': 'गैबॉन',
      'header.country.gb.44.name': 'यूनाइटेड किंगडम',
      'header.country.gd.1.name': 'ग्रेनाडा',
      'header.country.ge.995.name': 'जॉर्जिया',
      'header.country.gf.594.name': 'फ्रेंच गुयाना',
      'header.country.gh.233.name': 'घाना',
      'header.country.gi.350.name': 'जिब्राल्टर',
      'header.country.gl.299.name': 'ग्रीनलैंड',
      'header.country.gm.220.name': 'गाम्बिया',
      'header.country.gn.224.name': 'गिन्नी',
      'header.country.gp.450.name': 'ग्वाडेलूप',
      'header.country.gq.240.name': 'एक्वाटोरि गिनी',
      'header.country.gr.30.name': ' ग्रीस ',
      'header.country.gt.502.name': 'ग्वाटेमाला',
      'header.country.gu.1.name': 'गुआम',
      'header.country.gw.245.name': 'गिनी-बिसौ',
      'header.country.gy.592.name': 'गुयाना',
      'header.country.hk.852.name': 'हॉगकॉग',
      'header.country.hn.504.name': 'होंडुरस',
      'header.country.hr.385.name': 'क्रोएशिया',
      'header.country.ht.509.name': 'हैती',
      'header.country.hu.36.name': 'हंगरी',
      'header.country.id.62.name': 'इंडोनेशिया',
      'header.country.ie.353.name': 'आयरलैंड',
      'header.country.il.972.name': 'इज़राइल',
      'header.country.im.44.name': 'मैन द्वीप',
      'header.country.is.354.name': 'आइसलैंड',
      'header.country.in.91.name': 'भारत',
      'header.country.io.246.name': 'ब्रिटिश हिन्द महासागर क्षेत्र',
      'header.country.iq.964.name': 'इराक',
      'header.country.it.39.name': 'इटली',
      'header.country.je.44.name': 'जर्सी',
      'header.country.jm.1.name': 'जमैका',
      'header.country.jo.962.name': 'जॉर्डन',
      'header.country.jp.81.name': 'जापान',
      'header.country.ke.254.name': 'केन्या',
      'header.country.kg.996.name': 'किर्गिज़स्तान',
      'header.country.kh.855.name': 'कंबोडिया',
      'header.country.ki.686.name': 'किरिबाती',
      'header.country.km.269.name': 'कोमोरोस',
      'header.country.kn.1.name': 'संत किट्ट्स और नेविस',
      'header.country.kr.82.name': 'दक्षिण कोरिया',
      'header.country.kw.965.name': 'कुवैत',
      'header.country.ky.1.name': 'केमैन आइलैंड ',
      'header.country.kz.7.name': 'कजाकस्तान',
      'header.country.la.856.name': 'लाओ पीपुल्स डेमोक्रेटिक रिपब्लिक',
      'header.country.lb.961.name': 'लेबनान',
      'header.country.lc.1.name': 'सेंट लूसिया',
      'header.country.li.423.name': 'लिकटेंस्टीन',
      'header.country.lk.94.name': 'श्रीलंका',
      'header.country.lr.231.name': 'लाइबेरिया',
      'header.country.ls.266.name': 'लिसोटो',
      'header.country.lt.370.name': 'लिथुआनिया',
      'header.country.lu.352.name': 'लक्समबर्ग',
      'header.country.lv.371.name': 'लातविया',
      'header.country.ly.218.name': 'लीबिया',
      'header.country.ma.212.name': 'मोरक्को',
      'header.country.mc.377.name': 'मोनाको',
      'header.country.md.373.name': 'मोल्दोवा रिपब्लिक ',
      'header.country.me.382.name': 'मोंटेनेग्रो',
      'header.country.mf.590.name': 'संत मार्टिन',
      'header.country.mg.261.name': 'मादागास्कर',
      'header.country.mh.692.name': 'मार्शल आइलैंड ',
      'header.country.mk.389.name': 'मैसेडोनिया, पूर्व यूगोस्लाव गणराज्य',
      'header.country.ml.223.name': 'माली',
      'header.country.mm.95.name': 'म्यांमार',
      'header.country.mn.976.name': 'मंगोलिया',
      'header.country.mo.853.name': 'मकाओ',
      'header.country.mp.1.name': 'उत्तरी मरीयाना आइलैंड ',
      'header.country.mq.596.name': 'मार्टीनिक',
      'header.country.mr.222.name': 'मॉरिटानिया',
      'header.country.ms.1.name': 'मोंसेराट',
      'header.country.mt.356.name': 'माल्टा',
      'header.country.mu.230.name': 'मॉरीशस',
      'header.country.mv.960.name': 'मालदीव',
      'header.country.mw.265.name': 'मलावी',
      'header.country.mx.52.name': 'मेक्सिको',
      'header.country.my.60.name': 'मलेशिया',
      'header.country.mz.258.name': 'मोजाम्बिक',
      'header.country.na.264.name': 'नामीबिया',
      'header.country.nc.687.name': 'न्यू कैलेडोनिया',
      'header.country.ne.227.name': 'नाइजर',
      'header.country.nf.672.name': 'नॉरफ़ॉक आइलैंड्स',
      'header.country.ng.234.name': 'नाइजीरिया',
      'header.country.ni.505.name': 'निकारागुआ',
      'header.country.nl.31.name': 'नीदरलैंड',
      'header.country.no.47.name': 'नॉर्वे',
      'header.country.np.977.name': 'नेपाल',
      'header.country.nr.674.name': 'नाउरू',
      'header.country.nu.683.name': 'नियू',
      'header.country.nz.64.name': 'न्यूजीलैंड',
      'header.country.om.968.name': 'ओमान',
      'header.country.pa.507.name': 'पनामा',
      'header.country.pe.51.name': 'पेरू',
      'header.country.pf.689.name': 'फ्रेंच पॉलीनेशिया',
      'header.country.pg.675.name': 'पापुआ न्यू गिनी',
      'header.country.ph.63.name': 'फिलीपींस',
      'header.country.pk.92.name': 'पाकिस्तान',
      'header.country.pl.48.name': 'पोलैंड',
      'header.country.pm.508.name': 'सेंट पियर और मिकेलॉन',
      'header.country.pn.870.name': 'पिटकेर्न',
      'header.country.pr.1.name': 'प्यूर्टो रिको',
      'header.country.ps.970.name': 'फिलिस्तीन',
      'header.country.pt.351.name': 'पुर्तगाल',
      'header.country.pw.680.name': 'पालौ ',
      'header.country.py.595.name': 'पैरागुए ',
      'header.country.qa.974.name': 'क़तार ',
      'header.country.re.262.name': 'रियूनियन',
      'header.country.ro.40.name': 'रोमानिया',
      'header.country.rs.381.name': 'सर्बिया',
      'header.country.ru.7.name': 'रूसी संघ',
      'header.country.rw.250.name': 'रवांडा',
      'header.country.sa.966.name': 'सऊदी अरब',
      'header.country.sb.677.name': 'सोलोमन आइलैंडस',
      'header.country.sc.248.name': 'सेशेल',
      'header.country.se.46.name': 'स्वीडन',
      'header.country.sg.65.name': 'सिंगापुर',
      'header.country.sh.290.name': 'सेंट हेलेना, एसेंशन और ट्रिस्टन दा कुन्हा',
      'header.country.si.386.name': 'स्लोवेनिया',
      'header.country.sk.421.name': 'स्लोवाकिया',
      'header.country.sl.232.name': 'सियरा लिओन',
      'header.country.sm.378.name': 'सैन मैरीनो',
      'header.country.sn.221.name': 'सेनेगल',
      'header.country.so.252.name': 'सोमालिया',
      'header.country.sr.597.name': 'सूरीनाम',
      'header.country.st.239.name': 'साओ टोमे और प्रिंसिप',
      'header.country.sv.503.name': 'एल साल्वाडोर',
      'header.country.sx.1.name': 'सिंट मार्टेन',
      'header.country.sz.268.name': 'स्वाजीलैंड',
      'header.country.tc.1.name': 'तुर्क और कैकोज़ द्वीपसमूह',
      'header.country.td.235.name': 'चाड ',
      'header.country.tg.228.name': 'टोगो ',
      'header.country.th.66.name': 'थाईलैंड',
      'header.country.tj.992.name': 'तजिकिस्तान',
      'header.country.tk.690.name': 'टोकेलाऊ',
      'header.country.tl.670.name': 'तिमोर-लेस्त',
      'header.country.tm.993.name': 'तुर्कमेनिस्तान',
      'header.country.tn.216.name': 'ट्यूनीशिया',
      'header.country.to.676.name': 'टोंगा',
      'header.country.tr.90.name': 'तुर्की',
      'header.country.tt.1.name': 'त्रिनिदाद और टोबैगो',
      'header.country.tv.688.name': 'तुवालु',
      'header.country.tw.886.name': 'ताइवान',
      'header.country.tz.255.name': 'तंजानिया, संयुक्त गणराज्य',
      'header.country.ug.256.name': 'युगांडा',
      'header.country.us.1.name': 'संयुक्त राज्य अमेरिका',
      'header.country.uy.598.name': 'उरुग्वे',
      'header.country.uz.998.name': 'उज़्बेकिस्तान',
      'header.country.va.379.name': 'होली सी ',
      'header.country.vc.1.name': 'सेंट विंसेंट & amp; ग्रेनेडाइन',
      'header.country.ve.58.name': 'वेनेजुएला, बोलीविया गणराज्य',
      'header.country.vg.1.name': 'ब्रिटिश वर्जिन आइसलैण्ड्स',
      'header.country.vi.1.name': 'US वर्जिन आइलैंड ',
      'header.country.vn.84.name': 'वियतनाम',
      'header.country.vu.678.name': 'वानुअतु',
      'header.country.wf.681.name': 'वालीस और फ़्युटुना',
      'header.country.ws.685.name': 'समोआ',
      'header.country.xk.383.name': 'कोसोवो',
      'header.country.ye.967.name': 'यमन',
      'header.country.yt.262.name': 'मैयट',
      'header.country.za.27.name': 'दक्षिण अफ्रीका',
      'header.country.zm.260.name': 'जाम्बिया',
      'header.country.zw.263.name': 'जिम्बाब्वे',
      'header.TOP_COUNTRIES_LABEL': 'प्रमुख देश ',
      'header.OTHER_COUNTRIES_LABEL': 'अन्य देश',
      'header.switch.to.english.text': 'अंग्रेज़ी में देखें ',
      'header.hotels.message.for.arabic':
          'अरबी में होटल ब्राउज़ करने के लिए सपोर्ट जल्द आने वाला है',
      'header.please.proceed.text': 'हां, कृपया आगे बढ़ें',
      'header.cancel.text': 'कैंसिल करें ',
      'header.not.supporting.arabic':
          'अरबी में होटल ब्राउज़ करने के लिए सपोर्ट जल्द आने वाला है। हम आपको अंग्रेजी वेबसाइट पर स्विच कर  रहे हैं ',
      'header.ENGLISH': 'अंग्रेज़ी',
      'header.ARABIC': 'अरबी',
      'header.cancel.capitalised.text': 'कैंसिल करें ',
      'header.country.dropdown': {
        IN: 'भारत',
        AE: 'UAE',
        US: 'अमेरिका',
        KW: 'कुवैत',
        SA: 'सऊदी अरब',
        OM: 'ओमान',
      },
      'header.currency.text': 'मुद्रा',
      'header.country.text': 'देश',
      'header.language.text': 'भाषा',
      'header.available.in.arabic.text':
          "<span class='latoBold'>अब अरबी</span> में भी उपलब्ध है",
      'header.coming.soon.text': 'जल्द आ रहा है',
      'header.select.currency.text': 'मुद्रा चुनें',
      'header.select.language.text': 'भाषा चुनें ',
      'header.select.country.text': 'देश चुनें ',
      'header.apply.text': 'लागू करें',
      'header.manage.your.bookings.text': 'अपनी बुकिंग मैनेज करें',
    },
    FLIGHTS_UI_MESSAGES: {
      searchWidget: {
        tripType: {
          inputLabel: 'यात्रा प्रकार',
          options: {
            O: 'वन वे ',
            R: 'राउंड ट्रिप',
            M: 'मल्टी सिटी ',
          },
        },
        src: {
          inputLabel: 'कहां से',
          placeholder: 'शहर का नाम डालें ',
        },
        dest: {
          inputLabel: 'कहां तक ',
          placeholder: 'शहर का नाम डालें ',
        },
        departure: {
          inputLabel: 'प्रस्थान ',
        },
        return: {
          inputLabel: 'वापसी',
          placeholder: 'वापसी का चयन करें',
        },
        pnc: {
          inputLabel: 'यात्री और श्रेणी ',
          inputValues: {
            Adults: 'वयस्क',
            Travellers: 'यात्री',
            Adult: 'वयस्क',
            Traveller: 'यात्री',
            'Group Booking': 'ग्रुप बुकिंग',
          },
          options: {
            adults: {
              inputLabel: 'वयस्क (12 वर्ष से अधिक )',
              groupBookingTooltip: '9 से अधिक यात्रियों की बुकिंग पर बचत करें',
              ontheDayTravelText: 'की उम्र यात्रा के दिन प',
            },
            children: {
              inputLabel: 'बच्चे (2 से 12 वर्ष )',
              ontheDayTravelText: 'की उम्र यात्रा के दिन प',
            },
            infants: {
              inputLabel: 'शिशु  (2 वर्ष से कम )',
              ontheDayTravelText: 'की उम्र यात्रा के दिन प',
            },
            travelClass: {
              inputLabel: 'यात्रा श्रेणी चुनें',
              optionsLabels: {
                Economy: 'इकोनॉमी ',
                'Economy / Premium Economy': 'इकोनॉमी / प्रीमियम इकोनॉमी',
                'Premium Economy': 'प्रीमियम इकोनॉमी',
                Business: 'बिज़नेस ',
                'First Class': 'फर्स्ट क्लास ',
              },
            },
          },
          btnLabel: 'हो गया',
        },
        ctaButtonText: 'खोजें ',
        tripPrefix: 'यात्रा',
        addCityBtnText: '+ शहर जोड़ें',
        'SEARCH RESULTS': 'खोज के परिणाम',
        'NEARBY CITIES': 'आस पास के शहर',
        errMessages: {
          guestCount: 'कुल अतिथि 9 से अधिक नहीं हो सकते ',
          infantCount: 'शिशु वयस्कों से अधिक नहीं हो सकते',
          returnDate: 'कृपया वापसी की तिथि चुनें',
        },
      },
      searchLoadingMessage: 'रुकिए, हम आपके लिए उड़ानें ला रहे हैं',
      defaultErrorMessages: {
        NWE: {
          title: 'नेटवर्क की समस्या',
          subtitle:
              'हमारा सिस्टम आपके डिवाइस से कनेक्ट नहीं कर पा रहा है। कृपया थोड़ी देर बाद फिर प्रयास करें',
        },
        STREMPTY: {
          title: 'ओह!  कोई गलती हुई  है!',
          subtitle:
              'हम अपने सिस्टम से कनेक्ट करने में असमर्थ हैं। कृपया पेज को रीफ्रेश करें या थोड़ी देर बाद दुबारा प्रयास करें',
        },
        JSE: {
          title: 'ग्राहक सॉफ्टवेयर समस्या ',
          subtitle:
              'हम इसका हल शीघ्र निकालेंगे। कृपया थोड़ी देर में फिर प्रयास करें।',
        },
        DEFAULT: {
          title: 'ओह! पेज लोड करने में समस्या हुई ',
          subtitle:
              'हमारे सिस्टम में कोई समस्या हो रही है। हम इसे शीघ्र हल करने की कोशिश कर रहे हैं। कृपया पेज को ताज़ा करें या पिछले पेज पर वापस जाएँ',
        },
        rightCtaText: 'पेज रिफ्रेश करें ',
      },
      flightDetails: {
        title: 'उड़ान की डिटेल्स ',
        hideDtls: 'उड़ान की  डिटेल्स  छिपाएं',
        viewDtls: 'उड़ान की  डिटेल्स  देखें',
        baggageLabel: 'सामान',
        checkinLabel: 'चेक इन',
        cabinLabel: 'केबिन',
        tabs: {
          'FLIGHT DETAILS': 'उड़ान की डिटेल',
          'FARE SUMMARY': 'किराया सारांश',
          CANCELLATION: 'कैंसलेशन ',
          'DATE CHANGE': 'तिथि परिवर्तन ',
        },
        loaderText: 'डिटेल निकाल रहे हैं...',
        hideShowBtn: 'दिखाएं',
        notAvlText: 'जानकारी उपलब्ध नहीं है',
        exitText: 'निकास ',
      },
      flightsListing: {
        sorterTitle: 'क्रम आधार',
        bookNowCTAText: 'अभी बुक करें',
        multiFareHidePricesText: 'कीमतें छिपाएं',
        plusDayTemplate: '+ {{count}} दिन',
        loadersText: {
          selectingFlight: 'आपकी उड़ान सेलेक्ट हो रही है ',
          moreFaresSplit: 'आपके लिए अन्य किराए ला रहे हैं ...',
          moreFares: 'अन्य किराए ला रहे हैं ...',
          gettingFlights: 'रुकिए, हम उड़ानें खोज रहे हैं...',
          submitting: 'सबमिट हो रहा है...',
        },
        splitFooter: {
          fareDetailsText: 'किराए की डिटेल ',
        },
        mcTripTxt: 'ट्रिप {{index}}',
        otherFlightsHeading: 'अन्य उड़ानें',
        selectFareText: 'किराया चुनें',
        discountsTitle: {
          boldText: 'गरम',
          normalText: 'डील ',
        },
        hideShowTimingsOptions: {
          more: 'अन्य समय के ऑप्शन ',
          less: 'कम समय के ऑप्शन',
        },
      },
      flightsFilters: {
        FILTERED_OUT_TEXT: {
          TITLE: 'बहुत सारे फ़िल्टर लागू किए गए हैं!',
          DESC: 'आपके द्वारा लगाए सभी फ़िल्टरों के साथ हमें कोई उड़ान नहीं मिली। कुछ फ़िल्टर हटा कर प्रयास करें',
          OrText: 'या',
        },
        clearAllFiltersText: 'सभी फ़िल्टर हटाएं ',
        appliedFiltersText: 'लागू फ़िल्टर',
        clearAppliedFiltersText: 'सभी हटाएं',
        loadersText: {
          'Popular filters': 'लोकप्रिय फिल्टर',
          Price: 'कीमत',
          Departure: 'प्रस्थान',
          Airlines: 'एयरलाइंस',
          Arrival: 'आगमन ',
        },
      },
      flightsFiltersOld: {
        moreFiltersText: 'अन्य फ़िल्टर',
        resetBtnText: 'रीसेट',
        applyBtnText: 'लागू करें',
        cancelBtnText: 'कैंसिल ',
        moreAirlinesText: '+ {{count}} एयरलाइंस',
        FILTERED_OUT_TEXT: {
          TITLE: 'बहुत सारे फ़िल्टर लागू किए गए हैं!',
          DESC: 'फ़िल्टरों के एक अलग कॉम्बिनेशन से प्रयास करें।',
        },
        clearAllFiltersText: 'सभी फ़िल्टर हटाएं',
        mcFiltersTitle: 'फिल्टर',
      },
      reviewOnwardHeader: {
        pageNames: {
          'Review your booking': 'अपनी बुकिंग की समीक्षा करें',
          'Traveller & Addons': 'यात्री और अतिरिक्त सेवाएं ',
          'Booking Summary': 'बुकिंग सारांश',
        },
        timelineSteps: {
          flight: 'उड़ान चुन ली गई है',
          review: 'समीक्षा करें ',
          traveller: 'यात्री डिटेल ',
          itinerary: 'बुकिंग सारांश',
          pay: 'भुगतान करें ',
        },
      },
      itineraryTitle: 'यात्रा कार्यक्रम ',
      flightSummaryTitle: 'उड़ान सारांश',
      fareSummaryTitle: 'किराया सारांश',
      reviewLoaderTexts: {
        itLoaderText: 'डिटेल निकाल रहे हैं...',
        fareDetailsLoaderText: 'किराए की डिटेल ला रहे हैं ...',
        submitReviewLoaderText: 'समीक्षा सबमिट हो रही है',
        submitTravellerLoaderText: 'यात्री विवरण प्रस्तुत करना',
        layoverInfoLoaderText: 'विराम की जानकारी निकाल रहे हैं ...',
        headingLoaderText: '51 मिलियन उपयोगकर्ता और गिनती',
      },
      review: {
        continueCTA: 'जारी रखें',
        outOfPolicyTooltip: {
          title: 'महत्वपूर्ण',
        },
      },
      fareRules: {
        title: 'किराए के नियम',
        loaderText: 'किराए के नियम ला रहे हैं',
        noDataText: 'जानकारी उपलब्ध नहीं है',
        tabs: {
          'Cancellation Charges': 'कैंसलेशन शुल्क ',
          'Date change charges': 'तिथि परिवर्तन शुल्क',
        },
      },
      fastForward: {
        ctaText: 'हो गया',
        selectedTemplate: '{{fraction}} चुन लिया गया है ',
      },
      impInfo: {
        title: 'महत्वपूर्ण जानकारी',
      },
      addOnsHeading: 'ऐड-ऑन',
      coupons: {
        inputPlaceholder: 'कूपन कोड डालें',
        applyBtnText: 'लागू करें',
        removeBtnText: 'हटाएं ',
        'VIEW ALL OFFERS': 'सभी ऑफर देखें',
        'SHOW LESS': 'कम दिखाएं',
        OR: 'या',
        toastLinkText: 'ठीक है, समझ आ गया!',
      },
      travellerForm: {
        tags: {
          COMPLETE: 'पूरा है ',
          INCOMPLETE: 'अधूरा है ',
        },
        travellerTypes: {
          ADULT: 'वयस्क',
          CHILD: 'बच्चा ',
          INFANT: 'शिशु',
        },
        selectedTemplate: '{{ratio}} चुन लिया गया है',
        nameConfirmation: {
          title: 'नाम कन्फर्म करें ',
          fnLabel: 'पहला नाम',
          lnLabel: 'उपनाम',
          closeBtnText: 'हो गया ',
        },
        dateDropdownPlaceholders: {
          date: 'तिथि',
          month: 'महीना',
          year: 'वर्ष',
        },
        loaderText: {
          submitting: 'सबमिट हो रहा है...',
          selecting: 'सेलेक्ट कर रहे हैं...',
        },
        errMessage:
            'आपने पहले ही {{criteria}} चुन लिया है। नया जोड़ने से पहले उसे हटाएँ।',
      },
      flightDetailsText: 'उड़ान की डिटेल्स ',
      insurance: {
        editBtnText: 'एडिट करें ',
        showMoreText: 'और देखें ',
        showLessText: 'कम',
        daysInputPlaceholder: 'दिन डालें ',
        daysDoneCtaText: 'हो गया',
        toastLinkText: 'ठीक है, समझ आ गया!',
        benefitPrefix: ' भुगतान का दावा',
      },
      acknowledgement: {
        title: 'स्वीकृति',
        ctaBtnText: {
          createQuote: 'कोट बनाएं',
          continue: 'जारी रखें',
        },
      },
      ancillaries: {
        loaderText: {
          fetching: 'एंसीलरी और ऐड ऑन की जानकारी निकाल रहे हैं',
          updating: 'चुनी गई एंसीलरी अपडेट कर रहे हैं',
          submit: 'एंसीलरी डिटेल सबमिट हो रही है',
        },
        SKIP_TO_PAYMENT: 'भुगतान पर स्किप करें ',
        SKIP_ADD_ONS: 'ऐड ऑन स्किप करें',
        tabs: {
          Meals: 'भोजन',
          Seats: 'सीटें',
          Baggage: 'सामान',
        },
        addMealBtnText: 'जोड़ें ',
        flightSummaryText: 'उड़ान सारांश',
        continueBtnLabel: {
          next: 'अगला',
          continue: 'जारी रखें',
          nextSeats: 'अगला: सीटें',
          newFlowPreAttach: 'सीट कन्फर्म करें',
        },
        totalFareText: 'कुल किराया',
        clearSelectionOverlay: {
          title: 'क्या आपने निश्चय कर लिया है?',
          subTitle:
              'OK पर क्लिक करने से आपकी चुने हुए सभी सीट, भोजन और अतिरिक्त सामान हटा दिए जायेंगें।',
          rcaText: 'ठीक है',
          lcaText: 'कैंसिल ',
        },
        tooltip: {
          seatTaken: 'क्षमा करें, यह सीट ले ली गई है',
        },
      },
      thankyou: {
        loaderText: 'धन्यवाद की डिटेल निकाल रहे हैं ',
        hotelCrossSellTitle: 'अपनी होटल अभी बुक करें',
        hotelOffPercent: '{{offPercent}} प्रतिशत की छूट',
        refundBreakupText: 'रिफंड का ब्रेकअप ',
        fallBack: {
          title: 'आपकी बुकिंग हो रही है!',
          msg1: 'हमें खेद है कि इसमें सामान्य से अधिक समय लग रहा है, लेकिन आप चिंता न करें , हमें आपका भुगतान मिल गया है और आपकी बुकिंग हो रही है।',
          msg2: 'इसके कन्फर्म होते ही हम आपको सूचित करेंगे। आप मैनेज बुकिंग से भी स्थिति को ट्रैक कर सकते हैं।',
          ctaText: 'बुकिंग मैनेज करें ',
        },
      },
      utils: {
        MONTHS: [
          'जनवरी',
          'फरवरी',
          'मार्च',
          'अप्रैल',
          'मई',
          'जून',
          'जुलाई',
          'अगस्त',
          'सितंबर',
          'अक्टूबर',
          'नवंबर',
          'दिसंबर',
        ],
        DAYS: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        TIME: {
          hoursShort: 'h',
          minutesShort: 'm',
        },
        genericInputMessage: 'कृपया अंग्रेजी में टाइप करें ',
      },
      loginPopup: {
        b2b: {
          title: 'बधाई हो! आपने myBiz में लॉग इन किया है',
          subtitle:
              'myBiz उड़ानों पर किरायों का चुनाव, मुफ्त सुविधाएँ, GST का लाभ और बहुत कुछ पाएं ',
          leftCtaText: 'ठीक है',
        },
        ctaFlow: {
          title: 'बधाई हो! आपने एफिलिएट की तरह लॉग इन किया है।',
          subtitle: 'आपको होमपेज पर वापस ले जा रहे हैं',
          leftCtaText: 'ठीक है',
        },
      },
      logoutPopup: {
        b2b: {
          title: 'आपने लॉग आउट कर दिया है!',
          subtitle: 'हम आपको होमपेज पर ले जा रहे हैं, कृपया फिर से खोजें।',
          leftCtaText: 'ठीक है, समझ आ गया',
        },
        normalFlow: {
          title: 'आपने सफलतापूर्वक लॉग आउट कर लिया है',
          subtitle:
              'आपने लॉग आउट कर दिया है इसलिए भुगतान पेज पर आपका कुल किराया बदल सकता है। आपके रिवार्ड बोनस या अन्य ऑफ़र तभी लागू हो सकते हैं जब आप खाते में लॉग इन करके रखें।',
          leftCtaText: 'ठीक है, समझ आ गया',
        },
      },
      reviewDetails: {
        addBaggagePopup: {
          addText: 'जोड़ें ',
          footer: {
            addedPriceText: '(कुल किराए में जोड़ दिया गया है)',
            ctaText: 'हो गया',
          },
        },
      },
    },
    IF_DESTINATION_PICKER: {
      searchField: {
        tripType: 'यात्रा प्रकार',
        from: 'कहां से',
        to: 'कहां तक ',
        dateDuration: 'तिथियां और अवधि',
        departure: 'प्रस्थान',
        search: 'खोजें',
      },
      loaderTexts: {
        fareCalendarLoaderText: 'सबसे सस्ती उड़ानें निकाल रहे हैं ',
        flightSearchLoaderText: 'सबसे सस्ती उड़ानें निकाल रहे हैं ',
        mapLoaderText: 'गंतव्य लोड हो रहा है',
        listingLoaderHeader: 'गंतव्य लोड हो रहा है',
        sortText: 'क्रमाधार:',
        sortValue: 'कीमत',
        filtersLoaderText: {
          'Visa & Documents': 'वीज़ा और डॉक्यूमेंट',
          'Flight Duration': 'उड़ान की अवधि',
          Price: 'कीमत',
          'COVID Restrictions': 'कोविड के प्रतिबंध',
          Stops: 'स्टॉप ',
          'Popular Filters': 'लोकप्रिय फिल्टर',
        },
      },
    },
  },
  tam: {
    header: {
      'header.mmt.text': 'எம்.எம்.டி.',
      'header.black.text': 'கருப்பு',
      'header.loyalty.programme': 'விசுவாச திட்டம்',
      'header.double.black.text': 'DOUBLEBLACK',
      'header.free.cancellation.assured': 'இலவச ரத்து உறுதி',
      'header.biz.pending': 'நிலுவையில் உள்ளது',
      'header.biz.requests': 'கோரிக்கைகளை',
      'header.my.trips': 'எனது பயணங்கள்',
      'header.24x7': '24x7',
      'header.support': 'ஆதரவு',
      'header.introducing.myBiz': 'MyBiz ஐ அறிமுகப்படுத்துகிறது',
      'header.mmt.for.business': 'வணிகத்திற்கான MakeMyTrip',
      'header.welcome.message': 'ஏய் {firstName}',
      'header.login.or.create.account': 'உள்நுழைக அல்லது கணக்கை உருவாக்கவும்',
      'header.personal.text': 'தனிப்பட்ட',
      'header.myBiz.text': 'MYBIZ',
      'header.free.upgrade': 'இலவச மேம்படுத்தல்',
      'header.out.corporate.account': 'எங்கள் கார்ப்பரேட் கணக்கு',
      'header.corporate.fares': 'கார்ப்பரேட் கட்டணம்',
      'header.with.easy.modifications': 'எளிதான மாற்றங்களுடன்',
      'header.curated.hotels': 'நிர்வகிக்கப்பட்ட ஹோட்டல்கள்',
      'header.safety.text': 'பாதுகாப்பான மற்றும் சுகாதாரமான தங்குவதற்கு',
      'header.gst.invoice': 'ஜிஎஸ்டி விலைப்பட்டியல்',
      'header.assurance': 'உத்தரவாதம்',
      'header.signup.work.mail': 'பணி மின்னஞ்சலுடன் கையொப்பமிடுங்கள்',
      'header.know.more': 'மேலும் தெரிந்து கொள்ளுங்கள்',
      'header.about.myBiz': 'myBiz பற்றி.',
      'header.personal.profile.text':
          'உங்கள் தனிப்பட்ட சுயவிவரத்தைப் பார்க்கிறீர்கள் {email}',
      'header.myBiz.profile.text':
          'உங்கள் MyBiz சுயவிவரத்தைப் பார்க்கிறீர்கள் {email}',
      'header.my.trips.subtitle':
          'முன்பதிவு விவரங்கள், மின்-டிக்கெட்டை அச்சிடு, முன்பதிவை ரத்துசெய், முன்பதிவை மாற்றியமைத்தல், பணத்தைத் திருப்பிச் செலுத்தும் நிலை மற்றும் பலவற்றைக் காண்க.',
      'header.my.wallet': 'என் பணப்பை',
      'header.my.wallet.subtitle':
          'இன்னும் பெரிய தள்ளுபடியைப் பெற உங்கள் பணப்பையை பயன்படுத்தவும்',
      'header.my.mmt.black': 'எம்எம்டி பிளாக்',
      'header.my.mmt.black.subtitle':
          'உங்கள் செலவு பயணம், மைல்கற்கள் மற்றும் உரிமை வெகுமதிகளைக் காண்க!',
      'header.my.mmt.double.black': 'எம்எம்டி டபுள் பிளாக்',
      'header.my.mmt.double.black.inactive':
          'உங்கள் விமானம் மற்றும் ஹோட்டல் முன்பதிவுகளில் தொந்தரவு இல்லாத ரத்து செய்ய இப்போது வாங்கவும்',
      'header.my.mmt.double.black.active':
          'உங்கள் MMTDoubleBlack நன்மைகளைக் காண்க',
      'header.my.mmt.double.black.expired':
          'உங்கள் உறுப்பினர் காலாவதியானது, MMTDoubleBlack இன் நன்மைகளை தொடர்ந்து அனுபவிக்க புதுப்பிக்கவும்',
      'header.my.profile': 'என் சுயவிவரம்',
      'header.my.profile.subtitle':
          'உங்கள் சுயவிவரம், பயணிகளின் விவரங்கள், உள்நுழைவு விவரங்கள் மற்றும் கடவுச்சொல்லை நிர்வகிக்கவும்',
      'header.my.make.payment': 'பணம் செலுத்துங்கள்',
      'header.my.make.payment.subtitle':
          'நிலுவையில் உள்ள உங்கள் கொடுப்பனவுகளை இங்கே முடிக்கவும்',
      'header.logout.text': 'வெளியேறு',
      'header.login.signup.for.best.prices':
          'சிறந்த விலைகளுக்கான உள்நுழைவு / பதிவுபெறுதல்',
      'header.login.signup.text.cash':
          'உடனடியாக {currency} 555 சம்பாதிக்க உள்நுழை / பதிவுபெறு',
      'header.login.signup.easily.with': 'எளிதாக உள்நுழைக / கையொப்பமிடுங்கள்',
      'header.login.with.phone.email': 'தொலைபேசி / மின்னஞ்சல் மூலம் உள்நுழைக',
      'header.welcome.text': 'ஏய்',
      'header.traveller.text': 'பயணி',
      'header.login.success.message':
          'உள்நுழைவு வெற்றி! மொபைல் எண்ணை இணைக்க முடியவில்லை',
      'header.myBiz.login.message':
          'மைபிஸ் கணக்குகளுக்கான மொபைல் எண் வழியாக உள்நுழைவதை நாங்கள் இன்னும் ஆதரிக்கவில்லை. உங்கள் மின்னஞ்சல் மற்றும் கடவுச்சொல்லைப் பயன்படுத்தி உங்கள் கணக்கை தொடர்ந்து அணுகலாம்.',
      'header.mobile.number.linked.message':
          'இந்த கணக்கில் ஏற்கனவே இணைக்கப்பட்ட மொபைல் எண் உள்ளது, முதலில் இணைக்கப்பட்ட தொலைபேசி எண்ணை இணைக்க சுயவிவரப் பகுதியைப் பார்வையிட்டு மீண்டும் முயற்சிக்கவும்.',
      'header.move.back.text': 'மீண்டும்',
      'header.skip.text': 'தவிர்',
      'header.login.with.password': 'கடவுச்சொல்லுடன் உள்நுழைக',
      'header.login.signup.text': 'புகுபதிகை / பதிவு செய்தல்',
      'header.email.placeholder.text': 'மின்னஞ்சலை உள்ளிடவும்',
      'header.for.account.text': 'கணக்கிற்கு {username}',
      'header.email.or.mobile.placeholder.text':
          'மின்னஞ்சல் அல்லது மொபைல் எண்ணை உள்ளிடவும்',
      'header.email.label.text': 'மின்னஞ்சல்',
      'header.email.or.mobile.label.text': 'மின்னஞ்சல் அல்லது மொபைல் எண்',
      'header.continue.text': 'தொடரவும்',
      'header.login.with.text': 'அல்லது உள்நுழைக',
      'header.company.login.portal.text': 'கம்பனி லோகின் போர்டல்',
      'header.login.to.myBiz.account':
          'உங்கள் MyBiz கணக்கில் உள்நுழைய உங்கள் நிறுவனத்தின் நற்சான்றுகளைப் பயன்படுத்தலாம்.',
      'header.login.text': 'உள்நுழைய',
      'header.login.via.otp': 'அல்லது OTP வழியாக உள்நுழைக',
      'header.otp.on.mail.message': 'நீங்கள் மின்னஞ்சலில் OTP ஐப் பெறுவீர்கள்',
      'header.login.signup.with.text': 'அல்லது உள்நுழைக / பதிவுபெறு',
      'header.no.myBiz.account.message': 'மைபிஸ் கணக்கு இல்லையா?',
      'header.create.account.here.message': 'இங்கே ஒரு கணக்கை உருவாக்கவும்',
      'header.saving.on.business.travel.message':
          'உங்கள் வணிக பயணத்தில் சேமிக்கத் தொடங்குங்கள்',
      'header.personal.account.text': 'தனிப்பட்ட கணக்கு',
      'header.myBiz.account.text': 'மைபிஸ் கணக்கு',
      'header.reset.password.text': 'கடவுச்சொல்லை மீட்டமைக்க',
      'header.mobile.not.registered.text': 'மொபைல் எண் என்று தெரிகிறது',
      'header.mobile.not.registered.action.text':
          'MakeMyTrip இல் பதிவு செய்யப்படவில்லை, அடுத்து என்ன செய்ய விரும்புகிறீர்கள்?',
      'header.create.personal.account.message':
          'இந்த மொபைல் எண்ணுடன் புதிய தனிப்பட்ட கணக்கை உருவாக்கவும்',
      'header.link.existing.account': 'ஏற்கனவே உள்ள கணக்குடன் இணைக்கவும்',
      'header.link.user.to.existing.account':
          'ஏற்கனவே உள்ள கணக்குடன் {displayUserName} ஐ இணைக்கவும்',
      'header.dismiss.text': 'நிராகரி',
      'header.account.already.exists.message':
          '{accountType} கணக்கு ஏற்கனவே உள்ளது',
      'header.registered.account.action.message':
          'மின்னஞ்சல் ஐடியுடன் ஏற்கனவே பதிவுசெய்யப்பட்ட {accountType} கணக்கில் உள்நுழைய முயற்சிக்கிறீர்கள் என்று தெரிகிறது: {username}, அடுத்து நீங்கள் என்ன செய்ய விரும்புகிறீர்கள்?',
      'header.login.with.email': 'Login to {accountType} with this Email ID',
      'header.create.new.account':
          'Create a New {accountType} Account with {username}',
      'header.get.otp.for.mobile.login':
          'மொபைல் எண்ணுடன் உள்நுழைய OTP ஐப் பெறுக',
      'header.access.myBiz.account':
          'நிறுவனத்தின் உள்நுழைவுடன் myBiz ஐ அணுகவும்',
      'header.company.registered.myBiz.account':
          'தனிப்பட்ட மின்னஞ்சல் ஐடியுடன் உங்கள் நிறுவனம் உங்களுக்காக ஒரு மைபிஸ் கணக்கை ஏற்கனவே பதிவு செய்திருப்பதை நாங்கள் காண்கிறோம்: {பயனர்பெயர்}, அடுத்து நீங்கள் என்ன செய்ய விரும்புகிறீர்கள்?',
      'header.login.myBiz.with.company.portal':
          'நிறுவனத்தின் உள்நுழைவு போர்ட்டலுடன் myBiz இல் உள்நுழைக',
      'header.password.placeholder.text': 'குறைந்தபட்சம் 6 எழுத்துக்கள்.',
      'header.password.text': 'கடவுச்சொல்',
      'header.remember.me.text': 'என்னை நினைவில் வையுங்கள்',
      'header.agent.id.text': 'முகவர் ஐடி',
      'header.enter.mobile.number.text': 'மொபைல் எண்ணை உள்ளிடவும்',
      'header.send.otp.text': 'OTP ஐ அனுப்பவும்',
      'header.verify.mobile.number.title': 'மொபைல் எண்ணைச் சரிபார்க்கவும்',
      'header.verify.mobile.number.subtitle':
          'தொடர, உங்கள் மொபைல் எண்ணை சரிபார்க்கவும்',
      'header.and.word.text': 'மற்றும்',
      'header.or.use.text': 'அல்லது பயன்படுத்தவும்',
      'header.create.account.with': 'அல்லது கணக்கை உருவாக்கவும்',
      'header.resend.otp.text': 'OTP ஐ மீண்டும் அனுப்பு',
      'header.verify.text': 'சரிபார்க்கவும்',
      'header.otp.text': 'OTP',
      'header.enter.otp.sent.to.text': 'அனுப்பப்பட்ட OTP ஐ உள்ளிடவும்',
      'header.add.mobile.number.text': 'உங்கள் மொபைல் எண்ணைச் சேர்க்க.',
      'header.enter.myBiz.account.password':
          'MyBiz கணக்கு கடவுச்சொல்லை உள்ளிடவும்',
      'header.create.account.text': 'உங்கள் கணக்கை துவங்குங்கள்',
      'header.signup.agree.text':
          'பதிவுபெறுவதன் மூலம், நீங்கள் ஒப்புக்கொள்கிறீர்கள்',
      'header.terms.and.conditions.text': 'விதிமுறைகள் மற்றும் நிபந்தனைகள்',
      'header.email.or.phone.placeholder':
          'மின்னஞ்சல் அல்லது தொலைபேசி எண் உள்ளிடவும்.',
      'header.password.same.message':
          "உங்கள் தனிப்பட்ட கணக்கு கடவுச்சொல் MyBiz கணக்கு <span class='latoBold'>(abhinav.mittal@go-mmt.com)</span> கடவுச்சொல்லாக இருக்கும்",
      'header.create.personal.account.text':
          'புதிய தனிப்பட்ட கணக்கை உருவாக்கவும்',
      'header.enter.username.for.linking.mobile':
          'உங்கள் மொபைல் எண் {displayUserName} உடன் இணைக்க விரும்பும் கணக்கின் பயனர்பெயரை உள்ளிடவும்.',
      'header.continue.text.capitalized': 'தொடருங்கள்',
      'header.login.via.password.text': 'அல்லது கடவுச்சொல் வழியாக உள்நுழைக',
      'header.verify.emailId.message': 'உங்கள் மின்னஞ்சல் ஐடியை சரிபார்க்கவும்',
      'header.verify.mobile.message': 'உங்கள் மொபைல் எண்ணை சரிபார்க்கவும்',
      'header.enter.otp.on.email.text':
          'உள்நுழைய {username} க்கு அனுப்பப்பட்ட OTP அல்லது உங்கள் பதிவு செய்யப்பட்ட மின்னஞ்சல் ஐடியை உள்ளிடவும்',
      'header.enter.otp.on.mobile.text':
          'உள்நுழைய {username} க்கு அனுப்பப்பட்ட OTP அல்லது உங்கள் பதிவு செய்யப்பட்ட மொபைல் எண்ணை உள்ளிடவும்',
      'header.enter.otp.sent.to.username.text':
          'உள்நுழைய {username} க்கு அனுப்பப்பட்ட OTP ஐ உள்ளிடவும்',
      'header.login.to.your.account.text': 'உங்கள் கணக்கில் உள்நுழைய.',
      'header.reset.the.password.text': 'கடவுச்சொல்லை மீட்டமைக்க.',
      'header.to.continue.text': 'தொடர.',
      'header.send.reset.otp.on.email.mobile':
          'உங்கள் பதிவு செய்யப்பட்ட மின்னஞ்சல் ஐடி அல்லது மொபைல் எண்ணில் மீட்டமைப்பு OTP ஐ உங்களுக்கு அனுப்புவோம்',
      'header.send.reset.otp.on.email':
          'உங்கள் பதிவு செய்யப்பட்ட மின்னஞ்சல் ஐடியில் மீட்டமை OTP ஐ உங்களுக்கு அனுப்புவோம்',
      'header.register.email.or.mobile.text':
          'பதிவு செய்யப்பட்ட மின்னஞ்சல் அல்லது மொபைல் எண்',
      'header.register.email.text': 'பதிவு செய்யப்பட்ட மின்னஞ்சல்',
      'header.username.not.exist.message': 'இந்த பயனர்பெயர் இல்லை.',
      'header.trying.to.create.new.account':
          'நீங்கள் ஒரு புதிய $ {accountType} கணக்கை உருவாக்க முயற்சிக்கிறீர்கள் என்றால்',
      'header.google.business.account.text': 'Google வணிக கணக்கு',
      'header.new.password.text': 'புதிய கடவுச்சொல்',
      'header.create.new.password.text': 'புதிய கடவுச்சொல்லை உருவாக்கவும்',
      'header.new.password.validations.text':
          'குறைந்தபட்சம் 8 எழுத்துக்கள் நீளமாக இருக்க வேண்டும் மற்றும் குறைந்தது ஒரு எழுத்துக்கள், ஒரு எண் மற்றும் ஒரு சிறப்பு எழுத்துக்குறி இருக்க வேண்டும் @ $!% * #? &',
      'header.redirect.to.login.text': 'உள்நுழையச் செல்லவும்',
      'header.password.changed.successfully.message':
          'கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது',
      'header.do.not.share.password.message':
          'தவறாகப் பயன்படுத்துவதைத் தடுக்க, உங்கள் கடவுச்சொல்லை யாருடனும் பகிர வேண்டாம்.',
      'header.login.successful.message': 'உள்நுழைவு வெற்றிகரமாக',
      'header.A.letter.text': 'அ',
      'header.successful.logged.in.message':
          'உங்கள் கணக்கில் வெற்றிகரமாக உள்நுழைந்துள்ளீர்கள்',
      'header.account.creation.unsuccessful': 'கணக்கு உருவாக்கம் தோல்வியுற்றது',
      'header.account.creation.unsuccessful.message':
          'மொபைல் எண் சரிபார்ப்பு தோல்வியுற்றதால் உங்கள் கணக்கை எங்களால் உருவாக்க முடியவில்லை.',
      'header.continue.creating.account': 'கணக்கை உருவாக்குவதைத் தொடருங்கள்',
      'header.reset.your.password.text': 'உங்கள் கடவுச்சொல்லை மீட்டமைக்க',
      'header.enter.otp.sent.text': 'அனுப்பப்பட்ட OTP ஐ உள்ளிடவும்',
      'header.verify.and.link.account': 'சரிபார்க்க மற்றும் கணக்கோடு இணைக்க',
      'header.enter.otp.placeholder': 'OTP ஐ உள்ளிடவும்',
      'header.create.next.account.text': 'புதிய கணக்கை உருவாக்க',
      'header.already.a.member.text': 'ஏற்கனவே உறுப்பினரா?',
      'header.verify.number.and.create.account':
          'எண்ணைச் சரிபார்த்து கணக்கை உருவாக்கவும்',
      'header.login.myBiz.with.email':
          'இந்த மின்னஞ்சல் ஐடியுடன் myBiz இல் உள்நுழைக',
      'header.already.registered.email.message':
          'மின்னஞ்சல் ஐடியுடன் ஏற்கனவே பதிவுசெய்யப்பட்ட எனது பிஸ் கணக்கில் பதிவுபெற முயற்சிக்கிறீர்கள் என்று தெரிகிறது: {username}, அடுத்து நீங்கள் என்ன செய்ய விரும்புகிறீர்கள்?',
      'header.myBiz.account.exists': 'ஒரு MyBiz கணக்கு ஏற்கனவே உள்ளது',
      'header.congratulations.message': 'வாழ்த்துக்கள்!',
      'header.account.created.successfully':
          'கணக்கு வெற்றிகரமாக உருவாக்கப்பட்டது',
      'header.save.and.continue.text': 'சேமித்து தொடரவும்',
      'header.save.and.verify.mobile.text':
          'மொபைல் எண்ணைச் சேமித்து சரிபார்க்கவும்',
      'header.account.created.successfully.message':
          'வாழ்த்துக்கள்! உங்கள் கணக்கு வெற்றிகரமாக உருவாக்கப்பட்டது! சிறந்த விலைகளைப் பெற நீங்கள் இப்போது முன்பதிவு செய்யலாம்.',
      'header.unlocked.bonus.reward.message':
          'வாழ்த்துக்கள்! போனஸ் வெகுமதியை வெற்றிகரமாக திறந்துள்ளீர்கள்',
      'header.wallet.money.rewarded': '555 பணப்பை பணம்',
      'header.verify.and.create.account': 'கணக்கை சரிபார்த்து உருவாக்குங்கள்',
      'header.verify.and.link.account.text': 'கணக்கு சரிபார்க்கவும்',
      'header.incorrect.otp.entered.text':
          'தவறான OTP நுழைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.',
      'header.enter.otp.label': 'OTP ஐ உள்ளிடவும்',
      'header.enter.otp.here.placeholder': 'OTP ஐ இங்கே உள்ளிடவும்',
      'header.numeric.validation': 'ஒரு எண்ணாக இருக்க வேண்டும்',
      'header.min.characters.validation': 'Must be {min} characters or more',
      'header.max.characters.validation': 'Must be {max} characters or less',
      'header.min.value.validation': 'Must be at least {min}',
      'header.email.format.message':
          "மின்னஞ்சல் ஐடி 'abc@xyz.com' வடிவத்தில் இருக்க வேண்டும்",
      'header.aol.email.message':
          'அப்படியா? உங்கள் மின்னஞ்சலுக்கு நீங்கள் இன்னும் AOL ஐப் பயன்படுத்துகிறீர்களா?',
      'header.alphanumeric.validation': 'எண்ணெழுத்து எழுத்துக்கள் மட்டுமே',
      'header.mobile.number.validation':
          'தவறான தொலைபேசி எண், 10 இலக்கங்களாக இருக்க வேண்டும்',
      'header.required.validation': 'தேவை',
      'header.privacy.policy.text': 'தனியுரிமைக் கொள்கை',
      'header.user.agreement.text': 'பயனர் ஒப்பந்தம்',
      'header.terms.of.service.text': 'சேவை விதிமுறைகள்',
      'header.invalid.phone.number': 'தவறான தொலைபேசி எண்',
      'header.your.username.message': 'இது உங்கள் பயனர்பெயராக இருக்கும்',
      'header.otp.verification.completed':
          'மொபைல் எண்ணைப் பயன்படுத்தி கணக்கு உருவாக்கப்படும் போது <b>OTP சரிபார்ப்பு</b> செய்யப்படுகிறது',
      'header.click.here.text': 'இங்கே கிளிக் செய்க',
      'header.attempting.login.text':
          'நீங்கள் உள்நுழைய முயற்சிக்கிறீர்கள் என்றால்.',
      'header.enter.password.placeholder': 'கடவுச்சொல்லை உள்ளிடவும்',
      'header.enter.work.email': 'உங்கள் பணி மின்னஞ்சல் ஐடியை உள்ளிடவும்',
      'header.agreement.text.on.mmt':
          'தொடர்வதன் மூலம், மேக்மைட்ரிப்ஸை ஒப்புக்கொள்கிறீர்கள்',
      'header.policy.text': 'தனியுரிமை',
      'header.login.expired': 'உள்நுழைவு காலாவதியானது',
      'header.click.to.login.again':
          "கவலைப்பட தேவையில்லை! பயனர்களின் கணக்கை சிறப்பாகப் பாதுகாக்க நாங்கள் தவறாமல் வெளியேறுகிறோம். <a className='latoBold'>மீண்டும் உள்நுழைய இங்கே கிளிக்</a> செய்து MMT அனுபவத்தை அனுபவிக்கவும்.",
      'header.signup.with.facebook': 'பேஸ்புக் மூலம் பதிவுபெறுக',
      'header.login.with.facebook': 'பேஸ்புக் மூலம் உள்நுழைக',
      'header.signup.with.google': 'Google உடன் பதிவுபெறுக',
      'header.login.with.google': 'Google உடன் உள்நுழைக',
      'header.login.or.signup.message': 'புகுபதிகை / பதிவு செய்தல்',
      'header.work.email.text': 'வேலை மின்னஞ்சல்',
      'header.verification.successful.text': 'சரிபார்ப்பு வெற்றிகரமாக',
      'header.mobile.number.verified.message':
          'வாழ்த்துக்கள்! உங்கள் மொபைல் எண் {பயனர்பெயர் வெற்றிகரமாக சரிபார்க்கப்பட்டது மற்றும் {emailId account கணக்கில் இணைக்கப்பட்டுள்ளது',
      'header.cruise': 'குரூஸ்',
      'header.new.text': 'புதியது',
      'header.admin.text': 'நிர்வாகம்',
      'header.FLIGHTS': 'விமானங்கள்',
      'header.CHARTER_FLIGHTS': 'சார்ட்டர் விமானங்கள்',
      'header.CHARTER_FLIGHTS_CLASS': 'சார்ட்டர் ஃப்ளைட்கள்',
      'header.HOTELS': 'ஹோட்டல்',
      'header.HOLIDAYS': 'விடுமுறை',
      'header.BUSES': 'பேருந்துகள்',
      'header.CABS': 'வண்டிகள்',
      'header.BIZ_CABS': 'விமான நிலைய வண்டிகள்',
      'header.TRAINS': 'ரயில்கள்',
      'header.GIFTCARDS': 'பரிசு அட்டைகள்',
      'header.MORE': 'மேலும்',
      'header.LOGIN_AGENT': 'முகவர் உள்நுழைவு',
      'header.MMT_LOGO_ALT': 'MMT இன் லோகோ',
      'header.ACTIVE': 'செயலில்',
      'header.IN_YOUR_WALLET': 'உங்கள் பணப்பையில்',
      'header.YOUR_WALLET': 'உங்கள் பணப்பை',
      'header.LOGIN_OR': 'உள்நுழைக அல்லது',
      'header.CREATE_ACCOUNT_TEXT': 'உங்கள் கணக்கை துவங்குங்கள்',
      'header.MY_BIZ': 'என் பிஸ்',
      'header.INT_FLIGHT': 'சர்வதேச விமானங்கள்',
      'header.INT_HOTEL': 'சர்வதேச ஹோட்டல்கள்',
      'header.REFER_EARN': 'பார்க்கவும் சம்பாதிக்கவும்',
      'header.BLOG': 'வலைப்பதிவு',
      'header.Deals': 'ஒப்பந்தங்கள்',
      'header.VENUES': 'இடங்கள்',
      'header.ADMIN_SITE': 'நிர்வாகம்',
      'header.HOME_STAYS': 'வில்லாஸ் & ஆப்ட்ஸ்',
      'header.HOME_STAYS_CLASS': 'ஹோம்ஸ்டேஸ்',
      'header.VISA': 'விசா',
      'header.MICE': 'எலிகள்',
      'header.TRIP_IDEAS': 'பயண ஆலோசனைகள்',
      'header.LOGIN_ENTER_VALID_EMAIL_ERROR_MESSAGE':
          'செல்லுபடியாகும் மின்னஞ்சல் ஐடி அல்லது மொபைல் எண்ணை உள்ளிடவும்.',
      'header.LOGIN_ENTER_VALID_AGENT_ERROR_MESSAGE':
          'செல்லுபடியாகும் முகவர் ஐடியை உள்ளிடவும்.',
      'header.LOGIN_ENTER_VALID_ONLY_EMAIL_ERROR_MESSAGE':
          'செல்லுபடியாகும் மின்னஞ்சலை உள்ளிடவும்.',
      'header.LOGIN_ENTER_PASSWORD_ERROR_MESSAGE': 'கடவுச்சொல்லை உள்ளிடவும்.',
      'header.LOGIN_ENTER_VALID_PASSWORD_ERROR_MESSAGE':
          'கடவுச்சொல் 6 எழுத்துகளுக்கு குறைவாக இருக்கக்கூடாது.',
      'header.LOGIN_ENTER_VALID_OTP_ERROR_MESSAGE':
          'செல்லுபடியாகும் OTP ஐ உள்ளிடவும்',
      'header.SIGNUP_ENTER_VALID_CHARACTER_PASSWORD_ERROR_MESSAGE':
          'கடவுச்சொல்லில் குறைந்தபட்சம் 8 எழுத்துக்கள் இருக்க வேண்டும் மற்றும் குறைந்தது ஒரு எழுத்துக்கள், ஒரு எண் மற்றும் ஒரு சிறப்பு எழுத்துக்குறி இருக்க வேண்டும் @ $!% * #? &',
      'header.OTP_LOGIN_VALID_OTP_ERROR':
          'தவறான OTP! உங்களுக்கு வழங்கப்பட்ட OTP ஐ உள்ளிடவும்.',
      'header.LOGIN_ACCOUNT_BLOCKED_ERROR_MESSAGE':
          'உள்நுழைவு முயற்சிகளின் அதிகபட்ச வரம்பை நீங்கள் கடந்துவிட்டீர்கள். பின்னர் மீண்டும் முயற்சிக்கவும்',
      'header.LOGIN_INCORRECT_EMAIL_PASSWORD_ERROR_MESSAGE':
          'பயனர்பெயர் அல்லது கடவுச்சொல் தவறானது.',
      'header.LOGIN_DEFAULT_ERROR_MESSAGE':
          'நாங்கள் சில தொழில்நுட்ப சிக்கல்களை எதிர்கொள்கிறோம் போல் தெரிகிறது, தயவுசெய்து சிறிது நேரத்தில் மீண்டும் முயற்சிக்கவும்.',
      'header.FORGOT_PASSWORD_USER_NOT_EXISTS_ERROR_MESSAGE':
          'பயனர்பெயர் இல்லை, செல்லுபடியாகும் மின்னஞ்சல் ஐடி அல்லது மொபைல் எண்ணை உள்ளிடவும்',
      'header.FORGOT_PASSWORD_DEFAULT_ERROR_MESSAGE':
          'ஏதோ தவறு ஏற்பட்டது, தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
      'header.VERIFY_OTP_LIMIT_CROSSED_ERROR_MESSAGE':
          'OTP முயற்சிகளை அனுப்புவதற்கான அதிகபட்ச வரம்பை நீங்கள் கடந்துவிட்டீர்கள். பின்னர் மீண்டும் முயற்சிக்கவும்',
      'header.VERIFY_OTP_INCORRECT_OTP_ERROR_MESSAGE':
          'தவறான OTP, மீண்டும் முயற்சிக்கவும்',
      'header.FORGOT_PASSWORD_OTP_INVALID_TOKEN_ERROR_MESSAGE':
          'தவறான OTP, மீண்டும் முயற்சிக்கவும்',
      'header.FORGOT_PASSWORD_OTP_DEFAULT_ERROR_MESSAGE':
          'ஏதோ தவறு ஏற்பட்டது, தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
      'header.FORGOT_PASSWORD_OTP_INCORRECT_OTP_ERROR_MESSAGE':
          'தவறான OTP, மீண்டும் முயற்சிக்கவும்',
      'header.LOGIN_CREDENTIALS_EXPIRED_ERROR_MESSAGE':
          'உங்கள் கடவுச்சொல் காலாவதியானது. உங்கள் கடவுச்சொல்லை மீட்டமைக்க கடவுச்சொல்லை மீட்டமை என்பதைக் கிளிக் செய்க.',
      'header.PLACEHOLDER_COUNTRY_CODE': 'நாட்டின் பெயர் அல்லது குறியீடு',
      'header.NOT_VALID_USER':
          'இந்த மின்னஞ்சல் ஐடியுடன் தனிப்பட்ட கணக்கு எதுவும் இல்லை',
      'header.ACCOUNT_ALREADY_LINKED':
          'இந்த கணக்கில் ஏற்கனவே ஒரு தொலைபேசி எண் தொடர்புடையது',
      'header.PROCEED_TO_LOGIN_MSG':
          'தொடர்வதன் மூலம், மேக்மைட்ரிப்ஸை ஒப்புக்கொள்கிறீர்கள்',
      'header.TOS_MSG': 'டி & சி',
      'header.PRIVACY_POLICY_MSG': 'தனியுரிமைக் கொள்கை',
      'header.USER_AGREEMENT_MSG': 'பயனர் ஒப்பந்தம்',
      'header.PHONE_NUMBER_ALREADY_LINKED':
          'தொலைபேசி எண் மற்றொரு கணக்குடன் தொடர்புடையது.',
      'header.GOOGLE_ERROR': 'Google உள்நுழைவு தோல்வியுற்றது',
      'header.FB_ERROR': 'பேஸ்புக் உள்நுழைவு தோல்வியுற்றது',
      'header.NO_MATCH_FOUND': 'எந்த பொருத்தமும் கிடைக்கவில்லை',
      'header.facebook.text': 'முகநூல்',
      'header.google.text': 'கூகிள்',
      'header.enter.fullname.text': 'முழு பெயரை உள்ளிடவும்',
      'header.enter.valid.name.message': 'சரியான பெயரை உள்ளிடவும்',
      'header.incorrect.format.message': 'தவறான வடிவம்',
      'header.invalid.phone.number.message': 'தவறான தொலைபேசி எண்',
      'header.enter.full.name.placeholder': 'உங்கள் முழு பெயரை உள்ளிடவும்',
      'header.country.ad.376.name': 'அன்டோரா',
      'header.country.ae.971.name': 'ஐக்கிய அரபு நாடுகள்',
      'header.country.af.93.name': 'ஆப்கானிஸ்தான்',
      'header.country.ag.1.name': 'ஆன்டிகுவா மற்றும் பார்புடா',
      'header.country.ai.1.name': 'அங்குவிலா',
      'header.country.al.355.name': 'அல்பேனியா',
      'header.country.am.374.name': 'ஆர்மீனியா',
      'header.country.ao.244.name': 'அங்கோலா',
      'header.country.aq.672.name': 'அண்டார்டிகா',
      'header.country.ar.54.name': 'அர்ஜென்டினா',
      'header.country.as.1.name': 'அமெரிக்கன் சமோவா',
      'header.country.at.43.name': 'ஆஸ்திரியா',
      'header.country.au.61.name': 'ஆஸ்திரேலியா',
      'header.country.aw.297.name': 'அருபா',
      'header.country.az.358.name': 'ஆலண்ட் தீவுகள்',
      'header.country.az.994.name': 'அஜர்பைஜான்',
      'header.country.ba.387.name': 'போஸ்னியா மற்றும் ஹெர்சகோவினா',
      'header.country.bb.1.name': 'பார்படாஸ்',
      'header.country.bd.880.name': 'பங்களாதேஷ்',
      'header.country.be.32.name': 'பெல்ஜியம்',
      'header.country.bf.226.name': 'புர்கினா பாசோ',
      'header.country.bg.359.name': 'பல்கேரியா',
      'header.country.bh.973.name': 'பஹ்ரைன்',
      'header.country.bi.257.name': 'புருண்டி',
      'header.country.bj.229.name': 'பெனின்',
      'header.country.bl.590.name': 'செயிண்ட் பார்தலேமி',
      'header.country.bm.1.name': 'பெர்முடா',
      'header.country.bn.673.name': 'புருனே தாருஸ்ஸலாம்',
      'header.country.bo.591.name': 'பொலிவியா, ப்ளூரினேஷனல் ஸ்டேட் ஆஃப்',
      'header.country.br.55.name': 'பிரேசில்',
      'header.country.bs.1.name': 'பஹாமாஸ்',
      'header.country.bt.975.name': 'பூட்டான்',
      'header.country.bw.267.name': 'போட்ஸ்வானா',
      'header.country.by.375.name': 'பெலாரஸ்',
      'header.country.bz.501.name': 'பெலிஸ்',
      'header.country.ca.1.name': 'கனடா',
      'header.country.cc.61.name': 'கோகோஸ் தீவுகள்',
      'header.country.cd.243.name': 'காங்கோ, ஜனநாயக குடியரசு',
      'header.country.cf.236.name': 'மத்திய ஆப்பிரிக்க குடியரசு',
      'header.country.cg.242.name': 'காங்கோ',
      'header.country.ch.41.name': 'சுவிட்சர்லாந்து',
      'header.country.ci.225.name': "கோட் டி 'ஐவோரி",
      'header.country.ck.682.name': 'குக் தீவுகள்',
      'header.country.cl.56.name': 'சிலி',
      'header.country.cm.237.name': 'கேமரூன்',
      'header.country.cn.86.name': 'சீனா',
      'header.country.co.57.name': 'கொலம்பியா',
      'header.country.cr.506.name': 'கோஸ்ட்டா ரிக்கா',
      'header.country.cv.238.name': 'கேப் வெர்டே',
      'header.country.cx.61.name': 'கிறிஸ்துமஸ் தீவு',
      'header.country.cy.357.name': 'சைப்ரஸ்',
      'header.country.cz.420.name': 'செ குடியரசு',
      'header.country.de.49.name': 'ஜெர்மனி',
      'header.country.dj.253.name': 'ஜிபூட்டி',
      'header.country.dk.45.name': 'டென்மார்க்',
      'header.country.dm.1.name': 'டொமினிகா',
      'header.country.do.1.name': 'டொமினிக்கன் குடியரசு',
      'header.country.dz.213.name': 'அல்ஜீரியா',
      'header.country.ec.593.name': 'ஈக்வடார்',
      'header.country.ee.372.name': 'எஸ்டோனியா',
      'header.country.eg.20.name': 'எகிப்து',
      'header.country.er.291.name': 'எரித்திரியா',
      'header.country.es.34.name': 'ஸ்பெயின்',
      'header.country.et.251.name': 'எத்தியோப்பியா',
      'header.country.fi.358.name': 'பின்லாந்து',
      'header.country.fj.679.name': 'பிஜி',
      'header.country.fk.500.name': 'பால்க்லேண்ட் தீவுகள்',
      'header.country.fm.691.name': 'மைக்ரோனேஷியா, கூட்டாட்சி நாடுகள்',
      'header.country.fo.298.name': 'ஃபாரோ தீவுகள்',
      'header.country.fr.33.name': 'பிரான்ஸ்',
      'header.country.ga.241.name': 'காபோன்',
      'header.country.gb.44.name': 'ஐக்கிய இராச்சியம்',
      'header.country.gd.1.name': 'கிரெனடா',
      'header.country.ge.995.name': 'ஜார்ஜியா',
      'header.country.gf.594.name': 'பிரஞ்சு கயானா',
      'header.country.gh.233.name': 'கானா',
      'header.country.gi.350.name': 'ஜிப்ரால்டர்',
      'header.country.gl.299.name': 'கிரீன்லாந்து',
      'header.country.gm.220.name': 'காம்பியா',
      'header.country.gn.224.name': 'கினியா',
      'header.country.gp.450.name': 'குவாதலூப்',
      'header.country.gq.240.name': 'எக்குவடோரியல் கினியா',
      'header.country.gr.30.name': 'கிரீஸ்',
      'header.country.gt.502.name': 'குவாத்தமாலா',
      'header.country.gu.1.name': 'குவாம்',
      'header.country.gw.245.name': 'கினியா-பிசாவு',
      'header.country.gy.592.name': 'கயானா',
      'header.country.hk.852.name': 'ஹாங்காங்',
      'header.country.hn.504.name': 'ஹோண்டுராஸ்',
      'header.country.hr.385.name': 'குரோஷியா',
      'header.country.ht.509.name': 'ஹைட்டி',
      'header.country.hu.36.name': 'ஹங்கேரி',
      'header.country.id.62.name': 'இந்தோனேசியா',
      'header.country.ie.353.name': 'அயர்லாந்து',
      'header.country.il.972.name': 'இஸ்ரேல்',
      'header.country.im.44.name': 'ஐல் ஆஃப் மேன்',
      'header.country.is.354.name': 'ஐஸ்லாந்து',
      'header.country.in.91.name': 'இந்தியா',
      'header.country.io.246.name': 'பிரிட்டிஷ் இந்தியப் பெருங்கடல் பகுதி',
      'header.country.iq.964.name': 'ஈராக்',
      'header.country.it.39.name': 'இத்தாலி',
      'header.country.je.44.name': 'ஜெர்சி',
      'header.country.jm.1.name': 'ஜமைக்கா',
      'header.country.jo.962.name': 'ஜோர்டான்',
      'header.country.jp.81.name': 'ஜப்பான்',
      'header.country.ke.254.name': 'கென்யா',
      'header.country.kg.996.name': 'கிர்கிஸ்தான்',
      'header.country.kh.855.name': 'கம்போடியா',
      'header.country.ki.686.name': 'கிரிபதி',
      'header.country.km.269.name': 'கொமொரோஸ்',
      'header.country.kn.1.name': 'செயிண்ட் கிட்ஸ் மற்றும் நெவிஸ்',
      'header.country.kr.82.name': 'தென் கொரியா',
      'header.country.kw.965.name': 'குவைத்',
      'header.country.ky.1.name': 'கெய்மன் தீவுகள்',
      'header.country.kz.7.name': 'கஜகஸ்தான்',
      'header.country.la.856.name': 'லாவோ மக்கள் ஜனநாயக குடியரசு',
      'header.country.lb.961.name': 'லெபனான்',
      'header.country.lc.1.name': 'செயிண்ட் லூசியா',
      'header.country.li.423.name': 'லிச்சென்ஸ்டீன்',
      'header.country.lk.94.name': 'இலங்கை',
      'header.country.lr.231.name': 'லைபீரியா',
      'header.country.ls.266.name': 'லெசோதோ',
      'header.country.lt.370.name': 'லிதுவேனியா',
      'header.country.lu.352.name': 'லக்சம்பர்க்',
      'header.country.lv.371.name': 'லாட்வியா',
      'header.country.ly.218.name': 'லிபியா',
      'header.country.ma.212.name': 'மொராக்கோ',
      'header.country.mc.377.name': 'மொனாக்கோ',
      'header.country.md.373.name': 'மோல்டோவா, குடியரசு',
      'header.country.me.382.name': 'மாண்டினீக்ரோ',
      'header.country.mf.590.name': 'செயிண்ட் மார்ட்டின்',
      'header.country.mg.261.name': 'மடகாஸ்கர்',
      'header.country.mh.692.name': 'மார்ஷல் தீவுகள்',
      'header.country.mk.389.name': 'மாசிடோனியா, முன்னாள் யூகோஸ்லாவிய குடியரசு',
      'header.country.ml.223.name': 'மாலி',
      'header.country.mm.95.name': 'மியான்மர்',
      'header.country.mn.976.name': 'மங்கோலியா',
      'header.country.mo.853.name': 'மக்காவோ',
      'header.country.mp.1.name': 'வடக்கு மரியானா தீவுகள்',
      'header.country.mq.596.name': 'மார்டினிக்',
      'header.country.mr.222.name': 'மவுரித்தேனியா',
      'header.country.ms.1.name': 'மொன்செராட்',
      'header.country.mt.356.name': 'மால்டா',
      'header.country.mu.230.name': 'மொரீஷியஸ்',
      'header.country.mv.960.name': 'மாலத்தீவுகள்',
      'header.country.mw.265.name': 'மலாவி',
      'header.country.mx.52.name': 'மெக்சிகோ',
      'header.country.my.60.name': 'மலேசியா',
      'header.country.mz.258.name': 'மொசாம்பிக்',
      'header.country.na.264.name': 'நமீபியா',
      'header.country.nc.687.name': 'புதிய கலிடோனியா',
      'header.country.ne.227.name': 'நைஜர்',
      'header.country.nf.672.name': 'நோர்போக் தீவுகள்',
      'header.country.ng.234.name': 'நைஜீரியா',
      'header.country.ni.505.name': 'நிகரகுவா',
      'header.country.nl.31.name': 'நெதர்லாந்து',
      'header.country.no.47.name': 'நோர்வே',
      'header.country.np.977.name': 'நேபாளம்',
      'header.country.nr.674.name': 'ந uru ரு',
      'header.country.nu.683.name': 'நியு',
      'header.country.nz.64.name': 'நியூசிலாந்து',
      'header.country.om.968.name': 'ஓமான்',
      'header.country.pa.507.name': 'பனாமா',
      'header.country.pe.51.name': 'பெரு',
      'header.country.pf.689.name': 'பிரெஞ்சு பாலினேசியா',
      'header.country.pg.675.name': 'பப்புவா நியூ கினி',
      'header.country.ph.63.name': 'பிலிப்பைன்ஸ்',
      'header.country.pk.92.name': 'பாகிஸ்தான்',
      'header.country.pl.48.name': 'போலந்து',
      'header.country.pm.508.name': 'செயிண்ட் பியர் மற்றும் மிகுவலன்',
      'header.country.pn.870.name': 'பிட்காயின்',
      'header.country.pr.1.name': 'புவேர்ட்டோ ரிக்கோ',
      'header.country.ps.970.name': 'பாலஸ்தீனம்',
      'header.country.pt.351.name': 'போர்ச்சுகல்',
      'header.country.pw.680.name': 'பலாவ்',
      'header.country.py.595.name': 'பராகுவே',
      'header.country.qa.974.name': 'கத்தார்',
      'header.country.re.262.name': 'ரியூனியன்',
      'header.country.ro.40.name': 'ருமேனியா',
      'header.country.rs.381.name': 'செர்பியா',
      'header.country.ru.7.name': 'இரஷ்ய கூட்டமைப்பு',
      'header.country.rw.250.name': 'ருவாண்டா',
      'header.country.sa.966.name': 'சவூதி அரேபியா',
      'header.country.sb.677.name': 'சாலமன் தீவுகள்',
      'header.country.sc.248.name': 'சீஷெல்ஸ்',
      'header.country.se.46.name': 'சுவீடன்',
      'header.country.sg.65.name': 'சிங்கப்பூர்',
      'header.country.sh.290.name':
          'செயிண்ட் ஹெலினா, அசென்ஷன் மற்றும் டிரிஸ்டன் டா குன்ஹா',
      'header.country.si.386.name': 'ஸ்லோவேனியா',
      'header.country.sk.421.name': 'ஸ்லோவாக்கியா',
      'header.country.sl.232.name': 'சியரா லியோன்',
      'header.country.sm.378.name': 'சான் மரினோ',
      'header.country.sn.221.name': 'செனகல்',
      'header.country.so.252.name': 'சோமாலியா',
      'header.country.sr.597.name': 'சுரினேம்',
      'header.country.st.239.name': 'சாவோ டோம் மற்றும் பிரின்சிபி',
      'header.country.sv.503.name': 'எல் சல்வடோர்',
      'header.country.sx.1.name': 'சிண்ட் மார்டன்',
      'header.country.sz.268.name': 'ஸ்வாசிலாந்து',
      'header.country.tc.1.name': 'டர்க்ஸ் மற்றும் கைகோஸ் தீவுகள்',
      'header.country.td.235.name': 'சாட்',
      'header.country.tg.228.name': 'போவதற்கு',
      'header.country.th.66.name': 'தாய்லாந்து',
      'header.country.tj.992.name': 'தஜிகிஸ்தான்',
      'header.country.tk.690.name': 'டோகேலாவ்',
      'header.country.tl.670.name': 'திமோர்-லெஸ்டே',
      'header.country.tm.993.name': 'துர்க்மெனிஸ்தான்',
      'header.country.tn.216.name': 'துனிசியா',
      'header.country.to.676.name': 'டோங்கா',
      'header.country.tr.90.name': 'துருக்கி',
      'header.country.tt.1.name': 'டிரினிடாட் & ஆம்ப்; டொபாகோ',
      'header.country.tv.688.name': 'துவாலு',
      'header.country.tw.886.name': 'தைவான்',
      'header.country.tz.255.name': 'தான்சானியா, யுனைடெட் குடியரசு',
      'header.country.ug.256.name': 'உகாண்டா',
      'header.country.us.1.name': 'அமெரிக்கா',
      'header.country.uy.598.name': 'உருகுவே',
      'header.country.uz.998.name': 'உஸ்பெகிஸ்தான்',
      'header.country.va.379.name': 'ஹோலி சீ',
      'header.country.vc.1.name': 'செயிண்ட் வின்சென்ட் & ஆம்ப்; கிரெனடைன்ஸ்',
      'header.country.ve.58.name': 'வெனிசுலா, பொலிவரிய குடியரசு',
      'header.country.vg.1.name': 'பிரிட்டிஷ் விர்ஜின் தீவுகள்',
      'header.country.vi.1.name': 'யு.எஸ். விர்ஜின் தீவுகள்',
      'header.country.vn.84.name': 'வியட்நாம்',
      'header.country.vu.678.name': 'வனடு',
      'header.country.wf.681.name': 'வாலிஸ் மற்றும் ஃபுட்டுனா',
      'header.country.ws.685.name': 'சமோவா',
      'header.country.xk.383.name': 'கொசோவோ',
      'header.country.ye.967.name': 'ஏமன்',
      'header.country.yt.262.name': 'மயோட்',
      'header.country.za.27.name': 'தென்னாப்பிரிக்கா',
      'header.country.zm.260.name': 'சாம்பியா',
      'header.country.zw.263.name': 'ஜிம்பாப்வே',
      'header.TOP_COUNTRIES_LABEL': 'சிறந்த நாடுகள்',
      'header.OTHER_COUNTRIES_LABEL': 'மற்ற நாடுகளில்',
      'header.switch.to.english.text': 'ஆங்கிலத்திற்கு மாறவும்',
      'header.hotels.message.for.arabic':
          'அரபு மொழியில் ஹோட்டல்களை உலாவுவதற்கான ஆதரவு விரைவில் வரும்',
      'header.please.proceed.text': 'ஆம் தயவுசெய்து தொடரவும்',
      'header.cancel.text': 'ரத்துசெய்',
      'header.not.supporting.arabic':
          'அரபு மொழியில் ஹோட்டல்களை உலாவுவதற்கான ஆதரவு விரைவில் வரும். நாங்கள் உங்களை ஆங்கில வலைத்தளத்திற்கு மாற்றுவோம்',
      'header.ENGLISH': 'ஆங்கிலம்',
      'header.ARABIC': 'அராபிக்',
      'header.cancel.capitalised.text': 'ரத்துசெய்',
      'header.country.dropdown': {
        IN: 'இந்தியா',
        AE: 'ஐக்கிய அரபு அமீரகம்',
        US: 'எங்களுக்கு',
      },
    },
    FLIGHTS_UI_MESSAGES: {
      searchWidget: {
        tripType: {
          inputLabel: 'TRIP TYPE',
          options: {
            O: 'ஒரு வழி',
            R: 'சுற்று பயணம்',
            M: 'மல்டி சிட்டி',
          },
        },
        src: {
          inputLabel: 'FROM',
          placeholder: 'நகரத்தை உள்ளிடவும்',
        },
        dest: {
          inputLabel: 'TO',
          placeholder: 'நகரத்தை உள்ளிடவும்',
        },
        departure: {
          inputLabel: 'புறப்படு',
        },
        return: {
          inputLabel: 'திரும்பவும்',
          placeholder: 'திரும்புவதைத் தேர்ந்தெடுக்கவும்',
        },
        pnc: {
          inputLabel: 'PASSENGERS & CLASS',
          inputValues: {
            Adults: 'பெரியவர்கள்',
            Travellers: 'பயணிகள்',
            Adult: 'பெரியவர்',
            Traveller: 'பயணி',
            'Group Booking': 'குழு முன்பதிவு',
          },
          options: {
            adults: {
              inputLabel: 'பெரியவர்கள் (12y +)',
              groupBookingTooltip:
                  '9 க்கும் அதிகமான பயணிகளுடன் புக்கிங்கில் சேமியுங்கள்',
              ontheDayTravelText: 'பயண நாளில்',
            },
            children: {
              inputLabel: 'குழந்தைகள் (2y - 12y)',
              ontheDayTravelText: 'பயண நாளில்',
            },
            infants: {
              inputLabel: 'INFANTS (2y க்கு கீழே)',
              ontheDayTravelText: 'பயண நாளில்',
            },
            travelClass: {
              inputLabel: 'பயண வகுப்பைத் தேர்வுசெய்க',
              optionsLabels: {
                Economy: 'பொருளாதாரம்',
                'Economy / Premium Economy':
                    'பொருளாதாரம் / பிரீமியம் பொருளாதாரம்',
                'Premium Economy': 'பிரீமியம் பொருளாதாரம்',
                Business: 'வணிக',
                'First Class': 'முதல் வகுப்பு',
              },
            },
          },
          btnLabel: 'முடிந்தது',
        },
        ctaButtonText: 'தேடல்',
        tripPrefix: 'TRIP',
        addCityBtnText: '+ நகரத்தைச் சேர்',
        'SEARCH RESULTS': 'தேடல் முடிவுகள்',
        'NEARBY CITIES': 'அருகிலுள்ள நகரங்கள்',
        errMessages: {
          guestCount: 'மொத்த விருந்தினர் எண்ணிக்கை 9 ஐ தாண்டக்கூடாது',
          infantCount:
              'குழந்தைகளின் எண்ணிக்கை வயது வந்தோரின் எண்ணிக்கையை விட அதிகமாக இருக்கக்கூடாது',
        },
      },
      searchLoadingMessage:
          'இருங்கள், நாங்கள் உங்களுக்காக விமானங்களைப் பெறுகிறோம்',
      defaultErrorMessages: {
        NWE: {
          title: 'வலையமைப்பு பிரச்சனை',
          subtitle:
              'உங்கள் சாதனத்திலிருந்து எங்கள் கணினிகளுடன் இணைக்க முடியவில்லை. சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்',
        },
        JSE: {
          title: 'வாடிக்கையாளர் மென்பொருள் விதிவிலக்கு',
          subtitle:
              'இந்த அசாப்பை நாங்கள் தீர்ப்போம். சிறிது நேரத்தில் மீண்டும் முயற்சிக்கவும்.',
        },
        DEFAULT: {
          title: 'அச்சச்சோ! பக்கத்தை ஏற்றுவதில் சிக்கல் ஏற்பட்டது',
          subtitle:
              'எங்கள் அமைப்புகள் சிக்கலை எதிர்கொள்கின்றன. அதை விரைவில் தீர்க்கும் பணியில் ஈடுபட்டுள்ளோம். தயவுசெய்து பக்கத்தைப் புதுப்பிக்கவும் அல்லது முந்தைய பக்கத்திற்குச் செல்லவும்',
        },
        rightCtaText: 'புதுப்பிப்பு',
      },
      flightDetails: {
        title: 'விமான விவரங்கள்',
        baggageLabel: 'பேக்கேஜ்:',
        checkinLabel: 'சரிபார்க்கவும்',
        cabinLabel: 'கேபின்',
        tabs: {
          'FLIGHT DETAILS': 'விமான விவரங்கள்',
          'FARE SUMMARY': 'FARE SUMMARY',
          CANCELLATION: 'ரத்து',
          'DATE CHANGE': 'தேதி மாற்றம்',
        },
        loaderText: 'விவரங்களைப் பெறுதல் ...',
        hideShowBtn: 'காட்டு',
        notAvlText: 'தகவல் கிடைக்கவில்லை',
      },
      flightsListing: {
        sorterTitle: 'வரிசைப்படுத்தியது:',
        bookNowCTAText: 'பதிவு',
        multiFareHidePricesText: 'விலைகளை மறைக்க',
        plusDayTemplate: '+ {{count}} நாள்',
        loadersText: {
          selectingFlight: 'உங்கள் விமானத்தைத் தேர்ந்தெடுக்கிறது ...',
          moreFaresSplit: 'உங்களுக்காக அதிக கட்டணம் பெறுவது ...',
          moreFares: 'அதிக கட்டணம் பெறுதல் ...',
          gettingFlights: 'இருங்கள், நாங்கள் விமானங்களைப் பெறுகிறோம் ..',
          submitting: 'சமர்ப்பித்தல் ...',
        },
        splitFooter: {
          fareDetailsText: 'கட்டணம் விவரங்கள்',
        },
        mcTripTxt: 'பயணம் {{index}}',
        otherFlightsHeading: 'பிற விமானங்கள்',
        selectFareText: 'கட்டணம் என்பதைத் தேர்ந்தெடுக்கவும்',
        discountsTitle: {
          boldText: 'சூடாக',
          normalText: 'ஒப்பந்தங்கள்',
        },
        hideShowTimingsOptions: {
          more: 'மேலும் நேர விருப்பங்கள்',
          less: 'குறைந்த நேர விருப்பங்கள்',
        },
      },
      flightsFilters: {
        FILTERED_OUT_TEXT: {
          TITLE: 'பல வடிப்பான்கள் பயன்படுத்தப்பட்டன!',
          DESC: 'நீங்கள் தேர்ந்தெடுத்த எல்லா வடிப்பான்களிலும் எந்த விமானங்களையும் எங்களால் கண்டுபிடிக்க முடியவில்லை. சில வடிப்பான்களை அகற்ற முயற்சிக்கவும்',
          OrText: 'அல்லது',
        },
        clearAllFiltersText: 'எல்லா வடிப்பான்களையும் அழிக்கவும்',
        appliedFiltersText: 'பயன்பாட்டு வடிப்பான்கள்',
        clearAppliedFiltersText: 'அனைத்தையும் அழி',
        loadersText: {
          'Popular filters': 'பிரபலமான வடிப்பான்கள்',
          Price: 'விலை',
          Departure: 'புறப்படுதல்',
          Airlines: 'விமான நிறுவனங்கள்',
          Arrival: 'வருகை',
        },
      },
      flightsFiltersOld: {
        moreFiltersText: 'மேலும் வடிப்பான்கள்',
        resetBtnText: 'மீட்டமை',
        applyBtnText: 'விண்ணப்பிக்கவும்',
        cancelBtnText: 'ரத்துசெய்',
        moreAirlinesText: '+ {{count}} விமான நிறுவனங்கள்',
        FILTERED_OUT_TEXT: {
          TITLE: 'பல வடிப்பான்கள் பயன்படுத்தப்பட்டன!',
          DESC: 'வடிப்பான்களின் வேறுபட்ட கலவையை முயற்சிக்கவும்.',
        },
        clearAllFiltersText: 'எல்லா வடிப்பான்களையும் அழிக்கவும்',
        mcFiltersTitle: 'வடிப்பான்கள்:',
      },
      reviewOnwardHeader: {
        pageNames: {
          'Review your booking': 'உங்கள் முன்பதிவை மதிப்பாய்வு செய்யவும்',
          'Traveller & Addons': 'பயணி & துணை நிரல்கள்',
          'Booking Summary': 'முன்பதிவு சுருக்கம்',
        },
        timelineSteps: {
          flight: 'விமானம் தேர்ந்தெடுக்கப்பட்டது',
          review: 'விமர்சனம்',
          traveller: 'பயணி விவரங்கள்',
          itinerary: 'முன்பதிவு சுருக்கம்',
          pay: 'பணம் கட்டு',
        },
      },
      itineraryTitle: 'பயணம்',
      flightSummaryTitle: 'விமான சுருக்கம்',
      fareSummaryTitle: 'கட்டணம் சுருக்கம்',
      reviewLoaderTexts: {
        itLoaderText: 'விவரங்களைப் பெறுதல் ...',
        fareDetailsLoaderText: 'கட்டண விவரங்களைப் பெறுகிறது ...',
        submitReviewLoaderText: 'மதிப்பாய்வை சமர்ப்பித்தல்',
        submitTravellerLoaderText: 'பயணி விவரங்களை சமர்ப்பித்தல்',
        layoverInfoLoaderText: 'தளவமைப்பு தகவல்களைப் பெறுகிறது ...',
        headingLoaderText: '51 மில்லியன் பயனர்கள் மற்றும் எண்ணிக்கை',
      },
      review: {
        continueCTA: 'தொடரவும்',
        outOfPolicyTooltip: {
          title: 'முக்கியமான',
        },
      },
      fareRules: {
        title: 'கட்டணம் விதிகள்',
        loaderText: 'கட்டணம் விதிகள் பெறுதல்',
        noDataText: 'தகவல் கிடைக்கவில்லை',
        tabs: {
          'Cancellation Charges': 'ரத்துசெய்யும் கட்டணங்கள்',
          'Date change charges': 'தேதி மாற்ற கட்டணங்கள்',
        },
      },
      fastForward: {
        ctaText: 'முடிந்தது',
        selectedTemplate: '{{fraction}} தேர்ந்தெடுக்கப்பட்டது',
      },
      impInfo: {
        title: 'முக்கிய தகவல்',
      },
      addOnsHeading: 'துணை நிரல்கள்',
      coupons: {
        inputPlaceholder: 'கூப்பன் குறியீட்டை உள்ளிடவும்',
        applyBtnText: 'விண்ணப்பிக்கவும்',
        removeBtnText: 'அகற்று',
        'VIEW ALL OFFERS': 'எல்லா சலுகைகளையும் காண்க',
        'SHOW LESS': 'குறைவாகக் காட்டு',
        OR: 'அல்லது',
        toastLinkText: 'சரி, கிடைத்தது!',
      },
      travellerForm: {
        tags: {
          COMPLETE: 'முழுமை',
          INCOMPLETE: 'முழுமையற்றது',
        },
        travellerTypes: {
          ADULT: 'வயது வந்தோர்',
          CHILD: 'குழந்தை',
          INFANT: 'குழந்தை',
        },
        selectedTemplate: '{{ratio}} தேர்ந்தெடுக்கப்பட்டது',
        nameConfirmation: {
          title: 'பெயர் உறுதிப்படுத்தல்',
          fnLabel: 'முதல் பெயர்:',
          lnLabel: 'கடைசி பெயர்:',
          closeBtnText: 'முடிந்தது',
        },
        dateDropdownPlaceholders: {
          date: 'தேதி',
          month: 'மாதம்',
          year: 'ஆண்டு',
        },
        loaderText: {
          submitting: 'சமர்ப்பித்தல் ...',
          selecting: 'தேர்ந்தெடுக்கும் ...',
        },
        errMessage:
            'You have already selected {{criteria}}. Remove before adding a new one.',
      },
      flightDetailsText: 'விமான விவரங்கள்',
      insurance: {
        editBtnText: 'தொகு',
        showMoreText: 'மேலும்',
        showLessText: 'குறைவாக',
        daysInputPlaceholder: 'நாட்களின் எண்ணிக்கையை உள்ளிடவும்',
        daysDoneCtaText: 'முடிந்தது',
        toastLinkText: 'சரி, கிடைத்தது!',
        benefitPrefix: 'வரை உரிமை கோருங்கள்',
      },
      acknowledgement: {
        title: 'ஒப்புதல்',
        ctaBtnText: {
          createQuote: 'மேற்கோளை உருவாக்கவும்',
          continue: 'தொடரவும்',
        },
      },
      ancillaries: {
        loaderText: {
          fetching: 'துணை மற்றும் கூடுதல் தகவல்களைப் பெறுதல்',
          updating: 'தேர்ந்தெடுக்கப்பட்ட துணை புதுப்பித்தல்',
          submit: 'துணை விவரங்களை சமர்ப்பித்தல்',
        },
        SKIP_TO_PAYMENT: 'கட்டணம் செலுத்துவதற்கு தவிர்',
        SKIP_ADD_ONS: 'ஸ்கிப் சேர்-ஓன்ஸ்',
        tabs: {
          Meals: 'உணவு',
          Seats: 'இருக்கைகள்',
          Baggage: 'சாமான்கள்',
        },
        addMealBtnText: 'கூட்டு',
        flightSummaryText: 'விமான சுருக்கம்',
        continueBtnLabel: {
          next: 'அடுத்தது',
          continue: 'தொடரவும்',
          nextSeats: 'அடுத்து: இருக்கைகள்',
          newFlowPreAttach: 'சீட் (எஸ்) உறுதிப்படுத்தவும்',
        },
        totalFareText: 'மொத்த கட்டணம்',
        clearSelectionOverlay: {
          title: 'நீ சொல்வது உறுதியா ?',
          subTitle:
              'சரி என்பதைக் கிளிக் செய்வதன் மூலம், உங்கள் இருக்கை, உணவு மற்றும் கூடுதல் சாமான்கள் தேர்வு அனைத்தும் நிராகரிக்கப்படும்.',
          rcaText: 'சரி',
          lcaText: 'ரத்துசெய்',
        },
        tooltip: {
          seatTaken: 'மன்னிக்கவும், இந்த இருக்கை எடுக்கப்பட்டுள்ளது',
        },
      },
      thankyou: {
        loaderText: 'நன்றி விவரங்களைப் பெறுதல்',
        hotelCrossSellTitle: 'உங்கள் ஹோட்டலை இப்போது முன்பதிவு செய்யுங்கள்',
        hotelOffPercent: '{{offPercent}} சதவீதம் தள்ளுபடி',
        refundBreakupText: 'பணத்தைத் திரும்பப் பெறுதல்',
        fallBack: {
          title: 'உங்கள் முன்பதிவு நடந்து கொண்டிருக்கிறது!',
          msg1: 'மன்னிக்கவும், இது வழக்கத்தை விட அதிக நேரம் எடுக்கும், ஆனால் கவலைப்பட வேண்டாம் நாங்கள் உங்கள் கட்டணத்தை பெற்றுள்ளோம், உங்கள் முன்பதிவு செயல்பாட்டில் உள்ளது.',
          msg2: 'அது உறுதிசெய்யப்பட்டவுடன் நாங்கள் உங்களுக்கு அறிவிப்போம். நிர்வகித்தல் முன்பதிவு வழியாக நீங்கள் நிலையைக் கண்காணிக்கலாம்.',
          ctaText: 'முன்பதிவை நிர்வகிக்கவும்',
        },
      },
      utils: {
        MONTHS: [
          'ஜன',
          'பிப்',
          'மார்',
          'ஏப்ரல்',
          'மே',
          'ஜூன்',
          'ஜூலை',
          'ஆக',
          'செப்',
          'அக்',
          'நவ',
          'டிச',
        ],
        DAYS: [
          'திங்கள்',
          'செவ்வாய்',
          'திருமணம் செய்',
          'து',
          'வெள்ளி',
          'சனி',
          'சூரியன்',
        ],
        TIME: {
          hoursShort: 'h',
          minutesShort: 'மீ',
        },
        genericInputMessage: 'ஆங்கிலத்தில் தட்டச்சு செய்யுமாறு கோருகிறேன்',
      },
      loginPopup: {
        b2b: {
          title: 'வாழ்த்துக்கள்! நீங்கள் எனது பிஸில் உள்நுழைந்துள்ளீர்கள்.',
          subtitle:
              'மைபிஸ் விமானங்களில் கட்டணங்கள், இலவச வசதிகள் *, ஜிஎஸ்டி சலுகைகள் மற்றும் இன்னும் பலவற்றை அனுபவிக்கவும்',
          leftCtaText: 'சரி',
        },
        ctaFlow: {
          title: 'வாழ்த்துக்கள்! நீங்கள் ஒரு இணைப்பாக உள்நுழைந்துள்ளீர்கள்.',
          subtitle: 'நீங்கள் முகப்புப்பக்கத்திற்கு திருப்பி விடப்படுகிறீர்கள்',
          leftCtaText: 'சரி',
        },
      },
      logoutPopup: {
        b2b: {
          title: 'நீங்கள் வெளியேரிவிட்டிர்கள்!',
          subtitle:
              'நாங்கள் உங்களை முகப்புப்பக்கத்திற்கு அழைத்துச் செல்கிறோம், தயவுசெய்து மீண்டும் தேடுங்கள்.',
          leftCtaText: 'சரி, கிடைத்தது',
        },
        normalFlow: {
          title: 'நீங்கள் வெற்றிகரமாக வெளியேறிவிட்டீர்கள்',
          subtitle:
              'நீங்கள் வெளியேறியதால், கட்டணம் பக்கத்தில் உங்கள் மொத்த கட்டணம் மாறக்கூடும். இது உங்கள் வெகுமதி போனஸ் அல்லது வேறு எந்த சலுகையும் காரணமாக இருக்கலாம், இது உங்கள் உள்நுழைந்த கணக்கில் மட்டுமே பொருந்தும்.',
          leftCtaText: 'சரி, கிடைத்தது',
        },
      },
    },
  },
  pan: {
    header: {
      'header.mmt.text': 'ਐਮ.ਐਮ.ਟੀ.',
      'header.black.text': 'ਕਾਲਾ',
      'header.loyalty.programme': 'ਵਫਾਦਾਰੀ ਪ੍ਰੋਗਰਾਮ',
      'header.double.black.text': 'ਡਬਲਬਲਕ',
      'header.free.cancellation.assured': 'ਮੁਫਤ ਰੱਦ ਕਰਨ ਦਾ ਬੀਮਾ',
      'header.biz.pending': 'ਬਕਾਇਆ',
      'header.biz.requests': 'ਬੇਨਤੀ',
      'header.my.trips': 'ਮੇਰੀਆਂ ਯਾਤਰਾਵਾਂ',
      'header.24x7': '24x7',
      'header.support': 'ਸਹਿਯੋਗ',
      'header.introducing.myBiz': 'ਮਾਈਬਿਜ਼ ਪੇਸ਼ ਕਰ ਰਿਹਾ ਹਾਂ',
      'header.mmt.for.business': 'ਵਪਾਰ ਲਈ ਮੇਕਮਾਈਟਰਿਪ',
      'header.welcome.message': 'Hey {firstName}',
      'header.login.or.create.account': 'ਲੌਗਇਨ ਕਰੋ ਜਾਂ ਖਾਤਾ ਬਣਾਓ',
      'header.personal.text': 'ਵਿਅਕਤੀਗਤ',
      'header.myBiz.text': 'ਮਾਈਬੀਬੀਜ਼',
      'header.free.upgrade': 'ਵਿੱਚ ਮੁਫਤ ਅਪਗ੍ਰੇਡ',
      'header.out.corporate.account': 'ਸਾਡਾ ਕਾਰਪੋਰੇਟ ਖਾਤਾ',
      'header.corporate.fares': 'ਕਾਰਪੋਰੇਟ ਕਿਰਾਏ',
      'header.with.easy.modifications': 'ਆਸਾਨ ਤਬਦੀਲੀਆਂ ਦੇ ਨਾਲ',
      'header.curated.hotels': 'ਕਯੂਰੇਟਡ ਹੋਟਲਜ਼',
      'header.safety.text': 'ਸੁਰੱਖਿਅਤ ਅਤੇ ਹਾਈਜੀਨਿਕ ਸਟੈਸ ਲਈ',
      'header.gst.invoice': 'ਜੀਐਸਟੀ ਚਲਾਨ',
      'header.assurance': 'ਭਰੋਸਾ',
      'header.signup.work.mail': 'ਕੰਮ ਦੇ ਨਾਲ ਸਾਈਨ ਅਪ ਕਰੋ',
      'header.know.more': 'ਹੋਰ ਜਾਣੋ',
      'header.about.myBiz': 'ਮਾਈਬਿਜ਼ ਬਾਰੇ.',
      'header.personal.profile.text':
          'ਤੁਸੀਂ ਆਪਣਾ ਨਿੱਜੀ ਪ੍ਰੋਫਾਈਲ {email} ਦੇਖ ਰਹੇ ਹੋ',
      'header.myBiz.profile.text':
          'ਤੁਸੀਂ ਆਪਣਾ ਮਾਈਬਿਜ਼ ਪ੍ਰੋਫਾਈਲ {email} ਦੇਖ ਰਹੇ ਹੋ',
      'header.my.trips.subtitle':
          'ਬੁਕਿੰਗ ਦੇ ਵੇਰਵੇ, ਈ-ਟਿਕਟ ਛਾਪੋ, ਬੁਕਿੰਗ ਰੱਦ ਕਰੋ, ਬੁਕਿੰਗ ਨੂੰ ਸੋਧੋ, ਰਿਫੰਡ ਦੀ ਸਥਿਤੀ ਵੇਖੋ ਅਤੇ ਹੋਰ ਦੇਖੋ.',
      'header.my.wallet': 'ਮੇਰਾ ਵਾਲਿਟ',
      'header.my.wallet.subtitle':
          'ਇਸ ਤੋਂ ਵੀ ਜ਼ਿਆਦਾ ਛੋਟ ਲੈਣ ਲਈ ਆਪਣੇ ਵਾਲਿਟ ਦੇ ਪੈਸੇ ਦੀ ਵਰਤੋਂ ਕਰੋ',
      'header.my.mmt.black': 'ਐਮ ਐਮ ਟੀ ਕਾਲਾ',
      'header.my.mmt.black.subtitle':
          'ਆਪਣੀ ਖਰਚ ਯਾਤਰਾ, ਮੀਲ ਪੱਥਰ ਅਤੇ ਦਾਅਵੇ ਦੇ ਇਨਾਮ ਵੇਖੋ!',
      'header.my.mmt.double.black': 'ਐਮਐਮਟੀ ਡਬਲ ਬਲੈਕ',
      'header.my.mmt.double.black.inactive':
          "ਆਪਣੀ ਉਡਾਣ ਅਤੇ ਹੋਟਲ ਬੁਕਿੰਗ 'ਤੇ ਮੁਸ਼ਕਲ ਰਹਿਤ ਰੱਦ ਕਰਨ ਲਈ ਹੁਣ ਖਰੀਦੋ",
      'header.my.mmt.double.black.active':
          'ਆਪਣੇ ਐਮ ਐਮ ਟੀ ਡੀ ਟੂਬਲ ਬਲੈਕ ਲਾਭ ਵੇਖੋ',
      'header.my.mmt.double.black.expired':
          'ਤੁਹਾਡੀ ਮੈਂਬਰਸ਼ਿਪ ਦੀ ਮਿਆਦ ਖਤਮ ਹੋ ਗਈ ਹੈ, ਐਮ ਐਮ ਟੀ ਡੀ ਟੂਬਲ ਬਲੈਕ ਤੋਂ ਲਾਭ ਪ੍ਰਾਪਤ ਕਰਨਾ ਜਾਰੀ ਕਰਨ ਲਈ ਨਵੀਨੀਕਰਣ ਕਰੋ',
      'header.my.profile': 'ਮੇਰਾ ਪ੍ਰੋਫਾਈਲ',
      'header.my.profile.subtitle':
          'ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ, ਯਾਤਰੀ ਵੇਰਵੇ, ਲੌਗਇਨ ਵੇਰਵੇ ਅਤੇ ਪਾਸਵਰਡ ਪ੍ਰਬੰਧਿਤ ਕਰੋ',
      'header.my.make.payment': 'ਭੁਗਤਾਨ ਕਰੋ',
      'header.my.make.payment.subtitle': 'ਇੱਥੇ ਆਪਣੇ ਬਕਾਇਆ ਭੁਗਤਾਨ ਨੂੰ ਪੂਰਾ ਕਰੋ',
      'header.logout.text': 'ਲਾੱਗ ਆਊਟ, ਬਾਹਰ ਆਉਣਾ',
      'header.login.signup.for.best.prices': 'ਵਧੀਆ ਭਾਅ ਲਈ ਲੌਗਇਨ / ਸਾਈਨਅਪ',
      'header.login.signup.text.cash':
          'Login/Signup to earn {currency}555 instantly',
      'header.login.signup.easily.with': 'ਆਸਾਨੀ ਨਾਲ ਲਾਗਇਨ / ਸਾਈਨ ਅਪ ਕਰੋ',
      'header.login.with.phone.email': 'ਫੋਨ / ਈਮੇਲ ਨਾਲ ਲੌਗਇਨ ਕਰੋ',
      'header.welcome.text': 'ਹੇ',
      'header.traveller.text': 'ਯਾਤਰੀ',
      'header.login.success.message':
          'ਲੌਗਇਨ ਸਫਲਤਾ! ਮੋਬਾਈਲ ਨੰਬਰ ਨੂੰ ਲਿੰਕ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ',
      'header.myBiz.login.message':
          'ਅਸੀਂ ਅਜੇ ਤੱਕ ਮਾਈਬੀਜ਼ ਖਾਤਿਆਂ ਲਈ ਮੋਬਾਈਲ ਨੰਬਰ ਰਾਹੀਂ ਲੌਗਇਨ ਦਾ ਸਮਰਥਨ ਨਹੀਂ ਕਰਦੇ. ਤੁਸੀਂ ਆਪਣੇ ਈਮੇਲ ਅਤੇ ਪਾਸਵਰਡ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਆਪਣੇ ਖਾਤੇ ਤਕ ਪਹੁੰਚਣਾ ਜਾਰੀ ਰੱਖ ਸਕਦੇ ਹੋ.',
      'header.mobile.number.linked.message':
          'ਇਸ ਖਾਤੇ ਦਾ ਪਹਿਲਾਂ ਹੀ ਇਸ ਨਾਲ ਜੁੜਿਆ ਹੋਇਆ ਇੱਕ ਮੋਬਾਈਲ ਨੰਬਰ ਹੈ, ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਲਿੰਕ ਕੀਤੇ ਫੋਨ ਨੰਬਰ ਨੂੰ ਅਨਲਿੰਕ ਕਰਨ ਲਈ ਪ੍ਰੋਫਾਈਲ ਵਿਭਾਗ ਤੇ ਜਾਓ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ.',
      'header.move.back.text': 'ਵਾਪਸ',
      'header.skip.text': 'ਛੱਡੋ',
      'header.login.with.password': 'ਪਾਸਵਰਡ ਨਾਲ ਲਾਗਇਨ ਕਰੋ',
      'header.login.signup.text': 'ਲੌਗਇਨ / ਸਾਈਨਅਪ',
      'header.email.placeholder.text': 'ਈਮੇਲ ਦਰਜ ਕਰੋ',
      'header.for.account.text': 'For account {username}',
      'header.email.or.mobile.placeholder.text': 'ਈਮੇਲ ਜਾਂ ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ',
      'header.email.label.text': 'ਈ - ਮੇਲ',
      'header.email.or.mobile.label.text': 'ਈਮੇਲ ਜਾਂ ਮੋਬਾਈਲ ਨੰਬਰ',
      'header.continue.text': 'ਜਾਰੀ ਰੱਖੋ',
      'header.login.with.text': 'ਜਾਂ ਇਸ ਨਾਲ ਲੌਗਇਨ ਕਰੋ',
      'header.company.login.portal.text': 'ਕੰਪਨੀ ਦਾ ਲਾਗਇਨ ਪੋਰਟਲ',
      'header.login.to.myBiz.account':
          'ਤੁਸੀਂ ਆਪਣੇ ਮਾਈਬਿਜ਼ ਖਾਤੇ ਵਿੱਚ ਲੌਗਇਨ ਕਰਨ ਲਈ ਆਪਣੀ ਕੰਪਨੀ ਦੇ ਪ੍ਰਮਾਣ ਪੱਤਰਾਂ ਦੀ ਵਰਤੋਂ ਕਰ ਸਕਦੇ ਹੋ.',
      'header.login.text': 'ਲਾਗਿਨ',
      'header.login.via.otp': 'ਜਾਂ ਓਟੀਪੀ ਰਾਹੀਂ ਲੌਗਇਨ ਕਰੋ',
      'header.otp.on.mail.message': 'ਤੁਸੀਂ ਈ-ਮੇਲ ਤੇ ਓਟੀਪੀ ਪ੍ਰਾਪਤ ਕਰੋਗੇ',
      'header.login.signup.with.text': 'ਜਾਂ ਨਾਲ ਲਾਗਇਨ / ਸਾਈਨਅਪ',
      'header.no.myBiz.account.message': 'ਕੀ ਮੇਰਾ ਮਾਈਬਿਜ਼ ਖਾਤਾ ਨਹੀਂ ਹੈ?',
      'header.create.account.here.message': 'ਇੱਥੇ ਇੱਕ ਖਾਤਾ ਬਣਾਓ',
      'header.saving.on.business.travel.message':
          "& ਆਪਣੀ ਕਾਰੋਬਾਰੀ ਯਾਤਰਾ 'ਤੇ ਬਚਤ ਕਰਨਾ ਸ਼ੁਰੂ ਕਰੋ",
      'header.personal.account.text': 'ਨਿੱਜੀ ਖਾਤਾ',
      'header.myBiz.account.text': 'MyBiz ਖਾਤਾ',
      'header.reset.password.text': 'ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰੋ',
      'header.mobile.not.registered.text': 'ਅਜਿਹਾ ਲਗਦਾ ਹੈ ਕਿ ਮੋਬਾਈਲ ਨੰਬਰ',
      'header.mobile.not.registered.action.text':
          'ਮੇਕਮਾਈਟਰਿਪ ਨਾਲ ਰਜਿਸਟਰਡ ਨਹੀਂ ਹੈ, ਤੁਸੀਂ ਅੱਗੇ ਕੀ ਕਰਨਾ ਚਾਹੋਗੇ?',
      'header.create.personal.account.message':
          'ਇਸ ਮੋਬਾਈਲ ਨੰਬਰ ਨਾਲ ਨਵਾਂ ਨਿੱਜੀ ਖਾਤਾ ਬਣਾਓ',
      'header.link.existing.account': 'ਮੌਜੂਦਾ ਖਾਤੇ ਨਾਲ ਲਿੰਕ ਕਰੋ',
      'header.link.user.to.existing.account':
          'ਇੱਕ ਮੌਜੂਦਾ ਖਾਤੇ ਦੇ ਨਾਲ {displayUserName} ਨੂੰ ਲਿੰਕ ਕਰੋ',
      'header.dismiss.text': 'ਬਰਖਾਸਤ ਕਰੋ',
      'header.account.already.exists.message':
          'ਇੱਕ {accountType} ਖਾਤਾ ਪਹਿਲਾਂ ਹੀ ਮੌਜੂਦ ਹੈ',
      'header.registered.account.action.message':
          'ਅਜਿਹਾ ਲਗਦਾ ਹੈ ਕਿ ਤੁਸੀਂ ਪਹਿਲਾਂ ਤੋਂ ਰਜਿਸਟਰਡ {accountType} ਖਾਤੇ ਨਾਲ ਈਮੇਲ ਆਈਡੀ: {username} ਨਾਲ ਲੌਗਇਨ ਕਰਨ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰ ਰਹੇ ਹੋ, ਤੁਸੀਂ ਅੱਗੇ ਕੀ ਕਰਨਾ ਚਾਹੋਗੇ?',
      'header.login.with.email': 'Login to {accountType} with this Email ID',
      'header.create.new.account':
          'Create a New {accountType} Account with {username}',
      'header.get.otp.for.mobile.login':
          'ਮੋਬਾਈਲ ਨੰਬਰ ਨਾਲ ਲੌਗਇਨ ਕਰਨ ਲਈ ਓਟੀਪੀ ਪ੍ਰਾਪਤ ਕਰੋ',
      'header.access.myBiz.account': 'ਕੰਪਨੀ ਲੌਗਇਨ ਦੇ ਨਾਲ ਮਾਈਬਿਜ਼ ਨੂੰ ਐਕਸੈਸ ਕਰੋ',
      'header.company.registered.myBiz.account':
          'ਅਸੀਂ ਵੇਖਦੇ ਹਾਂ ਕਿ ਤੁਹਾਡੀ ਕੰਪਨੀ ਨੇ ਪਹਿਲਾਂ ਹੀ ਤੁਹਾਡੇ ਲਈ ਇਕ ਨਿਜੀ ਈਮੇਲ ਆਈਡੀ: {ਯੂਜ਼ਰਨੇਮ} ਨਾਲ ਤੁਹਾਡੇ ਲਈ ਇਕ ਮਾਈਬਿਜ਼ ਖਾਤਾ ਰਜਿਸਟਰ ਕਰ ਲਿਆ ਹੈ, ਤੁਸੀਂ ਅੱਗੇ ਕੀ ਕਰਨਾ ਚਾਹੋਗੇ?',
      'header.login.myBiz.with.company.portal':
          'ਕੰਪਨੀ ਲੌਗਿਨ ਪੋਰਟਲ ਨਾਲ ਮਾਈਬੀਜ਼ ਤੇ ਲੌਗਇਨ ਕਰੋ',
      'header.password.placeholder.text': 'ਘੱਟੋ ਘੱਟ 6 ਅੱਖਰ.',
      'header.password.text': 'ਪਾਸਵਰਡ',
      'header.remember.me.text': 'ਮੇਰੀ ਯਾਦ ਹੈ',
      'header.agent.id.text': 'ਏਜੰਟ ਆਈ.ਡੀ.',
      'header.enter.mobile.number.text': 'ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ',
      'header.send.otp.text': 'OTP ਭੇਜੋ',
      'header.verify.mobile.number.title': 'ਮੋਬਾਈਲ ਨੰਬਰ ਦੀ ਪੜਤਾਲ ਕਰੋ',
      'header.verify.mobile.number.subtitle':
          'ਜਾਰੀ ਰੱਖਣ ਲਈ, ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਮੋਬਾਈਲ ਨੰਬਰ ਦੀ ਤਸਦੀਕ ਕਰੋ',
      'header.and.word.text': 'ਅਤੇ',
      'header.or.use.text': 'ਜਾਂ ਵਰਤੋਂ',
      'header.create.account.with': 'ਜਾਂ ਨਾਲ ਖਾਤਾ ਬਣਾਓ',
      'header.resend.otp.text': 'ਓਟੀਪੀ ਨੂੰ ਦੁਬਾਰਾ ਭੇਜੋ',
      'header.verify.text': 'ਪੜਤਾਲ ਕਰੋ',
      'header.otp.text': 'ਓ.ਟੀ.ਪੀ.',
      'header.enter.otp.sent.to.text': 'ਕਿਰਪਾ ਕਰਕੇ ਭੇਜੇ ਗਏ ਓਟੀਪੀ ਨੂੰ ਦਾਖਲ ਕਰੋ',
      'header.add.mobile.number.text': 'ਆਪਣਾ ਮੋਬਾਈਲ ਨੰਬਰ ਜੋੜਨ ਲਈ.',
      'header.enter.myBiz.account.password': 'ਮਾਈਬਿਜ਼ ਖਾਤਾ ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ',
      'header.create.account.text': 'ਖਾਤਾ ਬਣਾਉ',
      'header.signup.agree.text': 'ਸਾਈਨ ਅਪ ਕਰਕੇ, ਤੁਸੀਂ ਸਹਿਮਤ ਹੋ',
      'header.terms.and.conditions.text': 'ਨਿਬੰਧਨ ਅਤੇ ਸ਼ਰਤਾਂ',
      'header.email.or.phone.placeholder': 'ਈਮੇਲ ਜਾਂ ਫੋਨ ਨੰਬਰ ਦਰਜ ਕਰੋ.',
      'header.password.same.message':
          "ਤੁਹਾਡਾ ਨਿੱਜੀ ਖਾਤਾ ਪਾਸਵਰਡ MyBiz ਖਾਤੇ <span class='latoBold'>(abhinav.mittal@go-mmt.com)</span> ਪਾਸਵਰਡ ਵਰਗਾ ਹੀ ਹੋਵੇਗਾ",
      'header.create.personal.account.text': 'ਨਵਾਂ ਨਿੱਜੀ ਖਾਤਾ ਬਣਾਓ',
      'header.enter.username.for.linking.mobile':
          'ਉਸ ਖਾਤੇ ਦਾ ਉਪਯੋਗਕਰਤਾ ਨਾਮ ਦਰਜ ਕਰੋ ਜਿਸ ਨਾਲ ਤੁਸੀਂ ਆਪਣਾ ਮੋਬਾਈਲ ਨੰਬਰ {displayUserName} ਜੋੜ ਸਕਦੇ ਹੋ.',
      'header.continue.text.capitalized': 'ਜਾਰੀ ਰੱਖੋ',
      'header.login.via.password.text': 'ਜਾਂ ਪਾਸਵਰਡ ਰਾਹੀਂ ਲਾਗਇਨ ਕਰੋ',
      'header.verify.emailId.message': 'ਆਪਣੀ ਈ-ਮੇਲ ਆਈਡੀ ਦੀ ਪੜਤਾਲ ਕਰੋ',
      'header.verify.mobile.message': 'ਆਪਣੇ ਮੋਬਾਈਲ ਨੰਬਰ ਦੀ ਤਸਦੀਕ ਕਰੋ',
      'header.enter.otp.on.email.text':
          'ਲੌਗਇਨ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ {username} ਤੇ ਭੇਜੀ ਗਈ OTP ਜਾਂ ਆਪਣੀ ਰਜਿਸਟਰਡ ਈ-ਮੇਲ ID ਭਰੋ',
      'header.enter.otp.on.mobile.text':
          'ਲੌਗਇਨ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ {username} ਤੇ ਭੇਜੇ ਗਏ ਓਟੀਪੀ ਜਾਂ ਆਪਣਾ ਰਜਿਸਟਰਡ ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ',
      'header.enter.otp.sent.to.username.text':
          'ਕਿਰਪਾ ਕਰਕੇ ਲੌਗਇਨ ਕਰਨ ਲਈ {username} ਤੇ ਭੇਜੇ ਗਏ ਓਟੀਪੀ ਨੂੰ ਦਾਖਲ ਕਰੋ',
      'header.login.to.your.account.text': 'ਤੁਹਾਡੇ ਖਾਤੇ ਵਿੱਚ ਲੌਗਇਨ ਕਰਨ ਲਈ.',
      'header.reset.the.password.text': 'ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰਨ ਲਈ.',
      'header.to.continue.text': 'ਚਾਲੂ.',
      'header.send.reset.otp.on.email.mobile':
          "ਅਸੀਂ ਤੁਹਾਨੂੰ ਤੁਹਾਡੇ ਰਜਿਸਟਰਡ ਈ-ਮੇਲ ਆਈਡੀ ਜਾਂ ਮੋਬਾਈਲ ਨੰਬਰ 'ਤੇ ਰੀਸੈਟ ਓਟੀਪੀ ਭੇਜਾਂਗੇ",
      'header.send.reset.otp.on.email':
          'ਅਸੀਂ ਤੁਹਾਨੂੰ ਤੁਹਾਡੇ ਰਜਿਸਟਰਡ ਈ-ਮੇਲ ਆਈਡੀ ਤੇ ਰੀਸੈਟ ਓਟੀਪੀ ਭੇਜਾਂਗੇ',
      'header.register.email.or.mobile.text': 'ਰਜਿਸਟਰਡ ਈਮੇਲ ਜਾਂ ਮੋਬਾਈਲ ਨੰਬਰ',
      'header.register.email.text': 'ਰਜਿਸਟਰਡ ਈਮੇਲ',
      'header.username.not.exist.message': 'ਇਹ ਉਪਯੋਗਕਰਤਾ ਨਾਮ ਮੌਜੂਦ ਨਹੀਂ ਹੈ.',
      'header.trying.to.create.new.account':
          'ਜੇ ਤੁਸੀਂ ਨਵਾਂ $ {accountType} ਖਾਤਾ ਬਣਾਉਣ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰ ਰਹੇ ਹੋ',
      'header.google.business.account.text': 'ਗੂਗਲ ਵਪਾਰ ਖਾਤਾ',
      'header.new.password.text': 'ਨਵਾਂ ਪਾਸਵਰਡ',
      'header.create.new.password.text': 'ਨਵਾਂ ਪਾਸਵਰਡ ਬਣਾਓ',
      'header.new.password.validations.text':
          'ਘੱਟੋ ਘੱਟ 8 ਅੱਖਰਾਂ ਦੀ ਲੰਬਾਈ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ ਅਤੇ ਇਸ ਵਿੱਚ ਘੱਟੋ ਘੱਟ ਇੱਕ ਅੱਖ਼ਰ, ਇੱਕ ਨੰਬਰ ਅਤੇ ਇੱਕ ਵਿਸ਼ੇਸ਼ ਅੱਖਰ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ @ $!% * #? &',
      'header.redirect.to.login.text': 'ਲਾਗਇਨ ਕਰਨ ਲਈ ਜਾਓ',
      'header.password.changed.successfully.message':
          'ਪਾਸਵਰਡ ਸਫਲਤਾਪੂਰਵਕ ਬਦਲਿਆ ਗਿਆ',
      'header.do.not.share.password.message':
          'ਦੁਰਵਰਤੋਂ ਨੂੰ ਰੋਕਣ ਲਈ, ਆਪਣਾ ਪਾਸਵਰਡ ਕਿਸੇ ਨਾਲ ਸਾਂਝਾ ਨਾ ਕਰੋ.',
      'header.login.successful.message': 'ਲੌਗਇਨ ਸਫਲ',
      'header.A.letter.text': 'ਏ',
      'header.successful.logged.in.message':
          'ਤੁਸੀਂ ਆਪਣੇ ਖਾਤੇ ਵਿੱਚ ਸਫਲਤਾਪੂਰਵਕ ਲੌਗਇਨ ਕੀਤਾ ਹੈ',
      'header.account.creation.unsuccessful': 'ਖਾਤਾ ਬਣਾਉਣਾ ਅਸਫਲ',
      'header.account.creation.unsuccessful.message':
          'ਅਸੀਂ ਤੁਹਾਡਾ ਖਾਤਾ ਬਣਾਉਣ ਵਿੱਚ ਅਸਮਰੱਥ ਹਾਂ ਕਿਉਂਕਿ ਮੋਬਾਈਲ ਨੰਬਰ ਦੀ ਤਸਦੀਕ ਅਸਫਲ ਰਹੀ ਸੀ.',
      'header.continue.creating.account': 'ਇਥੇ ਖਾਤਾ ਬਣਾਉਣਾ ਜਾਰੀ ਰੱਖੋ',
      'header.reset.your.password.text': 'ਤੁਹਾਡੇ ਪਾਸਵਰਡ ਨੂੰ ਰੀਸੈਟ ਕਰਨ ਲਈ',
      'header.enter.otp.sent.text': 'ਨੂੰ ਭੇਜਿਆ ਗਿਆ ਓਟੀਪੀ ਦਰਜ ਕਰੋ',
      'header.verify.and.link.account':
          'ਨੂੰ ਤਸਦੀਕ ਕਰਨ ਅਤੇ ਉਸੇ ਨੂੰ ਖਾਤੇ ਨਾਲ ਜੋੜਨ ਲਈ',
      'header.enter.otp.placeholder': 'ਓਟੀਪੀ ਦਰਜ ਕਰੋ',
      'header.create.next.account.text': 'ਨਵਾਂ ਖਾਤਾ ਬਣਾਓ',
      'header.already.a.member.text': 'ਪਹਿਲਾਂ ਤੋਂ ਹੀ ਕੋਈ ਮੈਂਬਰ ਹੈ?',
      'header.verify.number.and.create.account':
          'ਨੰਬਰ ਦੀ ਜਾਂਚ ਕਰੋ ਅਤੇ ਖਾਤਾ ਬਣਾਓ',
      'header.login.myBiz.with.email': 'ਇਸ ਈਮੇਲ ਆਈਡੀ ਨਾਲ ਮਾਈਬਿਜ਼ ਤੇ ਲੌਗਇਨ ਕਰੋ',
      'header.already.registered.email.message':
          'ਅਜਿਹਾ ਲਗਦਾ ਹੈ ਕਿ ਤੁਸੀਂ ਪਹਿਲਾਂ ਤੋਂ ਰਜਿਸਟਰਡ ਮਾਈਬੀਜ਼ ਅਕਾਉਂਟ ਨਾਲ ਈਮੇਲ ਆਈਡੀ: {username} ਨਾਲ ਸਾਈਨ ਅਪ ਕਰਨ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰ ਰਹੇ ਹੋ, ਤੁਸੀਂ ਅੱਗੇ ਕੀ ਕਰਨਾ ਚਾਹੋਗੇ?',
      'header.myBiz.account.exists': 'ਇੱਕ ਮਾਈਬਿਜ਼ ਖਾਤਾ ਪਹਿਲਾਂ ਹੀ ਮੌਜੂਦ ਹੈ',
      'header.congratulations.message': 'ਵਧਾਈਆਂ!',
      'header.account.created.successfully': 'ਖਾਤਾ ਸਫਲਤਾਪੂਰਵਕ ਬਣਾਇਆ ਗਿਆ',
      'header.save.and.continue.text': 'ਸੇਵ ਅਤੇ ਜਾਰੀ ਰੱਖੋ',
      'header.save.and.verify.mobile.text': 'ਮੋਬਾਈਲ ਨੰਬਰ ਸੇਵ ਅਤੇ ਵੈਰੀਫਾਈ ਕਰੋ',
      'header.account.created.successfully.message':
          'ਵਧਾਈਆਂ! ਤੁਹਾਡਾ ਖਾਤਾ ਸਫਲਤਾਪੂਰਵਕ ਬਣਾਇਆ ਗਿਆ ਹੈ! ਤੁਸੀਂ ਵਧੀਆ ਕੀਮਤਾਂ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਹੁਣੇ ਬੁਕਿੰਗ ਸ਼ੁਰੂ ਕਰ ਸਕਦੇ ਹੋ.',
      'header.unlocked.bonus.reward.message':
          'ਵਧਾਈਆਂ! ਦੇ ਬੋਨਸ ਇਨਾਮ ਨੂੰ ਤੁਸੀਂ ਸਫਲਤਾਪੂਰਵਕ ਅਣਲਾਕ ਕਰ ਦਿੱਤਾ ਹੈ',
      'header.wallet.money.rewarded': '555 ਵਾਲਿਟ ਪੈਸਾ',
      'header.verify.and.create.account': 'ਪੜਤਾਲ ਕਰੋ ਅਤੇ ਖਾਤਾ ਬਣਾਓ',
      'header.verify.and.link.account.text': 'ਪੜਤਾਲ ਅਤੇ ਲਿੰਕ ਖਾਤਾ',
      'header.incorrect.otp.entered.text':
          'ਗਲਤ ਓਟੀਪੀ ਦਰਜ ਕੀਤਾ ਗਿਆ. ਮੁੜ ਕੋਸ਼ਿਸ ਕਰੋ ਜੀ.',
      'header.enter.otp.label': 'ਓਟੀਪੀ ਦਰਜ ਕਰੋ',
      'header.enter.otp.here.placeholder': 'ਇੱਥੇ ਓਟੀਪੀ ਦਰਜ ਕਰੋ',
      'header.numeric.validation': 'ਇੱਕ ਨੰਬਰ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ',
      'header.min.characters.validation': 'Must be {min} characters or more',
      'header.max.characters.validation': 'Must be {max} characters or less',
      'header.min.value.validation': 'Must be at least {min}',
      'header.email.format.message':
          "ਈਮੇਲ ਆਈਡੀ 'abc@xyz.com' ਫਾਰਮੈਟ ਵਿੱਚ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ",
      'header.aol.email.message':
          'ਸਚਮੁਚ? ਕੀ ਤੁਸੀਂ ਅਜੇ ਵੀ ਆਪਣੀ ਈਮੇਲ ਲਈ ਏਓਐਲ ਦੀ ਵਰਤੋਂ ਕਰਦੇ ਹੋ?',
      'header.alphanumeric.validation': 'ਸਿਰਫ ਵਰਣਮਾਲਾ ਦੇ ਅੱਖਰ',
      'header.mobile.number.validation':
          'ਅਵੈਧ ਫ਼ੋਨ ਨੰਬਰ, 10 ਅੰਕ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ',
      'header.required.validation': 'ਲੋੜੀਂਦਾ',
      'header.privacy.policy.text': 'ਪਰਾਈਵੇਟ ਨੀਤੀ',
      'header.user.agreement.text': 'ਉਪਭੋਗਤਾ ਇਕਰਾਰਨਾਮਾ',
      'header.terms.of.service.text': 'ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ',
      'header.invalid.phone.number': 'ਅਵੈਧ ਫੋਨ ਨੰਬਰ',
      'header.your.username.message': 'ਇਹ ਤੁਹਾਡਾ ਉਪਯੋਗਕਰਤਾ ਨਾਮ ਹੋਵੇਗਾ',
      'header.otp.verification.completed':
          '<b>ਓਟੀਪੀ ਤਸਦੀਕ</b> ਉਦੋਂ ਕੀਤੀ ਜਾਂਦੀ ਹੈ ਜਦੋਂ ਮੋਬਾਈਲ ਨੰਬਰ ਦੀ ਵਰਤੋਂ ਨਾਲ ਖਾਤਾ ਬਣਾਇਆ ਜਾਂਦਾ ਹੈ',
      'header.click.here.text': 'ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ',
      'header.attempting.login.text':
          'ਜੇ ਤੁਸੀਂ ਲੌਗਇਨ ਕਰਨ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰ ਰਹੇ ਹੋ.',
      'header.enter.password.placeholder': 'ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ',
      'header.enter.work.email': 'ਆਪਣੀ ਕੰਮ ਦੀ ਈਮੇਲ ਆਈਡੀ ਦਿਓ',
      'header.agreement.text.on.mmt':
          'ਅੱਗੇ ਵਧਣ ਨਾਲ, ਤੁਸੀਂ ਮੇਕਮਾਈਟਰਿਪਜ਼ ਨਾਲ ਸਹਿਮਤ ਹੋ',
      'header.policy.text': 'ਪਰਦੇਦਾਰੀ',
      'header.login.expired': 'ਲਾਗਇਨ ਦੀ ਮਿਆਦ ਖਤਮ',
      'header.click.to.login.again':
          "ਚਿੰਤਾ ਕਰਨ ਦੀ ਕੋਈ ਲੋੜ ਨਹੀਂ! ਅਸੀਂ ਨਿਯਮਿਤ ਤੌਰ ਤੇ ਉਪਭੋਗਤਾਵਾਂ ਦੇ ਖਾਤੇ ਦੀ ਬਿਹਤਰੀ ਲਈ ਲਾਗ ਆਉਟ ਕਰਦੇ ਹਾਂ. <a className='latoBold'>ਦੁਬਾਰਾ ਲੌਗਇਨ ਕਰਨ</a> ਅਤੇ ਐਮਐਮਟੀ ਦੇ ਤਜ਼ਰਬੇ ਦਾ ਅਨੰਦ ਲੈਣ <a className='latoBold'>ਲਈ ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ</a> .",
      'header.signup.with.facebook': 'ਫੇਸਬੁੱਕ ਨਾਲ ਸਾਈਨ ਅੱਪ ਕਰੋ',
      'header.login.with.facebook': 'ਫੇਸਬੁੱਕ ਨਾਲ ਲਾਗਇਨ',
      'header.signup.with.google': 'ਗੂਗਲ ਨਾਲ ਸਾਈਨ ਅਪ ਕਰੋ',
      'header.login.with.google': 'ਗੂਗਲ ਨਾਲ ਲੌਗਇਨ ਕਰੋ',
      'header.login.or.signup.message': 'ਲੌਗਇਨ / ਸਾਈਨ ਅਪ ਕਰੋ',
      'header.work.email.text': 'ਕੰਮ ਦੀ ਈਮੇਲ',
      'header.verification.successful.text': 'ਤਸਦੀਕ ਸਫਲ',
      'header.mobile.number.verified.message':
          'ਵਧਾਈਆਂ! ਤੁਹਾਡਾ ਮੋਬਾਈਲ ਨੰਬਰ {ਯੂਜ਼ਰਨੇਮ successfully ਨੂੰ ਸਫਲਤਾਪੂਰਵਕ ਪ੍ਰਮਾਣਿਤ ਕੀਤਾ ਗਿਆ ਹੈ ਅਤੇ ਖਾਤੇ linked ਈਮੇਲ ਆਈਡੀ to ਨਾਲ ਲਿੰਕ ਕਰ ਦਿੱਤਾ ਗਿਆ ਹੈ',
      'header.cruise': 'ਕਰੂਜ਼',
      'header.new.text': 'ਨਵਾਂ',
      'header.admin.text': 'ਐਡਮਿਨ',
      'header.FLIGHTS': 'ਉਡਾਣਾਂ',
      'header.CHARTER_FLIGHTS': 'ਚਾਰਟਰ ਉਡਾਣਾਂ',
      'header.CHARTER_FLIGHTS_CLASS': 'ਚਾਰਟਰਫਲਾਈਟਸ',
      'header.HOTELS': 'ਹੋਟਲ',
      'header.HOLIDAYS': 'ਛੁੱਟੀਆਂ',
      'header.BUSES': 'ਬੱਸਾਂ',
      'header.CABS': 'ਕੈਬਾਂ',
      'header.BIZ_CABS': 'ਏਅਰਪੋਰਟ ਕੈਬਸ',
      'header.TRAINS': 'ਰੇਲ ਗੱਡੀਆਂ',
      'header.GIFTCARDS': 'ਗਿਫਟ ਕਾਰਡ',
      'header.MORE': 'ਹੋਰ',
      'header.LOGIN_AGENT': 'ਏਜੰਟ ਲੌਗਇਨ',
      'header.MMT_LOGO_ALT': 'ਐਮਐਮਟੀ ਦਾ ਲੋਗੋ',
      'header.ACTIVE': 'ਸਰਗਰਮ',
      'header.IN_YOUR_WALLET': 'ਤੁਹਾਡੇ ਬਟੂਏ ਵਿਚ',
      'header.YOUR_WALLET': 'ਤੁਹਾਡਾ ਵਾਲਿਟ',
      'header.LOGIN_OR': 'ਲੌਗਇਨ ਜਾਂ',
      'header.CREATE_ACCOUNT_TEXT': 'ਖਾਤਾ ਬਣਾਉ',
      'header.MY_BIZ': 'ਮੇਰਾ ਬਿਜ਼',
      'header.INT_FLIGHT': 'ਅੰਤਰਰਾਸ਼ਟਰੀ ਉਡਾਣਾਂ',
      'header.INT_HOTEL': 'ਅੰਤਰਰਾਸ਼ਟਰੀ ਹੋਟਲ',
      'header.REFER_EARN': 'ਵੇਖੋ ਅਤੇ ਕਮਾਓ',
      'header.BLOG': 'ਬਲਾੱਗ',
      'header.Deals': 'ਸੌਦੇ',
      'header.VENUES': 'ਸਥਾਨ',
      'header.ADMIN_SITE': 'ਐਡਮਿਨ',
      'header.HOME_STAYS': 'ਵਿਲਾ ਅਤੇ ਐਪਸ',
      'header.HOME_STAYS_CLASS': 'ਹੋਮਸਟੇਸ',
      'header.VISA': 'ਵੀਜ਼ਾ',
      'header.MICE': 'ਚੂਹੇ',
      'header.TRIP_IDEAS': 'ਯਾਤਰਾ ਵਿਚਾਰ',
      'header.LOGIN_ENTER_VALID_EMAIL_ERROR_MESSAGE':
          'ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਈਮੇਲ ਆਈਡੀ ਜਾਂ ਮੋਬਾਈਲ ਨੰਬਰ ਦਾਖਲ ਕਰੋ.',
      'header.LOGIN_ENTER_VALID_AGENT_ERROR_MESSAGE':
          'ਕਿਰਪਾ ਕਰਕੇ ਵੈਧ ਏਜੰਟ ਆਈਡੀ ਦਾਖਲ ਕਰੋ.',
      'header.LOGIN_ENTER_VALID_ONLY_EMAIL_ERROR_MESSAGE':
          'ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਈਮੇਲ ਦਰਜ ਕਰੋ.',
      'header.LOGIN_ENTER_PASSWORD_ERROR_MESSAGE': 'ਪਾਸਵਰਡ ਦਿਓ ਜੀ.',
      'header.LOGIN_ENTER_VALID_PASSWORD_ERROR_MESSAGE':
          'ਪਾਸਵਰਡ 6 ਅੱਖਰਾਂ ਤੋਂ ਘੱਟ ਨਹੀਂ ਹੋ ਸਕਦਾ.',
      'header.LOGIN_ENTER_VALID_OTP_ERROR_MESSAGE':
          'ਕਿਰਪਾ ਕਰਕੇ ਵੈਧ ਓਟੀਪੀ ਦਾਖਲ ਕਰੋ',
      'header.SIGNUP_ENTER_VALID_CHARACTER_PASSWORD_ERROR_MESSAGE':
          'ਪਾਸਵਰਡ ਵਿੱਚ ਘੱਟੋ ਘੱਟ 8 ਅੱਖਰ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ ਅਤੇ ਘੱਟੋ ਘੱਟ ਇੱਕ ਅੱਖ਼ਰ, ਇੱਕ ਨੰਬਰ ਅਤੇ ਇੱਕ ਵਿਸ਼ੇਸ਼ ਅੱਖਰ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ @ $!% * #? &',
      'header.OTP_LOGIN_VALID_OTP_ERROR':
          'ਗਲਤ ਓਟੀਪੀ! ਕਿਰਪਾ ਕਰਕੇ ਤੁਹਾਨੂੰ ਦਿੱਤਾ ਗਿਆ ਓਟੀਪੀ ਦਰਜ ਕਰੋ.',
      'header.LOGIN_ACCOUNT_BLOCKED_ERROR_MESSAGE':
          'ਤੁਸੀਂ ਲੌਗਇਨ ਕੋਸ਼ਿਸ਼ਾਂ ਦੀ ਅਧਿਕਤਮ ਸੀਮਾ ਨੂੰ ਪਾਰ ਕਰ ਚੁੱਕੇ ਹੋ. ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
      'header.LOGIN_INCORRECT_EMAIL_PASSWORD_ERROR_MESSAGE':
          'ਜਾਂ ਤਾਂ ਉਪਭੋਗਤਾ ਨਾਮ ਜਾਂ ਪਾਸਵਰਡ ਗਲਤ ਹੈ.',
      'header.LOGIN_DEFAULT_ERROR_MESSAGE':
          'ਇੰਝ ਜਾਪਦਾ ਹੈ ਕਿ ਅਸੀਂ ਕੁਝ ਤਕਨੀਕੀ ਸਮੱਸਿਆਵਾਂ ਦਾ ਸਾਹਮਣਾ ਕਰ ਰਹੇ ਹਾਂ, ਕਿਰਪਾ ਕਰਕੇ ਕੁਝ ਸਮੇਂ ਬਾਅਦ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ.',
      'header.FORGOT_PASSWORD_USER_NOT_EXISTS_ERROR_MESSAGE':
          'ਉਪਯੋਗਕਰਤਾ ਨਾਮ ਮੌਜੂਦ ਨਹੀਂ ਹੈ, ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਈਮੇਲ ਆਈਡੀ ਜਾਂ ਮੋਬਾਈਲ ਨੰਬਰ ਦਾਖਲ ਕਰੋ',
      'header.FORGOT_PASSWORD_DEFAULT_ERROR_MESSAGE':
          'ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ.',
      'header.VERIFY_OTP_LIMIT_CROSSED_ERROR_MESSAGE':
          'ਤੁਸੀਂ ਓਟੀਪੀ ਕੋਸ਼ਿਸ਼ਾਂ ਨੂੰ ਭੇਜਣ ਦੀ ਅਧਿਕਤਮ ਸੀਮਾ ਨੂੰ ਪਾਰ ਕਰ ਚੁੱਕੇ ਹੋ. ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
      'header.VERIFY_OTP_INCORRECT_OTP_ERROR_MESSAGE':
          'ਗਲਤ ਓਟੀਪੀ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
      'header.FORGOT_PASSWORD_OTP_INVALID_TOKEN_ERROR_MESSAGE':
          'ਗਲਤ ਓਟੀਪੀ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
      'header.FORGOT_PASSWORD_OTP_DEFAULT_ERROR_MESSAGE':
          'ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ.',
      'header.FORGOT_PASSWORD_OTP_INCORRECT_OTP_ERROR_MESSAGE':
          'ਗਲਤ ਓਟੀਪੀ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
      'header.LOGIN_CREDENTIALS_EXPIRED_ERROR_MESSAGE':
          'ਤੁਹਾਡਾ ਪਾਸਵਰਡ ਖਤਮ ਹੋ ਗਿਆ ਹੈ. ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਪਾਸਵਰਡ ਨੂੰ ਰੀਸੈਟ ਕਰਨ ਲਈ ਰੀਸੈਟ ਪਾਸਵਰਡ ਤੇ ਕਲਿਕ ਕਰੋ.',
      'header.PLACEHOLDER_COUNTRY_CODE': 'ਦੇਸ਼ ਦਾ ਨਾਮ ਜਾਂ ਕੋਡ',
      'header.NOT_VALID_USER': 'ਇਸ ਈਮੇਲ ਆਈਡੀ ਨਾਲ ਕੋਈ ਨਿੱਜੀ ਖਾਤਾ ਜੁੜਿਆ ਨਹੀਂ ਹੈ',
      'header.ACCOUNT_ALREADY_LINKED':
          'ਇਸ ਖਾਤੇ ਵਿੱਚ ਪਹਿਲਾਂ ਹੀ ਇੱਕ ਫੋਨ ਨੰਬਰ ਜੁੜਿਆ ਹੋਇਆ ਹੈ',
      'header.PROCEED_TO_LOGIN_MSG':
          'ਅੱਗੇ ਵਧਣ ਨਾਲ, ਤੁਸੀਂ ਮੇਕਮਾਈਟਰਿਪਜ਼ ਨਾਲ ਸਹਿਮਤ ਹੋ',
      'header.TOS_MSG': 'ਟੀ ਅਤੇ ਸੀ ਐਸ',
      'header.PRIVACY_POLICY_MSG': 'ਪਰਾਈਵੇਟ ਨੀਤੀ',
      'header.USER_AGREEMENT_MSG': 'ਉਪਭੋਗਤਾ ਇਕਰਾਰਨਾਮਾ',
      'header.PHONE_NUMBER_ALREADY_LINKED':
          'ਫੋਨ ਨੰਬਰ ਕਿਸੇ ਹੋਰ ਖਾਤੇ ਨਾਲ ਜੁੜਿਆ ਹੋਇਆ ਹੈ.',
      'header.GOOGLE_ERROR': 'ਗੂਗਲ ਲੌਗਇਨ ਅਸਫਲ',
      'header.FB_ERROR': 'ਫੇਸਬੁੱਕ ਲੌਗਇਨ ਅਸਫਲ',
      'header.NO_MATCH_FOUND': 'ਕੋਈ ਮੇਲ ਨਹੀਂ ਮਿਲਿਆ',
      'header.facebook.text': 'ਫੇਸਬੁੱਕ',
      'header.google.text': 'ਗੂਗਲ',
      'header.enter.fullname.text': 'ਪੂਰਾ ਨਾਮ ਦਰਜ ਕਰੋ',
      'header.enter.valid.name.message': 'ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਯੋਗ ਨਾਮ ਦਾਖਲ ਕਰੋ',
      'header.incorrect.format.message': 'ਗਲਤ ਫਾਰਮੈਟ',
      'header.invalid.phone.number.message': 'ਅਵੈਧ ਫੋਨ ਨੰਬਰ',
      'header.enter.full.name.placeholder': 'ਆਪਣਾ ਪੂਰਾ ਨਾਮ ਦਰਜ ਕਰੋ',
      'header.country.ad.376.name': 'ਅੰਡੋਰਾ',
      'header.country.ae.971.name': 'ਸੰਯੂਕਤ ਅਰਬ ਅਮੀਰਾਤ',
      'header.country.af.93.name': 'ਅਫਗਾਨਿਸਤਾਨ',
      'header.country.ag.1.name': 'ਐਂਟੀਗੁਆ ਅਤੇ ਬਾਰਬੂਡਾ',
      'header.country.ai.1.name': 'ਐਂਗੁਇਲਾ',
      'header.country.al.355.name': 'ਅਲਬਾਨੀਆ',
      'header.country.am.374.name': 'ਅਰਮੇਨੀਆ',
      'header.country.ao.244.name': 'ਅੰਗੋਲਾ',
      'header.country.aq.672.name': 'ਅੰਟਾਰਕਟਿਕਾ',
      'header.country.ar.54.name': 'ਅਰਜਨਟੀਨਾ',
      'header.country.as.1.name': 'ਅਮਰੀਕੀ ਸਮੋਆ',
      'header.country.at.43.name': 'ਆਸਟਰੀਆ',
      'header.country.au.61.name': 'ਆਸਟਰੇਲੀਆ',
      'header.country.aw.297.name': 'ਅਰੂਬਾ',
      'header.country.az.358.name': 'ਅਲੈਂਡ ਟਾਪੂ',
      'header.country.az.994.name': 'ਅਜ਼ਰਬਾਈਜਾਨ',
      'header.country.ba.387.name': 'ਬੋਸਨੀਆ ਅਤੇ ਹਰਜ਼ੇਗੋਵਿਨਾ',
      'header.country.bb.1.name': 'ਬਾਰਬਾਡੋਸ',
      'header.country.bd.880.name': 'ਬੰਗਲਾਦੇਸ਼',
      'header.country.be.32.name': 'ਬੈਲਜੀਅਮ',
      'header.country.bf.226.name': 'ਬੁਰਕੀਨਾ ਫਾਸੋ',
      'header.country.bg.359.name': 'ਬੁਲਗਾਰੀਆ',
      'header.country.bh.973.name': 'ਬਹਿਰੀਨ',
      'header.country.bi.257.name': 'ਬੁਰੂੰਡੀ',
      'header.country.bj.229.name': 'ਬੇਨਿਨ',
      'header.country.bl.590.name': 'ਸੇਂਟ ਬਾਰਥਲੇਮੀ',
      'header.country.bm.1.name': 'ਬਰਮੁਡਾ',
      'header.country.bn.673.name': 'ਬ੍ਰੂਨੇਈ ਦਾਰੂਸਲਮ',
      'header.country.bo.591.name': 'ਬੋਲੀਵੀਆ, ਪਲੂਰੀਨੇਸ਼ਨਲ ਸਟੇਟ ਆਫ',
      'header.country.br.55.name': 'ਬ੍ਰਾਜ਼ੀਲ',
      'header.country.bs.1.name': 'ਬਾਹਾਮਸ',
      'header.country.bt.975.name': 'ਭੂਟਾਨ',
      'header.country.bw.267.name': 'ਬੋਤਸਵਾਨਾ',
      'header.country.by.375.name': 'ਬੇਲਾਰੂਸ',
      'header.country.bz.501.name': 'ਬੇਲੀਜ਼',
      'header.country.ca.1.name': 'ਕਨੇਡਾ',
      'header.country.cc.61.name': 'ਕੋਕੋਸ ਟਾਪੂ',
      'header.country.cd.243.name': 'ਕਾਂਗੋ, ਡੈਮੋਕਰੇਟਿਕ ਰੀਪਬਲਿਕ ਆਫ਼ ਦਿ',
      'header.country.cf.236.name': 'ਮੱਧ ਅਫ਼ਰੀਕੀ ਗਣਰਾਜ',
      'header.country.cg.242.name': 'ਕੋਂਗੋ',
      'header.country.ch.41.name': 'ਸਵਿੱਟਜਰਲੈਂਡ',
      'header.country.ci.225.name': "ਕੋਟ ਡੀ'ਵਾਇਰ",
      'header.country.ck.682.name': 'ਕੁੱਕ ਆਈਲੈਂਡਜ਼',
      'header.country.cl.56.name': 'ਚਿਲੀ',
      'header.country.cm.237.name': 'ਕੈਮਰੂਨ',
      'header.country.cn.86.name': 'ਚੀਨ',
      'header.country.co.57.name': 'ਕੋਲੰਬੀਆ',
      'header.country.cr.506.name': 'ਕੋਸਟਾਰੀਕਾ',
      'header.country.cv.238.name': 'ਕੇਪ ਵਰਡੇ',
      'header.country.cx.61.name': 'ਕ੍ਰਿਸਮਸ ਆਈਲੈਂਡ',
      'header.country.cy.357.name': 'ਸਾਈਪ੍ਰਸ',
      'header.country.cz.420.name': 'ਚੇਕ ਗਣਤੰਤਰ',
      'header.country.de.49.name': 'ਜਰਮਨੀ',
      'header.country.dj.253.name': 'ਜਾਇਬੂਟੀ',
      'header.country.dk.45.name': 'ਡੈਨਮਾਰਕ',
      'header.country.dm.1.name': 'ਡੋਮਿਨਿਕਾ',
      'header.country.do.1.name': 'ਡੋਮਿਨਿੱਕ ਰਿਪਬਲਿਕ',
      'header.country.dz.213.name': 'ਅਲਜੀਰੀਆ',
      'header.country.ec.593.name': 'ਇਕੂਏਟਰ',
      'header.country.ee.372.name': 'ਐਸਟੋਨੀਆ',
      'header.country.eg.20.name': 'ਮਿਸਰ',
      'header.country.er.291.name': 'ਏਰੀਟਰੀਆ',
      'header.country.es.34.name': 'ਸਪੇਨ',
      'header.country.et.251.name': 'ਈਥੋਪੀਆ',
      'header.country.fi.358.name': 'ਫਿਨਲੈਂਡ',
      'header.country.fj.679.name': 'ਫਿਜੀ',
      'header.country.fk.500.name': 'ਫਾਕਲੈਂਡ ਟਾਪੂ',
      'header.country.fm.691.name': 'ਮਾਈਕ੍ਰੋਨੇਸ਼ੀਆ, ਸੰਘੀ ਰਾਜਾਂ ਦੇ',
      'header.country.fo.298.name': 'ਫੈਰੋ ਟਾਪੂ',
      'header.country.fr.33.name': 'ਫਰਾਂਸ',
      'header.country.ga.241.name': 'ਗੈਬਨ',
      'header.country.gb.44.name': 'ਯੁਨਾਇਟੇਡ ਕਿਂਗਡਮ',
      'header.country.gd.1.name': 'ਗ੍ਰੇਨਾਡਾ',
      'header.country.ge.995.name': 'ਜਾਰਜੀਆ',
      'header.country.gf.594.name': 'ਫ੍ਰੈਂਚ ਗੁਆਇਨਾ',
      'header.country.gh.233.name': 'ਘਾਨਾ',
      'header.country.gi.350.name': 'ਜਿਬਰਾਲਟਰ',
      'header.country.gl.299.name': 'ਗ੍ਰੀਨਲੈਂਡ',
      'header.country.gm.220.name': 'ਗੈਂਬੀਆ',
      'header.country.gn.224.name': 'ਗਿੰਨੀ',
      'header.country.gp.450.name': 'ਗੁਆਡਾਲੂਪ',
      'header.country.gq.240.name': 'ਇਕੂਟੇਰੀਅਲ ਗਿੰਨੀ',
      'header.country.gr.30.name': 'ਗ੍ਰੀਸ',
      'header.country.gt.502.name': 'ਗੁਆਟੇਮਾਲਾ',
      'header.country.gu.1.name': 'ਗੁਆਮ',
      'header.country.gw.245.name': 'ਗਿੰਨੀ-ਬਿਸਾਉ',
      'header.country.gy.592.name': 'ਗੁਆਨਾ',
      'header.country.hk.852.name': 'ਹੋੰਗਕੋੰਗ',
      'header.country.hn.504.name': 'ਹੌਂਡੂਰਸ',
      'header.country.hr.385.name': 'ਕਰੋਸ਼ੀਆ',
      'header.country.ht.509.name': 'ਹੈਤੀ',
      'header.country.hu.36.name': 'ਹੰਗਰੀ',
      'header.country.id.62.name': 'ਇੰਡੋਨੇਸ਼ੀਆ',
      'header.country.ie.353.name': 'ਆਇਰਲੈਂਡ',
      'header.country.il.972.name': 'ਇਜ਼ਰਾਈਲ',
      'header.country.im.44.name': 'ਆਈਲ Manਫ ਮੈਨ',
      'header.country.is.354.name': 'ਆਈਸਲੈਂਡ',
      'header.country.in.91.name': 'ਭਾਰਤ',
      'header.country.io.246.name': 'ਬ੍ਰਿਟਿਸ਼ ਹਿੰਦ ਮਹਾਂਸਾਗਰ ਪ੍ਰਦੇਸ਼',
      'header.country.iq.964.name': 'ਇਰਾਕ',
      'header.country.it.39.name': 'ਇਟਲੀ',
      'header.country.je.44.name': 'ਜਰਸੀ',
      'header.country.jm.1.name': 'ਜਮਾਏਕਾ',
      'header.country.jo.962.name': 'ਜਾਰਡਨ',
      'header.country.jp.81.name': 'ਜਪਾਨ',
      'header.country.ke.254.name': 'ਕੀਨੀਆ',
      'header.country.kg.996.name': 'ਕਿਰਗਿਸਤਾਨ',
      'header.country.kh.855.name': 'ਕੰਬੋਡੀਆ',
      'header.country.ki.686.name': 'ਕਿਰੀਬਾਤੀ',
      'header.country.km.269.name': 'ਕੋਮੋਰੋਜ਼',
      'header.country.kn.1.name': 'ਸੇਂਟ ਕਿੱਟਸ ਅਤੇ ਨੇਵਿਸ',
      'header.country.kr.82.name': 'ਦੱਖਣੀ ਕੋਰੀਆ',
      'header.country.kw.965.name': 'ਕੁਵੈਤ',
      'header.country.ky.1.name': 'ਕੇਮੈਨ ਆਈਲੈਂਡਜ਼',
      'header.country.kz.7.name': 'ਕਜ਼ਾਕਿਸਤਾਨ',
      'header.country.la.856.name': 'ਲਾਓ ਪੀਪਲਜ਼ ਡੈਮੋਕਰੇਟਿਕ ਰੀਪਬਲਿਕ',
      'header.country.lb.961.name': 'ਲੇਬਨਾਨ',
      'header.country.lc.1.name': 'ਸੇਂਟ ਲੂਸੀਆ',
      'header.country.li.423.name': 'ਲਿਚਟੇਨਸਟਾਈਨ',
      'header.country.lk.94.name': 'ਸ਼ਿਰੀਲੰਕਾ',
      'header.country.lr.231.name': 'ਲਾਇਬੇਰੀਆ',
      'header.country.ls.266.name': 'ਲੈਸੋਥੋ',
      'header.country.lt.370.name': 'ਲਿਥੁਆਨੀਆ',
      'header.country.lu.352.name': 'ਲਕਸਮਬਰਗ',
      'header.country.lv.371.name': 'ਲਾਤਵੀਆ',
      'header.country.ly.218.name': 'ਲੀਬੀਆ',
      'header.country.ma.212.name': 'ਮੋਰੋਕੋ',
      'header.country.mc.377.name': 'ਮੋਨੈਕੋ',
      'header.country.md.373.name': 'ਮਾਲਡੋਵਾ, ਗਣਤੰਤਰ',
      'header.country.me.382.name': 'ਮੌਂਟੇਨੇਗਰੋ',
      'header.country.mf.590.name': 'ਸੇਂਟ ਮਾਰਟਿਨ',
      'header.country.mg.261.name': 'ਮੈਡਾਗਾਸਕਰ',
      'header.country.mh.692.name': 'ਮਾਰਸ਼ਲ ਟਾਪੂ',
      'header.country.mk.389.name': 'ਮੈਸੇਡੋਨੀਆ, ਯੂਗੋਸਲਾਵ ਦਾ ਸਾਬਕਾ ਗਣਰਾਜ',
      'header.country.ml.223.name': 'ਮਾਲੀ',
      'header.country.mm.95.name': 'ਮਿਆਂਮਾਰ',
      'header.country.mn.976.name': 'ਮੰਗੋਲੀਆ',
      'header.country.mo.853.name': 'ਮਕਾਓ',
      'header.country.mp.1.name': 'ਉੱਤਰੀ ਮਾਰੀਆਨਾ ਟਾਪੂ',
      'header.country.mq.596.name': 'ਮਾਰਟਿਨਿਕ',
      'header.country.mr.222.name': 'ਮੌਰੀਟਾਨੀਆ',
      'header.country.ms.1.name': 'ਮਾਂਟਸੇਰੇਟ',
      'header.country.mt.356.name': 'ਮਾਲਟਾ',
      'header.country.mu.230.name': 'ਮਾਰੀਸ਼ਸ',
      'header.country.mv.960.name': 'ਮਾਲਦੀਵ',
      'header.country.mw.265.name': 'ਮਾਲਾਵੀ',
      'header.country.mx.52.name': 'ਮੈਕਸੀਕੋ',
      'header.country.my.60.name': 'ਮਲੇਸ਼ੀਆ',
      'header.country.mz.258.name': 'ਮੋਜ਼ਾਮਬੀਕ',
      'header.country.na.264.name': 'ਨਾਮੀਬੀਆ',
      'header.country.nc.687.name': 'ਨਿ C ਕੈਲੇਡੋਨੀਆ',
      'header.country.ne.227.name': 'ਨਾਈਜਰ',
      'header.country.nf.672.name': 'ਨਾਰਫੋਕ ਟਾਪੂ',
      'header.country.ng.234.name': 'ਨਾਈਜੀਰੀਆ',
      'header.country.ni.505.name': 'ਨਿਕਾਰਾਗੁਆ',
      'header.country.nl.31.name': 'ਨੀਦਰਲੈਂਡਸ',
      'header.country.no.47.name': 'ਨਾਰਵੇ',
      'header.country.np.977.name': 'ਨੇਪਾਲ',
      'header.country.nr.674.name': 'ਨੌਰੂ',
      'header.country.nu.683.name': 'ਨੀਯੁ',
      'header.country.nz.64.name': 'ਨਿਊਜ਼ੀਲੈਂਡ',
      'header.country.om.968.name': 'ਓਮਾਨ',
      'header.country.pa.507.name': 'ਪਨਾਮਾ',
      'header.country.pe.51.name': 'ਪੇਰੂ',
      'header.country.pf.689.name': 'ਫਰੈਂਚ ਪੋਲੀਸਨੀਆ',
      'header.country.pg.675.name': 'ਪਾਪੁਆ ਨਿ Gu ਗਿੰਨੀ',
      'header.country.ph.63.name': 'ਫਿਲੀਪੀਨਜ਼',
      'header.country.pk.92.name': 'ਪਾਕਿਸਤਾਨ',
      'header.country.pl.48.name': 'ਪੋਲੈਂਡ',
      'header.country.pm.508.name': 'ਸੇਂਟ ਪਿਅਰੇ ਐਂਡ ਮਿਕਵੇਲਨ',
      'header.country.pn.870.name': 'ਪਿਟਕੇਰਨ',
      'header.country.pr.1.name': 'ਪੋਰਟੋ ਰੀਕੋ',
      'header.country.ps.970.name': 'ਫਿਲਸਤੀਨ',
      'header.country.pt.351.name': 'ਪੁਰਤਗਾਲ',
      'header.country.pw.680.name': 'ਪਲਾਉ',
      'header.country.py.595.name': 'ਪੈਰਾਗੁਏ',
      'header.country.qa.974.name': 'ਕਤਰ',
      'header.country.re.262.name': 'ਰੀਯੂਨੀਅਨ',
      'header.country.ro.40.name': 'ਰੋਮਾਨੀਆ',
      'header.country.rs.381.name': 'ਸਰਬੀਆ',
      'header.country.ru.7.name': 'ਰਸ਼ੀਅਨ ਫੈਡਰੇਸ਼ਨ',
      'header.country.rw.250.name': 'ਰਵਾਂਡਾ',
      'header.country.sa.966.name': 'ਸਊਦੀ ਅਰਬ',
      'header.country.sb.677.name': 'ਸੁਲੇਮਾਨ ਆਈਲੈਂਡਜ਼',
      'header.country.sc.248.name': 'ਸੇਚੇਲਜ਼',
      'header.country.se.46.name': 'ਸਵੀਡਨ',
      'header.country.sg.65.name': 'ਸਿੰਗਾਪੁਰ',
      'header.country.sh.290.name': 'ਸੇਂਟ ਹੇਲੇਨਾ, ਅਸੈਂਸ਼ਨ ਐਂਡ ਟ੍ਰਿਸਟਨ ਡਾ ਕੂਨਹਾ',
      'header.country.si.386.name': 'ਸਲੋਵੇਨੀਆ',
      'header.country.sk.421.name': 'ਸਲੋਵਾਕੀਆ',
      'header.country.sl.232.name': 'ਸੀਅਰਾ ਲਿਓਨ',
      'header.country.sm.378.name': 'ਸੈਨ ਮਰੀਨੋ',
      'header.country.sn.221.name': 'ਸੇਨੇਗਲ',
      'header.country.so.252.name': 'ਸੋਮਾਲੀਆ',
      'header.country.sr.597.name': 'ਸੂਰੀਨਾਮ',
      'header.country.st.239.name': 'ਸਾਓ ਟੋਮ ਅਤੇ ਪ੍ਰਿੰਸੀਪਲ',
      'header.country.sv.503.name': 'ਐਲ ਸਾਲਵਾਡੋਰ',
      'header.country.sx.1.name': 'ਸਿੰਟ ਮਾਰਟਿਨ',
      'header.country.sz.268.name': 'ਸਵਾਜ਼ੀਲੈਂਡ',
      'header.country.tc.1.name': 'ਤੁਰਕਸ ਅਤੇ ਕੈਕੋਸ ਟਾਪੂ',
      'header.country.td.235.name': 'ਚਾਡ',
      'header.country.tg.228.name': 'ਹੁਣੇ ਜਾਣਾ',
      'header.country.th.66.name': 'ਥਾਈਲੈਂਡ',
      'header.country.tj.992.name': 'ਤਾਜਿਕਸਤਾਨ',
      'header.country.tk.690.name': 'ਟੋਕੇਲਾਓ',
      'header.country.tl.670.name': 'ਤਿਮੋਰ-ਲੇਸਟ',
      'header.country.tm.993.name': 'ਤੁਰਕਮੇਨਿਸਤਾਨ',
      'header.country.tn.216.name': 'ਟਿisਨੀਸ਼ੀਆ',
      'header.country.to.676.name': 'ਟੋਂਗਾ',
      'header.country.tr.90.name': 'ਟਰਕੀ',
      'header.country.tt.1.name': 'ਤ੍ਰਿਨੀਦਾਦ & amp; ਟੋਬੈਗੋ',
      'header.country.tv.688.name': 'ਤੁਵਾਲੁ',
      'header.country.tw.886.name': 'ਤਾਈਵਾਨ',
      'header.country.tz.255.name': 'ਤਨਜ਼ਾਨੀਆ, ਯੂਨਾਈਟਿਡ ਰੀਪਬਲਿਕ ਆਫ',
      'header.country.ug.256.name': 'ਯੂਗਾਂਡਾ',
      'header.country.us.1.name': 'ਸੰਯੁਕਤ ਪ੍ਰਾਂਤ',
      'header.country.uy.598.name': 'ਉਰੂਗਵੇ',
      'header.country.uz.998.name': 'ਉਜ਼ਬੇਕਿਸਤਾਨ',
      'header.country.va.379.name': 'ਹੋਲੀ ਸੀ',
      'header.country.vc.1.name': 'ਸੇਂਟ ਵਿਨਸੈਂਟ & amp; ਗ੍ਰੇਨਾਡਾਈਨਜ਼',
      'header.country.ve.58.name': 'ਵੈਨਜ਼ੂਏਲਾ, ਬੋਲੀਵੀਰੀਆ ਰੀਪਬਲਿਕ ਆਫ',
      'header.country.vg.1.name': 'ਬ੍ਰਿਟਿਸ਼ ਵਰਜਿਨ ਟਾਪੂ',
      'header.country.vi.1.name': 'ਯੂਐਸ ਵਰਜਿਨ ਆਈਲੈਂਡਸ',
      'header.country.vn.84.name': 'ਵੀਅਤਨਾਮ',
      'header.country.vu.678.name': 'ਵੈਨੂਆਟੂ',
      'header.country.wf.681.name': 'ਵਾਲਿਸ ਅਤੇ ਫੁਟੁਨਾ',
      'header.country.ws.685.name': 'ਸਮੋਆ',
      'header.country.xk.383.name': 'ਕੋਸੋਵੋ',
      'header.country.ye.967.name': 'ਯਮਨ',
      'header.country.yt.262.name': 'ਮੇਯੋਟ',
      'header.country.za.27.name': 'ਦੱਖਣੀ ਅਫਰੀਕਾ',
      'header.country.zm.260.name': 'ਜ਼ੈਂਬੀਆ',
      'header.country.zw.263.name': 'ਜ਼ਿੰਬਾਬਵੇ',
      'header.TOP_COUNTRIES_LABEL': 'ਚੋਟੀ ਦੇ ਦੇਸ਼',
      'header.OTHER_COUNTRIES_LABEL': 'ਹੋਰ ਦੇਸ਼',
      'header.switch.to.english.text': 'ਅੰਗਰੇਜ਼ੀ ਵਿਚ ਬਦਲੋ',
      'header.hotels.message.for.arabic':
          'ਅਰਬ ਵਿਚ ਹੋਟਲ ਬ੍ਰਾingਜ਼ਿੰਗ ਲਈ ਸਹਾਇਤਾ ਜਲਦੀ ਹੀ ਆਵੇਗੀ',
      'header.please.proceed.text': 'ਹਾਂ ਕਿਰਪਾ ਕਰਕੇ ਅੱਗੇ ਵਧੋ',
      'header.cancel.text': 'ਰੱਦ ਕਰੋ',
      'header.not.supporting.arabic':
          'ਅਰਬ ਵਿਚ ਹੋਟਲ ਬ੍ਰਾingਜ਼ਿੰਗ ਲਈ ਸਹਾਇਤਾ ਜਲਦੀ ਹੀ ਆਵੇਗੀ. ਅਸੀਂ ਤੁਹਾਨੂੰ ਇੰਗਲਿਸ਼ ਵੈਬਸਾਈਟ ਤੇ ਲੈ ਜਾਵਾਂਗੇ',
      'header.ENGLISH': 'ਅੰਗਰੇਜ਼ੀ',
      'header.ARABIC': 'ਅਰਬਿਕ',
      'header.cancel.capitalised.text': 'ਰੱਦ ਕਰੋ',
      'header.country.dropdown': {
        IN: 'ਭਾਰਤ',
        AE: 'ਯੂਏਈ',
        US: 'ਸਾਨੂੰ',
      },
    },
    FLIGHTS_UI_MESSAGES: {
      searchWidget: {
        tripType: {
          inputLabel: 'ਟਰਿਪ ਕਿਸਮ',
          options: {
            O: 'ਇੱਕ ਹੀ ਰਸਤਾ',
            R: 'ਸੈਰ',
            M: 'ਮਲਟੀ ਸਿਟੀ',
          },
        },
        src: {
          inputLabel: 'ਤੋਂ',
          placeholder: 'ਸ਼ਹਿਰ ਦਾਖਲ ਹੋਵੋ',
        },
        dest: {
          inputLabel: 'ਟੂ',
          placeholder: 'ਸ਼ਹਿਰ ਦਾਖਲ ਹੋਵੋ',
        },
        departure: {
          inputLabel: 'ਰਵਾਨਗੀ',
        },
        return: {
          inputLabel: 'ਵਾਪਸ ਆਓ',
          placeholder: 'ਵਾਪਸੀ ਦੀ ਚੋਣ ਕਰੋ',
        },
        pnc: {
          inputLabel: 'ਪਾਸਵਰਡ ਅਤੇ ਕਲਾਸ',
          inputValues: {
            Adults: 'ਬਾਲਗ',
            Travellers: 'ਯਾਤਰੀ',
            Adult: 'ਬਾਲਗ',
            Traveller: 'ਯਾਤਰੀ',
            'Group Booking': 'ਸਮੂਹ ਬੁਕਿੰਗ',
          },
          options: {
            adults: {
              inputLabel: 'ਬਾਲਗ਼ (12 ਸਾਲਾ +)',
              groupBookingTooltip: "9 ਤੋਂ ਵੱਧ ਯਾਤਰੀਆਂ ਨਾਲ ਬੁਕਿੰਗ 'ਤੇ ਬਚਤ ਕਰੋ",
              ontheDayTravelText: 'ਯਾਤਰਾ ਦੇ ਦਿਨ',
            },
            children: {
              inputLabel: 'ਬੱਚੇ (2y - 12y)',
              ontheDayTravelText: 'ਯਾਤਰਾ ਦੇ ਦਿਨ',
            },
            infants: {
              inputLabel: 'ਜਾਣਕਾਰੀ (2 ਸਾਲ ਤੋਂ ਘੱਟ)',
              ontheDayTravelText: 'ਯਾਤਰਾ ਦੇ ਦਿਨ',
            },
            travelClass: {
              inputLabel: 'ਯਾਤਰਾ ਕਲਾਸ ਚੁਣੋ',
              optionsLabels: {
                Economy: 'ਆਰਥਿਕਤਾ',
                'Economy / Premium Economy': 'ਆਰਥਿਕਤਾ / ਪ੍ਰੀਮੀਅਮ ਆਰਥਿਕਤਾ',
                'Premium Economy': 'ਪ੍ਰੀਮੀਅਮ ਆਰਥਿਕਤਾ',
                Business: 'ਕਾਰੋਬਾਰ',
                'First Class': 'ਬਹੁਤ ਵਧੀਆ',
              },
            },
          },
          btnLabel: 'ਹੋ ਗਿਆ',
        },
        ctaButtonText: 'ਭਾਲ ਕਰੋ',
        tripPrefix: 'ਟਰਿਪ',
        addCityBtnText: '+ ਸ਼ਹਿਰ ਸ਼ਾਮਲ ਕਰੋ',
        'SEARCH RESULTS': 'ਖੋਜ ਨਤੀਜੇ',
        'NEARBY CITIES': 'ਨੇੜਲੇ ਸ਼ਹਿਰ',
        errMessages: {
          guestCount: 'ਕੁਲ ਮਹਿਮਾਨਾਂ ਦੀ ਗਿਣਤੀ 9 ਤੋਂ ਵੱਧ ਨਹੀਂ ਹੋ ਸਕਦੀ',
          infantCount: 'ਬੱਚਿਆਂ ਦੀ ਗਿਣਤੀ ਬਾਲਗਾਂ ਦੀ ਗਿਣਤੀ ਤੋਂ ਵੱਧ ਨਹੀਂ ਹੋ ਸਕਦੀ',
        },
      },
      searchLoadingMessage: 'ਹੋਲਡ ਹੋਵੋ, ਅਸੀਂ ਤੁਹਾਡੇ ਲਈ ਉਡਾਣਾਂ ਲੈ ਰਹੇ ਹਾਂ',
      defaultErrorMessages: {
        NWE: {
          title: 'ਨੈੱਟਵਰਕ ਦੀ ਸਮੱਸਿਆ',
          subtitle:
              'ਅਸੀਂ ਤੁਹਾਡੀ ਡਿਵਾਈਸ ਤੋਂ ਸਾਡੇ ਸਿਸਟਮ ਨਾਲ ਜੁੜਨ ਵਿੱਚ ਅਸਮਰੱਥ ਹਾਂ. ਕਿਰਪਾ ਕਰਕੇ ਥੋੜ੍ਹੀ ਦੇਰ ਬਾਅਦ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
        },
        JSE: {
          title: 'ਕਲਾਇੰਟ ਸਾਫਟਵੇਅਰ ਅਪਵਾਦ',
          subtitle:
              'ਅਸੀਂ ਇਸ ਨੂੰ ਆਸਾਨੀ ਨਾਲ ਹੱਲ ਕਰਾਂਗੇ. ਕਿਰਪਾ ਕਰਕੇ ਥੋੜ੍ਹੀ ਦੇਰ ਬਾਅਦ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ.',
        },
        DEFAULT: {
          title: 'ਓਹ ਹੋ! ਪੇਜ ਨੂੰ ਲੋਡ ਕਰਨ ਵਿੱਚ ਇੱਕ ਸਮੱਸਿਆ ਹੋਈ ਸੀ',
          subtitle:
              "ਸਾਡੇ ਸਿਸਟਮ ਕਿਸੇ ਮੁੱਦੇ ਦਾ ਅਨੁਭਵ ਕਰ ਰਹੇ ਹਨ. ਅਸੀਂ ਇਸ ਨੂੰ ਆਸਾਨੀ ਨਾਲ ਹੱਲ ਕਰਨ 'ਤੇ ਕੰਮ ਕਰ ਰਹੇ ਹਾਂ. ਕਿਰਪਾ ਕਰਕੇ ਪੇਜ ਨੂੰ ਤਾਜ਼ਾ ਕਰੋ ਜਾਂ ਪਿਛਲੇ ਪੰਨੇ ਤੇ ਵਾਪਸ ਜਾਓ",
        },
        rightCtaText: 'ਤਾਜ਼ਾ ਕਰੋ',
      },
      flightDetails: {
        title: 'ਉਡਾਣ ਦੇ ਵੇਰਵੇ',
        baggageLabel: 'ਸਾਮਾਨ :',
        checkinLabel: 'ਚੈੱਕ ਕਰੋ ਇਨ',
        cabinLabel: 'ਕੈਬਿਨ',
        tabs: {
          'FLIGHT DETAILS': 'ਫਲਾਈਟ ਵੇਰਵੇ',
          'FARE SUMMARY': 'ਮੁਫਤ ਸੰਖੇਪ',
          CANCELLATION: 'ਰੱਦ',
          'DATE CHANGE': 'ਤਾਰੀਖ ਤਬਦੀਲੀ',
        },
        loaderText: 'ਵੇਰਵਾ ਪ੍ਰਾਪਤ ਕਰ ਰਿਹਾ ਹੈ ...',
        hideShowBtn: 'ਦਿਖਾਓ',
        notAvlText: 'ਜਾਣਕਾਰੀ ਉਪਲਬਧ ਨਹੀਂ ਹੈ',
      },
      flightsListing: {
        sorterTitle: 'ਕ੍ਰਮਬੱਧ:',
        bookNowCTAText: 'ਹੁਣੇ ਬੁੱਕ ਕਰੋ',
        multiFareHidePricesText: 'ਭਾਅ ਲੁਕਾਓ',
        plusDayTemplate: '+ {{count}} ਦਿਨ',
        loadersText: {
          selectingFlight: 'ਆਪਣੀ ਉਡਾਣ ਦੀ ਚੋਣ ਕਰ ਰਿਹਾ ਹੈ ...',
          moreFaresSplit: 'ਤੁਹਾਡੇ ਲਈ ਵਧੇਰੇ ਕਿਰਾਇਆ ਪ੍ਰਾਪਤ ਕਰ ਰਿਹਾ ਹੈ ...',
          moreFares: 'ਹੋਰ ਕਿਰਾਇਆ ਪ੍ਰਾਪਤ ਕਰ ਰਿਹਾ ਹੈ ...',
          gettingFlights: 'ਫੜੋ, ਅਸੀਂ ਉਡਾਣਾਂ ਪ੍ਰਾਪਤ ਕਰ ਰਹੇ ਹਾਂ ..',
          submitting: 'ਜਮ੍ਹਾ ਕਰ ਰਿਹਾ ਹੈ ...',
        },
        splitFooter: {
          fareDetailsText: 'ਕਿਰਾਇਆ ਵੇਰਵਾ',
        },
        mcTripTxt: 'Trip {{index}}',
        otherFlightsHeading: 'ਹੋਰ ਉਡਾਣਾਂ',
        selectFareText: 'ਕਿਰਾਇਆ ਚੁਣੋ',
        discountsTitle: {
          boldText: 'ਗਰਮ',
          normalText: 'ਸੌਦੇ',
        },
        hideShowTimingsOptions: {
          more: 'ਹੋਰ ਸਮਾਂ ਚੋਣ',
          less: 'ਘੱਟ ਟਾਈਮਿੰਗ ਵਿਕਲਪ',
        },
      },
      flightsFilters: {
        FILTERED_OUT_TEXT: {
          TITLE: 'ਬਹੁਤ ਸਾਰੇ ਫਿਲਟਰ ਲਾਗੂ ਕੀਤੇ ਗਏ!',
          DESC: 'ਤੁਹਾਡੇ ਦੁਆਰਾ ਚੁਣੇ ਗਏ ਸਾਰੇ ਫਿਲਟਰਾਂ ਦੇ ਨਾਲ ਅਸੀਂ ਕੋਈ ਉਡਾਣਾਂ ਨਹੀਂ ਲੱਭ ਸਕੇ. ਕੁਝ ਫਿਲਟਰ ਹਟਾਉਣ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
          OrText: 'ਜਾਂ',
        },
        clearAllFiltersText: 'ਸਾਰੇ ਫਿਲਟਰ ਸਾਫ਼ ਕਰੋ',
        appliedFiltersText: 'ਲਾਗੂ ਫਿਲਟਰ',
        clearAppliedFiltersText: 'ਸਾਰਾ ਸਾਫ ਕਰੋ',
        loadersText: {
          'Popular filters': 'ਪ੍ਰਸਿੱਧ ਫਿਲਟਰ',
          Price: 'ਮੁੱਲ',
          Departure: 'ਰਵਾਨਗੀ',
          Airlines: 'ਏਅਰਲਾਇੰਸ',
          Arrival: 'ਪਹੁੰਚਣਾ',
        },
      },
      flightsFiltersOld: {
        moreFiltersText: 'ਹੋਰ ਫਿਲਟਰ',
        resetBtnText: 'ਰੀਸੈੱਟ',
        applyBtnText: 'ਲਾਗੂ ਕਰੋ',
        cancelBtnText: 'ਰੱਦ ਕਰੋ',
        moreAirlinesText: '+ {{count}} ਏਅਰਲਾਈਨਾਂ',
        FILTERED_OUT_TEXT: {
          TITLE: 'ਬਹੁਤ ਸਾਰੇ ਫਿਲਟਰ ਲਾਗੂ ਕੀਤੇ ਗਏ!',
          DESC: 'ਫਿਲਟਰ ਦੇ ਵੱਖਰੇ ਸੁਮੇਲ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ.',
        },
        clearAllFiltersText: 'ਸਾਰੇ ਫਿਲਟਰ ਸਾਫ਼ ਕਰੋ',
        mcFiltersTitle: 'ਫਿਲਟਰ:',
      },
      reviewOnwardHeader: {
        pageNames: {
          'Review your booking': 'ਆਪਣੀ ਬੁਕਿੰਗ ਦੀ ਸਮੀਖਿਆ ਕਰੋ',
          'Traveller & Addons': 'ਯਾਤਰੀ ਅਤੇ ਐਡਸਨ',
          'Booking Summary': 'ਬੁਕਿੰਗ ਸੰਖੇਪ',
        },
        timelineSteps: {
          flight: 'ਫਲਾਈਟ ਚੁਣੀ ਗਈ',
          review: 'ਸਮੀਖਿਆ',
          traveller: 'ਯਾਤਰੀ ਵੇਰਵਾ',
          itinerary: 'ਬੁਕਿੰਗ ਸੰਖੇਪ',
          pay: 'ਭੁਗਤਾਨ ਕਰੋ',
        },
      },
      itineraryTitle: 'ਯਾਤਰਾ',
      flightSummaryTitle: 'ਫਲਾਈਟ ਸੰਖੇਪ',
      fareSummaryTitle: 'ਕਿਰਾਇਆ ਸਾਰ',
      reviewLoaderTexts: {
        itLoaderText: 'ਵੇਰਵਾ ਪ੍ਰਾਪਤ ਕਰ ਰਿਹਾ ਹੈ ...',
        fareDetailsLoaderText: 'ਕਿਰਾਏ ਦੇ ਵੇਰਵੇ ਪ੍ਰਾਪਤ ਕਰ ਰਿਹਾ ਹੈ ...',
        submitReviewLoaderText: 'ਸਮੀਖਿਆ ਜਮ੍ਹਾਂ ਕਰ ਰਿਹਾ ਹੈ',
        submitTravellerLoaderText: 'ਯਾਤਰੀ ਵੇਰਵਿਆਂ ਨੂੰ ਜਮ੍ਹਾਂ ਕਰਨਾ',
        layoverInfoLoaderText: 'ਲੇਓਵਰ ਜਾਣਕਾਰੀ ਪ੍ਰਾਪਤ ਕਰ ਰਿਹਾ ਹੈ ...',
        headingLoaderText: '51 ਮਿਲੀਅਨ ਉਪਭੋਗਤਾ ਅਤੇ ਗਿਣਤੀ',
      },
      review: {
        continueCTA: 'ਜਾਰੀ ਰੱਖੋ',
        outOfPolicyTooltip: {
          title: 'ਮਹੱਤਵਪੂਰਨ',
        },
      },
      fareRules: {
        title: 'ਕਿਰਾਏ ਦੇ ਨਿਯਮ',
        loaderText: 'ਕਿਰਾਏ ਦੇ ਨਿਯਮ ਲਿਆਏ ਜਾ ਰਹੇ ਹਨ',
        noDataText: 'ਜਾਣਕਾਰੀ ਉਪਲਬਧ ਨਹੀਂ ਹੈ',
        tabs: {
          'Cancellation Charges': 'ਰੱਦ ਕਰਨ ਦੇ ਖਰਚੇ',
          'Date change charges': 'ਮਿਤੀ ਤਬਦੀਲੀ ਦੇ ਖਰਚੇ',
        },
      },
      fastForward: {
        ctaText: 'ਹੋ ਗਿਆ',
        selectedTemplate: '{{fraction}} ਚੁਣਿਆ ਗਿਆ',
      },
      impInfo: {
        title: 'ਮਹੱਤਵਪੂਰਣ ਜਾਣਕਾਰੀ',
      },
      addOnsHeading: 'ਐਡ-ਆਨਸ',
      coupons: {
        inputPlaceholder: 'ਕੂਪਨ ਕੋਡ ਦਰਜ ਕਰੋ',
        applyBtnText: 'ਲਾਗੂ ਕਰੋ',
        removeBtnText: 'ਹਟਾਓ',
        'VIEW ALL OFFERS': 'ਸਾਰੇ ਪੇਸ਼ਕਸ਼ਾਂ ਵੇਖੋ',
        'SHOW LESS': 'ਘੱਟ ਦਿਖਾਓ',
        OR: 'ਜਾਂ',
        toastLinkText: 'ਠੀਕ ਹੈ, ਸਮਝ ਗਿਆ!',
      },
      travellerForm: {
        tags: {
          COMPLETE: 'ਪੂਰਾ ਕਰੋ',
          INCOMPLETE: 'ਅਧੂਰਾ',
        },
        travellerTypes: {
          ADULT: 'ਬਾਲਗ',
          CHILD: 'ਬੱਚੇ',
          INFANT: 'ਜਾਣਕਾਰੀ',
        },
        selectedTemplate: '{{ratio}} ਚੁਣਿਆ ਗਿਆ',
        nameConfirmation: {
          title: 'ਨਾਮ ਦੀ ਪੁਸ਼ਟੀ',
          fnLabel: 'ਪਹਿਲਾ ਨਾਂ:',
          lnLabel: 'ਆਖੀਰਲਾ ਨਾਂਮ:',
          closeBtnText: 'ਹੋ ਗਿਆ',
        },
        dateDropdownPlaceholders: {
          date: 'ਤਾਰੀਖ਼',
          month: 'ਮਹੀਨਾ',
          year: 'ਸਾਲ',
        },
        loaderText: {
          submitting: 'ਜਮ੍ਹਾ ਕਰ ਰਿਹਾ ਹੈ ...',
          selecting: 'ਚੁਣ ਰਿਹਾ ਹੈ ...',
        },
        errMessage:
            'ਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ {{criteria}} ਨੂੰ ਚੁਣਿਆ ਹੈ. ਨਵਾਂ ਜੋੜਨ ਤੋਂ ਪਹਿਲਾਂ ਹਟਾਓ.',
      },
      flightDetailsText: 'ਉਡਾਣ ਦੇ ਵੇਰਵੇ',
      insurance: {
        editBtnText: 'ਸੰਪਾਦਿਤ ਕਰੋ',
        showMoreText: 'ਹੋਰ',
        showLessText: 'ਘੱਟ',
        daysInputPlaceholder: 'ਦਿਨ ਦੀ ਗਿਣਤੀ ਦਰਜ ਕਰੋ',
        daysDoneCtaText: 'ਹੋ ਗਿਆ',
        toastLinkText: 'ਠੀਕ ਹੈ, ਸਮਝ ਗਿਆ!',
        benefitPrefix: 'ਦਾਅਵਾ ਕਰੋ',
      },
      acknowledgement: {
        title: 'ਪ੍ਰਵਾਨਗੀ',
        ctaBtnText: {
          createQuote: 'ਹਵਾਲਾ ਬਣਾਓ',
          continue: 'ਜਾਰੀ ਰੱਖੋ',
        },
      },
      ancillaries: {
        loaderText: {
          fetching: 'ਸਹਾਇਕ ਉਪਕਰਣ ਅਤੇ ਐਡ-ਆਨ ਜਾਣਕਾਰੀ',
          updating: 'ਚੁਣੀ ਗਈ ਸਹਾਇਕ ਨੂੰ ਅਪਡੇਟ ਕਰਨਾ',
          submit: 'ਸਹਾਇਕ ਵੇਰਵੇ ਜਮ੍ਹਾਂ ਕਰਨਾ',
        },
        SKIP_TO_PAYMENT: 'ਭੁਗਤਾਨ ਤੇ ਜਾਓ',
        SKIP_ADD_ONS: 'ਛੱਡੋ',
        tabs: {
          Meals: 'ਭੋਜਨ',
          Seats: 'ਸੀਟਾਂ',
          Baggage: 'ਸਾਮਾਨ',
        },
        addMealBtnText: 'ਸ਼ਾਮਲ ਕਰੋ',
        flightSummaryText: 'ਫਲਾਈਟ ਦਾ ਸਾਰ',
        continueBtnLabel: {
          next: 'ਅਗਲਾ',
          continue: 'ਜਾਰੀ ਰੱਖੋ',
          nextSeats: 'ਅੱਗੇ: ਸੀਟਾਂ',
          newFlowPreAttach: 'ਸਪੱਸ਼ਟ ਸੀਟ (ਸ)',
        },
        totalFareText: 'ਕੁੱਲ ਕਿਰਾਏ',
        clearSelectionOverlay: {
          title: 'ਤੁਹਾਨੂੰ ਪੂਰਾ ਵਿਸ਼ਵਾਸ ਹੈ ?',
          subTitle:
              'ਠੀਕ ਹੈ ਤੇ ਕਲਿਕ ਕਰਨ ਨਾਲ, ਤੁਹਾਡੀਆਂ ਸਾਰੀਆਂ ਸੀਟਾਂ, ਭੋਜਨ ਅਤੇ ਵਾਧੂ ਸਮਾਨ ਦੀਆਂ ਚੋਣਾਂ ਨੂੰ ਛੱਡ ਦਿੱਤਾ ਜਾਵੇਗਾ.',
          rcaText: 'ਠੀਕ ਹੈ',
          lcaText: 'ਰੱਦ ਕਰੋ',
        },
        tooltip: {
          seatTaken: 'ਮੁਆਫ ਕਰਨਾ, ਇਹ ਸੀਟ ਮਿਲੀ ਹੈ',
        },
      },
      thankyou: {
        loaderText: 'ਧੰਨਵਾਦ ਵੇਰਵਾ ਲਿਆ ਰਿਹਾ ਹੈ',
        hotelCrossSellTitle: 'ਹੁਣੇ ਆਪਣਾ ਹੋਟਲ ਬੁੱਕ ਕਰੋ',
        hotelOffPercent: '{{offPercent}}% ਦੀ ਛੂਟ',
        refundBreakupText: 'ਰਿਫੰਡ ਬਰੇਕਅਪ',
        fallBack: {
          title: 'ਤੁਹਾਡੀ ਬੁਕਿੰਗ ਜਾਰੀ ਹੈ!',
          msg1: 'ਸਾਨੂੰ ਅਫ਼ਸੋਸ ਹੈ, ਇਹ ਆਮ ਨਾਲੋਂ ਬਹੁਤ ਜ਼ਿਆਦਾ ਸਮਾਂ ਲੈ ਰਿਹਾ ਹੈ ਪਰ ਚਿੰਤਾ ਨਾ ਕਰੋ ਕਿ ਅਸੀਂ ਤੁਹਾਡਾ ਭੁਗਤਾਨ ਮੁੜ ਪ੍ਰਾਪਤ ਕਰ ਲਿਆ ਹੈ ਅਤੇ ਤੁਹਾਡੀ ਬੁਕਿੰਗ ਪ੍ਰਕਿਰਿਆ ਅਧੀਨ ਹੈ.',
          msg2: 'ਜਿਵੇਂ ਹੀ ਇਸ ਦੀ ਪੁਸ਼ਟੀ ਹੋ ਜਾਂਦੀ ਹੈ ਅਸੀਂ ਤੁਹਾਨੂੰ ਸੂਚਿਤ ਕਰਾਂਗੇ. ਤੁਸੀਂ ਪ੍ਰਬੰਧਨ ਬੁਕਿੰਗ ਦੁਆਰਾ ਸਥਿਤੀ ਨੂੰ ਟਰੈਕ ਵੀ ਕਰ ਸਕਦੇ ਹੋ.',
          ctaText: 'ਬੁਕਿੰਗ ਦਾ ਪ੍ਰਬੰਧਨ',
        },
      },
      utils: {
        MONTHS: [
          'ਜਨ',
          'ਫਰਵਰੀ',
          'ਮਾਰ',
          'ਅਪ੍ਰੈਲ',
          'ਮਈ',
          'ਜੂਨ',
          'ਜੁਲਾਈ',
          'ਅਗਸਤ',
          'ਸਤੰਬਰ',
          'ਅਕਤੂਬਰ',
          'ਨਵੰਬਰ',
          'ਦਸੰਬਰ',
        ],
        DAYS: ['ਸੋਮ', 'ਮੰਗਲ', 'ਬੁੱਧ', 'ਤੂ', 'ਸ਼ੁੱਕਰਵਾਰ', 'ਸਤਿ', 'ਸੂਰਜ'],
        TIME: {
          hoursShort: 'h',
          minutesShort: 'ਮੀ',
        },
        genericInputMessage: 'ਤੁਹਾਨੂੰ ਅੰਗ੍ਰੇਜ਼ੀ ਵਿਚ ਟਾਈਪ ਕਰਨ ਦੀ ਬੇਨਤੀ ਕਰੋ',
      },
      loginPopup: {
        b2b: {
          title: 'ਵਧਾਈਆਂ! ਤੁਸੀਂ ਮਾਈਬਿਜ਼ ਵਿੱਚ ਲੌਗ ਇਨ ਹੋ ਗਏ ਹੋ.',
          subtitle:
              'ਕਿਰਾਏ ਦੀ ਚੋਣ, ਮੁਫਤ ਸਹੂਲਤਾਂ *, ਜੀਐਸਟੀ ਲਾਭ ਅਤੇ ਮਾਈਬਿਜ਼ ਉਡਾਣਾਂ ਵਿਚ ਬਹੁਤ ਕੁਝ ਦਾ ਆਨੰਦ ਲਓ',
          leftCtaText: 'ਠੀਕ ਹੈ',
        },
        ctaFlow: {
          title: 'ਵਧਾਈਆਂ! ਤੁਸੀਂ ਐਫੀਲੀਏਟ ਦੇ ਤੌਰ ਤੇ ਲੌਗ ਇਨ ਹੋ ਗਏ ਹੋ.',
          subtitle: "ਤੁਹਾਨੂੰ ਹੋਮਪੇਜ 'ਤੇ ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ",
          leftCtaText: 'ਠੀਕ ਹੈ',
        },
      },
      logoutPopup: {
        b2b: {
          title: 'ਤੁਸੀਂ ਲਾਗ ਆਉਟ ਹੋ ਗਏ ਹੋ!',
          subtitle:
              'ਅਸੀਂ ਤੁਹਾਨੂੰ ਹੋਮਪੇਜ ਤੇ ਲੈ ਜਾ ਰਹੇ ਹਾਂ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਖੋਜ ਕਰੋ.',
          leftCtaText: 'ਠੀਕ ਹੈ, ਸਮਝ ਗਿਆ',
        },
        normalFlow: {
          title: 'ਤੁਸੀਂ ਸਫਲਤਾਪੂਰਵਕ ਲਾਗ ਆਉਟ ਹੋ ਗਏ ਹੋ',
          subtitle:
              "ਕਿਉਂਕਿ ਤੁਸੀਂ ਲੌਗ ਆਉਟ ਕਰ ਚੁੱਕੇ ਹੋ, ਤੁਹਾਡਾ ਕੁੱਲ ਕਿਰਾਏ ਕਿਰਾਏ ਦੇ ਪੇਜ 'ਤੇ ਬਦਲ ਸਕਦੇ ਹਨ. ਇਹ ਤੁਹਾਡੇ ਇਨਾਮ ਬੋਨਸ ਜਾਂ ਕਿਸੇ ਹੋਰ ਪੇਸ਼ਕਸ਼ ਦੇ ਕਾਰਨ ਹੈ ਜੋ ਲਾਗੂ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ ਜੋ ਸਿਰਫ ਤੁਹਾਡੇ ਲੌਗਇਨ ਖਾਤੇ ਲਈ ਲਾਗੂ ਸੀ.",
          leftCtaText: 'ਠੀਕ ਹੈ, ਸਮਝ ਗਿਆ',
        },
      },
    },
  },
};

export const mLingualDataPWA = {
  ara: {
    flightsUiPwa_listing: {
      'timingOptions.selectFlightTagText': 'حدد رحلة لهذا السفر',
      'timingOptions.nonStopText': 'بدون توقف',
      'timingOptions.stopsDescText': '{{stopsCount}} توقف',
      'timingOptions.showMoreBtnText': 'عرض المزيد',
      'timingOptions.showLessBtnText': 'عرض أقل',
      'timingOptions.continueBtnText': 'متابعة ',
      'listingCard.bookBtnText': 'احجز',
      'listingCard.viewMoreBtnTextPlural': '+ {{optionsCountP}} خيارات',
      'listingCard.viewMoreBtnTextSingular': '+ {{optionsCountS}} خيار ',
      'listingCard.lessOptionsBtnText': 'عرض أقل',
      'listingCard.plusDayTemplatePlural':
          '<span class="font10">+{{dayCountP}}</span> أيام ',
      'listingCard.plusDayTemplateSingular':
          '<span class="font10">+{{dayCountS}}</span> يوم ',
      'listingCard.discountMessage':
          'يحصل على ما يصل إلى.{{amount}} عرض العودة لهذه الرحلة ',
      'filtersV2.filterBarTexts.sort': 'ترتيب النتائج ',
      'filtersV2.filterBarTexts.filter': 'ترشيح الرحلات',
      'filtersV2.heading': 'المرشحات والترتيب',
      'filtersV2.tabsTexts.sort': 'مرتبة حسب',
      'filtersV2.tabsTexts.filters': 'المرشحات',
      'filtersV2.filterResultsTemplate':
          '{{filterCount}} من {{totalCount}} نتائج',
      'filtersV2.filterResultsSplitViewTemplate':
          '{{filterCountSV}} المغادرة {{filterCountRT}} العودة',
      'filtersV2.applyBtnText': 'تطبيق',
      'filtersV2.clearBtnText': 'امسح',
      'filtersV2.showMoreAirlinesText': 'عرض المزيد من شركات الطيران',
      'filtersV2.showLessAirlinesText': 'عرض أقل من شركات الطيران',
      'filtersV2.emptyResultsToastMessage':
          'تم تطبيق مرشحات كثيرة، يرجى إلغاء اختيار المرشح الأخير',
      'filtersV2.tooManyFilters.title':
          'تم تطبيق مرشحات عديدة جدا،  يرجى إلغاء تحديد المرشح الأخير!',
      'filtersV2.tooManyFilters.subTitle': 'جرب مجموعة مختلفة من المرشحات',
      'filtersV2.tooManyFilters.ctaBtnText': 'إزالة جميع المرشحات',
      'filtersV2.otherFiltersTitle': 'مرشحات أخرى',
      otherFlightsHeading: 'رحلات أخرى',
      'loadersText.preReview': 'نحن نقدم لك تفاصيل الرحلة ...',
      'loadersText.pageBlock': 'انتظر لحظة ...',
      'flightDetail.heading': 'تفاصيل الرحلة',
      'multiFare.heading': 'خيارات السعر',
      'fareCalendar.heading': 'تقويم الأسعار',
      'fareCalendar.fromToTemplate': '{{fromCityName}} إلى {{toCityName}}',
      'fareCalendar.doneBtnText': 'تمام',
      'fareCalendar.clearBtnText': 'امسح',
      'subHeaderRT.tabs.departText': 'المغادرة',
      'subHeaderRT.tabs.returnText': 'العودة',
      'subHeaderRT.fareInfo.departureText': 'المغادرة',
      'subHeaderRT.fareInfo.returnText': 'العودة',
      'subHeaderRT.returnDiscountMsg.part1': 'تم تطبيق الخصم للعودة|',
      'subHeaderRT.returnDiscountMsg.part2':
          'توفّر {currencySymbol} {discountSum} {currencySymbol}',
      'coachmarks.buttonsTexts.skip': 'تخطى',
      'coachmarks.buttonsTexts.next': 'التالى',
      'coachmarks.buttonsTexts.last': 'حسنًا، فهمت',
      'coachmarks.step1':
          '<span class="LatoBold">انتقل نحو الأسفل</span> لمزيد من الرحلات .<br/> <span class="LatoBold">اضغط</span> للتحديد.',
      'coachmarks.step2a':
          '<span class="LatoBold"> قم بالتمرير إلى اليسار </span> للرحلات من {fromCity}  إلى {toCity}<span class="LatoBold"> اضغط </span> للتحديد.',
      'coachmarks.step2b':
          '<span class="LatoBold">اضغط هنا  </span> للحصول على تفاصيل الرحلات من {fromCity}  إلى {toCity} ',
      'coachmarks.step3':
          '<span class="LatoBold">تطبيق المرشحات</span> لبحث الرحلة الخاصة بك.',
      'coachmarks.step4':
          'اضغط هنا لتحديد <span class="LatoBold"> المرشح السريع.</span>',
      'invalidCombo.moreTimeOptionInvalidTitle': 'مجموعة غير صالحة',
      'invalidCombo.moreTimeOptionInvalidMessage':
          'مواعيد الرحلة المحدودة غير متوافقة. يرجى تحديد خيار موعد آخر.',
      'invalidCombo.rtDomInvalidTitle': 'مجموعة غير صالحة',
      'invalidCombo.rtDomInvalidMessage':
          'مواعيد الرحلة المحدودة غير متوافقة. يرجى أن تكون فجوة لا تقل عن 60 دقيقة بين رحلة الذهاب والعودة',
      'invalidCombo.ctaText': 'حسنا، فهمت',
    },
    flightsUiPwa_common: {
      'searchHeader.editBtnText': 'تعديل',
      'searchHeader.heading': 'تعديل بحث الرحلة',
      'searchHeader.travellerHeading': 'تفاصيل المسافر',
      'fareBreakup.heading': 'تفاصيل الأسعار',
      'fareBreakup.totalAmtText': 'إجمالي المبلغ :',
      autoCompleteNoOptionsText: 'لا يوجد خيارات',
      'wheelDatePicker.captions.date': 'تاريخ',
      'wheelDatePicker.captions.month': 'شهر',
      'wheelDatePicker.captions.year': 'عام',
      'wheelDatePicker.doneBtnText': 'تمام',
      'wheelDatePicker.cancelBtnText': 'إلغاء',
      'errorScreen.title': 'قد واجهت خطأ.',
      'errorScreen.ctaTexts.webview': 'إغلاق',
      'errorScreen.ctaTexts.pwa': 'تحديث',
      'bottomOverlay.loaderText': 'انتظر لحظة ...',
      genericInputErrMessage: 'يرجى الكتابة باللغة الإنجليزية',
    },
    flight_widget_pwa: {
      'flight.pwa.choose.filters.text': 'اختر المرشحات(اختياري)',
      'flight.pwa.one.way.text': 'اتجاه واحد',
      'flight.pwa.roundtrip.text': 'رحلة الذهاب والعودة',
      'flight.pwa.multi.city.text': 'مدن متعددة',
      'flight.pwa.enter.city.airport.text': 'أدخل اسم المدينة / المطار',
      'flight.pwa.number.of.travellers.text': 'إضافة عدد من المسافرين',
      'flight.pwa.day.of.travel.text': ' يوم السفر',
      'flight.pwa.adults.text': 'بالغين',
      'flight.pwa.children.text': 'أطفال',
      'flight.pwa.infants.text': 'الرضع',
      'flight.pwa.adult.text': 'البالغون',
      'flight.pwa.child.text': 'طفل',
      'flight.pwa.infant.text': 'رضيع',
      'flight.pwa.choose.cabin.class.text': 'اختر الفئة الكابينة',
      'flight.pwa.adult.years.text': '12 سنة ومن فوقه',
      'flight.pwa.children.years.text': 'ما بين 2- 12 سنة',
      'flight.pwa.check.out.text': 'تسجيل المغادرة',
      'flight.pwa.check.in.text': 'التسجيل',
      'flight.pwa.date.text': 'تاريخ',
      'flight.pwa.select.text': 'تحديد',
      'flight.pwa.nights.text': 'ليالي',
      'flight.pwa.today.text': 'اليوم',
      'flight.pwa.done.text': 'تمام',
      'flight.pwa.apply.search.text': 'طبّق وابحث عن الرحلات',
      'flight.pwa.to.book.text': 'للحجز',
      'flight.pwa.more.travellers.text': 'أكثر من 9 مسافرين',
      'flight.pwa.call.us.text': 'يرجى الاتصال بنا في ',
      'flight.pwa.get.prices.text': 'واحصل على أسعار جذابة',
      'flight.pwa.etc.text': 'إلخ',
      'flight.pwa.special.fare.text': 'سعر خاص (اختياري)',
      'flight.pwa.select.fare.type': 'حدد نوع السعر',
      'flight.pwa.premium.economy.text': 'سياحية/ سياحية مميزة',
      'flight.pwa.premium.economy.short.text': 'سياحية/ سياحية مميزة',
      'flight.pwa.prem.eco.text': 'سياحية مميزة',
      'flight.pwa.prem.eco.short.text': 'سياحية مميزة',
      'flight.pwa.business.text': 'درجة الأعمال',
      'flight.pwa.search.flights.text': 'البحث عن الرحلات',
      'flight.pwa.travelling.from.text': 'السفر من',
      'flight.pwa.travelling.to.text': 'السفر الى',
      'flight.pwa.from.to.text': 'من - الى',
      'flight.pwa.travel.dates.text': 'مواعيد السفر',
      'flight.pwa.traveller.class.text': 'المسافر ودرجة السفر',
      'flight.pwa.filters.text': 'مرشحات',
      'flight.pwa.select.traveller.class.text': 'حدد المسافر ودرجة السفر',
      'flight.pwa.from.text': 'من ',
      'flight.pwa.to.text': 'إلى',
      'flight.pwa.from.uppercase.text': 'من ',
      'flight.pwa.to.uppercase.text': 'إلى',
      'flight.pwa.save.atleast.text': 'وفّر المزيد في رحلات الذهاب والعودة!',
      'flight.pwa.infant.years.text': 'دون سنتين',
      'flight.pwa.return.date.text': 'تاريخ العودة',
      'flight.pwa.add.return.date.text': '+ إضافة تاريخ العودة',
      'flight.pwa.fare.type.text': 'نوع السعر',
      'flight.pwa.departure.date.text': 'تاريخ المغادرة',
      'flight.pwa.non.stop.filter': 'مباشر',
      'flight.pwa.morning.departure.filter': 'المغادرة الصباحية',
      'flight.pwa.late.departure.filter': 'المغادرة المتأخرة',
      'flight.pwa.one.stop.filter': '1 توقف',
      'flight.pwa.select.departure.date.text': 'حدد تاريخ المغادرة',
      'flight.pwa.select.return.date.text': 'حدد تاريخ العودة',
      'flight.pwa.departure.date.tooltip': 'تاريخ المغادرة من التقويم أعلاه',
      'flight.pwa.return.date.tooltip': 'تاريخ العودة من التقويم أعلاه',
      'flight.pwa.infants.more.than.adults.error':
          'لا يمكن أن يتجاوز عدد الرضع عدد البالغين',
      'flight.pwa.max.passenger.error': 'يمكن حجز لـ9 ركاب في وقت واحد.',
      'flight.pwa.same.from.to.message':
          '"لا يمكن أن تكون مدينة المصدر ومدينة الوجهة سواء"',
      'flight.pwa.select.date.text': 'حدد تاريخ',
      'flight.pwa.add.city.text': '+ أضف مدينة',
      'flight.pwa.regular.text': 'اعتيادي',
      'flight.pwa.student.text': 'طالب',
      'flight.pwa.student.description.text':
          'الطلاب الذين تزيد أعمارهم عن 12 عامًا فقط مؤهلون للحصول على أسعار خاصة و / أو أوزان أمتعة إضافية. يعد حمل بطاقات هوية الطالب وتأشيرات الطلاب الصالحة (عند الاقتضاء) أمرًا إلزاميًا ، وإلا فقد يُمنع \nالراكب من الصعود إلى الطائرة أو يُطلب منه دفع ثمن الأمتعة الإضافية.',
      'flight.pwa.defence.text': 'القوات المسلحة',
      'flight.pwa.defence.description.text':
          'ولا يمكن الاستفادة من هذا السعر الخاص إلا لموظفي القوات المسلحة الهندية العاملين/المتقاعدين وعائلاتهم، ولا بد من إبراز بطاقة هوية سارية للقوات المسلحة أو بطاقة تابعة في المطار ، وبدونها سيتم رفض الصعود إلى الطائرة.',
      'flight.pwa.senior.text': 'مسنّ',
      'flight.pwa.doctor.text': 'طبيب',
      'flight.pwa.doctor.description.text':
          'تُطبق الأسعار المخفضة الخاصة على أخصائيي الرعاية الصحية فقط. يتعين على الركاب الذين حجزوا بموجب هذا السعر تقديم بطاقة هوية صحية سارية المفعول في مكاتب تسجيل الوصول بالمطار',
      'flight.pwa.senior.description.text':
          'يمكن لكبار السن الذين تزيد أعمارهم عن 60 عامًا فقط الاستفادة من هذه الأسعار الخاصة، ولا بد من تقديم دليل على تاريخ الميلاد في المطار ، وبدونه سيتم فرض الأسعار السائدة.',
      'flight.pwa.capital.date.text': 'تاريخ',
      'flight.pwa.flight.search.heading': 'بحث الرحلة',
      'flight.pwa.holiday.singular.text': 'يوم العطلة',
      'flight.pwa.holiday.plural.text': 'أيام العطلات',
      'flight.pwa.city.DXB': 'دبي',
      'flight.pwa.country.united.arab.emirates': 'الإمارات العربية المتحدة',
      'flight.pwa.dubai.international.airport': 'مطار دبي الدولي',
      'flight.pwa.city.singular.text': '+{count} مدينة',
      'flight.pwa.city.plural.text': '+{count} مدن',
      'flight.pwa.traveller.count.error': 'من فضلك، اختر قيمة بين {count} و10',
      'flight.pwa.calendar.months': [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر',
      ],
      'flight.pwa.calendar.months.short': [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر',
      ],
      'flight.pwa.calendar.week-days': [
        'الأحد',
        'الاثنين',
        'الثلاثاء',
        'الأربعاء',
        'الخميس',
        'يوم الجمعة',
        'السبت',
      ],
      'flight.pwa.calendar.week-days.3-digit': [
        'الاحد',
        'الإثنين',
        'الثلاثاء',
        'الأربعاء',
        'الخميس',
        'الجمعة',
        'السبت',
      ],
      'flight.pwa.calendar.week-days.3-digit.iso': [
        'الإثنين',
        'الثلاثاء',
        'الأربعاء',
        'الخميس',
        'الجمعة',
        'السبت',
        'الاحد',
      ],
      'flight.pwa.calendar.week-days.2-digit': [
        'الأحد',
        'الاثنين',
        'الثلاثاء',
        'الأربعاء',
        'الخميس',
        'الجمعة',
        'السبت',
      ],
      'flight.pwa.calendar.week-days.1-digit': [
        'الأحد',
        'الاثنين',
        'الثلاثاء',
        'الأربعاء',
        'الثلاثاء',
        'الجمعة',
        'الأحد',
      ],
      'flight.pwa.search.results.label': 'نتائج البحث',
      'flight.pwa.recent.searches.label': 'عمليات البحث الأخيرة',
      'flight.pwa.popular.searches.label': 'عمليات البحث الشائعة',
      'flight.pwa.no.result.found.label': 'آسف، لا توجد نتائج ل',
      'flight.pwa.please.retry.search.label':
          'يرجى المحاولة مرة أخرى ببحث مختلف',
      'flight.pwa.city.DEL': 'دلهي',
      'flight.pwa.city.NYC': 'نيويورك',
      'flight.pwa.country.india': 'الهند',
      'flight.pwa.delhi.airport': 'مطار دلهي',
      'flight.pwa.country.united.states': 'الولايات المتحدة الأمريكية',
      'flight.pwa.all.airports': 'جميع المطارات',
      'flight.pwa.travellers': 'المسافرون',
      'flight.pwa.traveller': 'مسافر',
      'flight.pwa.city': 'مدينة',
      'flight.pwa.cities': 'مدن',
      'flight.pwa.city.BOM': 'مومباي',
      'flight.pwa.mumbai.airport': 'مطار شاتراباتي شيفاجي الدولي',
      'flight.pwa.city.RUH': 'مدينة الرياض',
      'flight.pwa.country.saudi.arabia': 'المملكة العربية السعودية',
      'flight.pwa.riyadh.international.airport': 'مطار الرياض الدولي',
      'flight.pwa.city.KWI': 'مدينة الكويت',
      'flight.pwa.country.kuwait': 'الكويت',
      'flight.pwa.kuwait.international.airport': 'مطار الكويت الدولي',
      'flight.pwa.city.MCT': 'مسقط',
      'flight.pwa.country.oman': 'سلطنة عمان',
      'flight.pwa.muscat.international.airport': 'مطار مسقط الدولي',
    },
    flightsUiPwa_review: {
      'loaderTexts.fetching': 'يتم جلب معلومات الرحلة...',
      'loaderTexts.waiting': 'انتظر لحظة ...',
      'loaderTexts.fetchingLayover': 'يتم جلب معلومات التوقف',
      'leg.infoNotAvailableText': 'المعلومات غير متوفرة',
      'leg.amenities.title': 'وسائل الراحة',
      'leg.amenities.showLessText': 'عرض أقل',
      'leg.amenities.showMoreText': 'عرض المزيد',
      'leg.baggageTexts.cabin': 'حقيبة الكابين -',
      'leg.baggageTexts.checkin': 'الأمتعة المسجلة -',
      'leg.fareFamilyBtnTemplate': '+{{fareCount}} أسعار',
      'coupons.applyBtnText': 'تطبيق',
      'coupons.removeBtnText': 'إزالة',
      'coupons.inputPlaceholder': 'أدخل رمز القسيمة',
      'coupons.showAllOffersText': 'شاهد جميع العروض',
      'coupons.showLessOffersText': 'عرض أقل',
      'coupons.orText': 'أو',
      'impInfo.tagText': 'معلومات مهمة',
      'footer.ctaBtnText': 'متابعة ',
    },
    flightsUiPwa_reviewTraveller: {
      'loaderTexts.fetching': 'يتم جلب معلومات الرحلة...',
      'loaderTexts.waiting': 'انتظر لحظة ...',
      'travellerForm.heading': 'أضف المسافر',
      'travellerForm.addedTemplate': 'تمت إضافة {{travellerRatio}}',
      'travellerForm.errorMessageTemplate': '{fieldName} مطلوب',
      'travellerForm.confirmCtaText': 'تأكد',
      'travellerForm.errorTexts.selectTraveller':
          'يرجى تحديد المسافر (المسافرين)',
      'travellerForm.errorTexts.selectTravellerNew':
          'أضف تفاصيل المسافر للمتابعة!',
      'travellerForm.errorTexts.moreTravellers':
          'لقد قمت بالفعل بتحديد الحد الأقصى لعدد المسافرين',
      'travellerForm.errorTexts.addAllTravellers':
          'يرجى إضافة جميع المسافرين قبل المتابعة',
      'travellerForm.nameConfirmation.heading': 'تأكيد الاسم',
      'travellerForm.nameConfirmation.firstNameText': 'الاسم الاول:',
      'travellerForm.nameConfirmation.lastNameText': 'اسم العائلة:',
      'travellerForm.nameConfirmation.editBtnText': 'تعديل',
      'travellerForm.nameConfirmation.continueBtnText': 'حسنًا، تابع',
      'contactForm.label': 'رمز البلد',
      'contactForm.placeholder': 'اسم البلد أو الرمز',
      'gstForm.heading': 'معلومات ضريبة السلع والخدمات',
      'fareRules.heading': 'سياسة الاسترداد والأمتعة',
      'fareRules.tabs.CANCELLATION': 'إلغاء',
      'fareRules.tabs.DATE CHANGE': 'تغيير التاريخ',
      'fareRules.tabs.BAGGAGE': 'الأمتعة',
      'fareRules.baggageRuleCard.cabinText': 'مقصورة',
      'fareRules.baggageRuleCard.checkInText': 'تسجيل الدخول',
      'fareRules.notFound.title': 'لا تتوفر أي معلومات ',
      'fareRules.notFound.subTitle':
          'يمكنك التحقق من هذه المعلومات مع شركة الطيران',
      'deals.loginToastMessage': 'قم بتسجيل الدخول لتطبيق هذه العروض',
      'deals.viewMoreBtnText': 'عرض المزيد',
      'footer.ctaBtnText': 'متابعة ',
    },
    login_widget_pwa: {
      'login.widget.pwa.enter.valid.email.error':
          'يرجى إدخال عنوان بريد إلكتروني صالح أو رقم الجوال',
      'login.widget.pwa.enter.valid.emailId.error':
          'الرجاء إدخال عنوان بريد إلكتروني صالح',
      'login.widget.pwa.valid.mobile.number': 'يرجى إدخال رقم الجوال الصالح',
      'login.widget.pwa.otp.error': 'يرجى إدخال كلمة المرور الصالحة',
      'login.widget.pwa.enter.otp': 'أدخل كلمة المرور ',
      'login.widget.pwa.enter.otp.text': 'تم إرسال كلمة المرور',
      'login.widget.pwa.enter.email.phone':
          'أدخل رقم الجوال / البريد الإلكتروني',
      'login.widget.pwa.enter.email': 'أدخل عنوان البريد الإلكتروني',
      'login.widget.pwa.something.went.wrong': 'هناك خطأ ما.',
      'login.widget.pwa.default.message':
          'نحن نواجه بعض المشكلات التقنية في الوقت الحالي. حاول مرة اخرى.',
      'login.widget.pwa.login.default.persuation':
          'سجّل الدخول للحصول على أفضل العروضات للرحلات.',
      'login.widget.pwa.use.mobile.email':
          'استخدم رقم الجوال أو البريد الإلكتروني لتسجيل الدخول / انشاء حساب',
      'login.widget.pwa.enter.password.message':
          'أدخل كلمة المرور المرتبطة بالحساب',
      'login.widget.pwa.enter.password.label': 'أدخل كلمة المرور',
      'login.widget.pwa.pwa.enter.pwd.error.message':
          'يرجى إدخال كلمة المرور الصحيحة',
      'login.widget.pwa.user.already.registered': 'تم تسجيل المستخدم أصلاً',
      'login.widget.pwa.login.via.password': 'تسجيل الدخول عبر كلمة المرور',
      'login.widget.pwa.login.via.otp':
          'تسجيل الدخول عبر أو تي بي (كلمة المرور)',
      'login.widget.pwa.resend.otp': 'إعادة إرسال كلمة المرور',
      'login.widget.pwa.submit': 'إرسال',
      'login.widget.pwa.verify': 'تحقق',
      'login.widget.pwa.forgot.password': 'هل نسيت كلمة المرور؟',
      'login.widget.pwa.save': 'وفّر',
      'login.widget.pwa.continue': 'متابعة',
      'login.widget.pwa.resend.otp.whatsapp':
          'إعادة إرسال او تي بي (كلمة المرور) إلى',
      'login.widget.pwa.resend.otp.sub.text': 'الرسائل القصيرة وواتساب',
      'login.widget.pwa.whatsapp.disclaimer':
          'بالضغط على هذا ، أوافق على تلقي الرسائل الهامة مثل OTP وتفاصيل الحجز عن طريق واتساب',
      'login.widget.pwa.welcome.text': 'مرحبا بكم على متن',
      'login.widget.pwa.update.name.heading': 'أدخل اسمك لسرعة تسجيل الخروج',
      'login.widget.pwa.fullname.placeholder': 'اسمك الكامل',
      'login.widget.pwa.fullname.input.header': 'الاسم الكامل',
      'login.widget.pwa.skip': 'تخطى',
      'login.widget.pwa.link.account': 'ربط الحساب',
      'login.widget.pwa.enter.email.id':
          'يرجى إدخال عنوان البريد الإلكتروني الصحيح',
      'login.widget.pwa.not.valid.user':
          'لا يوجد حساب شخصي مرتبط بهذا البريد الإلكتروني',
      'login.widget.pwa.already.have.mob':
          'هذا الحساب لديه رقم هاتف مرتبط أصلا',
      'login.widget.pwa.link.heading.msg': 'ربط {mobile} ب{email}؟',
      'login.widget.pwa.link.account.msg': 'هل ترغب في ربط الحسابين؟',
      'login.widget.pwa.link.msg':
          'يبدو أن رقمك. {mobile} مرتبط بحساب {email}.',
      'login.widget.pwa.link.acc': 'نعم، ربط الحسابات',
      'login.widget.pwa.link.keep.seperate': 'لا ، احتفظ بهذه الأشياء منفصلة',
      'login.widget.pwa.powered.by.mobile.connect': 'مدعوم من Mobile Connect',
      'login.widget.pwa.privacy.policy.msg': 'سياسة الخصوصية\n',
      'login.widget.pwa.user.agremement.msg': 'اتفاقية المستخدم',
      'login.widget.pwa.google': 'جوجل',
      'login.widget.pwa.fb': 'الفيسبوك',
      'login.widget.pwa.incorrect.link.text':
          'عفوًا ،هذا الرابط ليتم فتحه على تطبيق MakeMyTrip الخاص بنا. ومع ذلك ، يمكنك:',
      'login.widget.pwa.login.on.pwa': 'تسجيل الدخول على موبايل ويب',
      'login.widget.pwa.go.to.app': 'احصل على تطبيق ميكمايتريب',
      'login.widget.pwa.login.signup.easily': 'تسجيل الدخول / التسجيل بسهولة',
      'login.widget.pwa.proceed.to.login.msg':
          'بالمضي قدماً فإنك توافق ميكما يتريب على ',
      'login.widget.pwa.tos.msg': 'الشروط والأحكام',
      'login.widget.pwa.create.password.label': 'إنشاء كلمة المرور',
      'login.widget.pwa.create.password.message':
          'لنتأكد الآن من أنك لن تفقد حق الوصول إلى حسابك أبدًا',
      'login.widget.pwa.one.or.numberic.msg': ' حرف رقمي واحد أو أكثر',
      'login.widget.pwa.one.or.more.special.msg':
          ' حرف خاصة واحدة أو أكثر (@ # $٪ ^ & *)',
      'login.widget.pwa.min.characters.msg': ' 8 أحرف أو أكثر',
      'login.widget.pwa.mybiz.account.msg':
          'يبدو أنك تحاول تسجيل الدخول باستخدام حساب myBiz الخاص بك',
      'login.widget.pwa.download.app': 'تحميل التطبيق',
      'login.widget.pwa.create.new.personal.account': 'إنشاء حساب شخصي جديد',
      'login.widget.pwa.login.account.block.error.msg':
          'لقد تجاوزت الحد الأقصى لمحاولات تسجيل الدخول. يرجى المحاولة مرة أخرى بعد',
      'login.widget.pwa.account.blocked':
          'تم حظر تسجيل الدخول. يرجى المحاولة مرة أخرى بعد',
      'login.widget.pwa.logged.in.success': 'لقد قمت بتسجيل الدخول بنجاح',
      'login.widget.pwa.signed.up.success': 'تم انشاء الحساب بنجاح',
      'login.widget.pwa.account.linked.successfully': 'تم ربط الحساب بنجاح',
      'login.widget.pwa.dismiss': 'رفض',
      'login.widget.pwa.mybiz.subheading':
          'myBiz غير متوفر حاليًا على موقع الجوال، للاستمرار في استخدام خدمات myBiz قم بتنزيل',
      'login.widget.pwa.mybiz.subheading.bold': 'تطبيق جوال مجاني',
      'login.widget.pwa.login.auto.fetch.otp': 'يجلب OTP تلقائيا',
      'login.widget.pwa.login.enter.here': 'أدخل هنا...',
      'login.widget.pwa.mconnect.tnc':
          'تم الحصول على رقمك من المشغل الخاص بك لتسجيل الدخول السريع ومن خلال الاستمرار توافق على استخدام نفس الرقم',
      'login.widget.pwa.login.country.name': 'اسم البلد أو الرمز',
      'login.widget.pwa.m.tos.msg': "وكذلك Mobile Connect's",
      'login.widget.pwa.google.error': 'فشل تسجيل الدخول إلى جوجل',
      'login.widget.pwa.facebook.error': 'فشل تسجيل الدخول باستخدام فيسبوك',
      'login.widget.pwa.login.closure.text': 'لتسجيل الدخول',
      'login.widget.enter.email.link.account':
          "أدخل البريد الإلكتروني للحساب الذي تريد <span class='lato-bold'>ربط</span> رقم جوالك <span class='lato-bold'>{mobileNumber}</span> به.",
      'login.widget.login.to.find.cheapest.flight':
          'سجّل الدخول للعثور على الرحلات الجوية بأفضل الأسعار',
      'login.widget.hi.traveller': 'مرحباً بالمسافر',
      'login.signup.for.best.price':
          'تسجيل الدخول / الاشتراك للحصول على الأسعار التنافسية',
      'login.autologout.title': 'انتهت وقت صلاحية تسجيل الدخول',
      'login.autologout.subtitle':
          'لقد تم تسجيل الخروج بسبب عدم النشاط. قم بتسجيل الدخول مرة أخرى للاستمتاع بالتجربة مع ميكمايتريب.',
      'login.autologout.subtitle_re_login':
          "لقد تم تسجيل الخروج بسبب عدم النشاط. <a class='blue-text latoBold'>قم بتسجيل الدخول مرة أخرى</a> للاستمتاع بالتجربة مع ميكمايتريب",
      'login.widget.pwa.login.with.google': 'تسجيل الدخول باستخدام جوجل',
    },
    flightsUiPwa_traveller: {
      'loaderTexts.fetching': 'انتظر من فضلك، نجلب لكم المعلومات...',
      'loaderTexts.waiting': 'انتظر لحظة ...',
      'travellerForm.heading': 'أضف المسافر',
      'travellerForm.clearBtnText': 'واضح',
      'travellerForm.confirmBtnText': 'تأكد',
      'travellerForm.editBtnText': 'تعديل',
      'travellerForm.selectedTemplate': '{{travellerRatio}} تم التحديد',
      'travellerForm.errorTexts.selectAdults': 'يرجى تحديد جميع البالغين',
      'travellerForm.errorTexts.selectChildren': 'يرجى تحديد جميع الأطفال',
      'travellerForm.errorTexts.selectInfants': 'يرجى تحديد جميع الرضع',
      'travellerForm.errorTexts.moreTravellers':
          'لقد قمت بالفعل بتحديد الحد الأقصى لعدد المسافرين',
      'footer.ctaBtnTexts.createQuote': 'إنشاء اقتراح',
      'footer.ctaBtnTexts.continue': 'متابعة ',
    },
    flightsUiPwa_ancillary: {
      'header.title': 'الإضافات',
      'header.skipBtnText': 'تخطي إلى عملية الدفع',
      'loaderTexts.fetching': 'في انتظار المعلومات الإضافية ',
      'loaderTexts.waiting': 'انتظر لحظة ...',
      'clearWarning.title': 'هل أنت متأكد؟',
      'clearWarning.subTitle':
          'بالضغط على "موافق" ، سيتم تجاهل جميع اختياراتك من المقاعد والوجبات والأمتعة الإضافية.',
      'clearWarning.rcaText': 'حسناً',
      'clearWarning.lcaText': 'إلغاء',
      'addonsCommonTexts.addBtnText': 'أضف',
      'addonsCommonTexts.totalFareTemplate': 'مجموعة {{fare}}',
      'addonsCommonTexts.totalFareSubtitle': 'يضاف إلى الأسعار',
      'seats.seatTakenText': 'عذراً، هذا المقعد محجوز أصلاً',
      'tabs.SEATS': 'المقاعد',
      'tabs.MEALS': 'وجبات',
      'tabs.ADDONS': 'إضافات',
      'footer.ctaBtnText': 'التالى',
    },
  },
  eng: {
    flightsUiPwa_listing: {
      'timingOptions.selectFlightTagText': 'Select a flight for this trip',
      'timingOptions.nonStopText': 'Non stop',
      'timingOptions.stopsDescText': '{{stopsCount}} stop(s)',
      'timingOptions.showMoreBtnText': 'Show More',
      'timingOptions.showLessBtnText': 'Show Less',
      'timingOptions.continueBtnText': 'CONTINUE',
      'listingCard.bookBtnText': 'Book',
      'listingCard.viewMoreBtnTextPlural': '+ {{optionsCountP}} options',
      'listingCard.viewMoreBtnTextSingular': '+ {{optionsCountS}} option',
      'listingCard.lessOptionsBtnText': 'Less',
      'listingCard.plusDayTemplatePlural':
          '<span class="font10">+{{dayCountP}}</span> DAYS',
      'listingCard.plusDayTemplateSingular':
          '<span class="font10">+{{dayCountS}}</span> DAY',
      'listingCard.discountMessage':
          'Get up to Rs.{{amount}} return discount on this flight',
      'filtersV2.filterBarTexts.sort': 'Sort Results',
      'filtersV2.filterBarTexts.filter': 'Filter Flights',
      'filtersV2.heading': 'Sort & Filters',
      'filtersV2.tabsTexts.sort': 'Sort by',
      'filtersV2.tabsTexts.filters': 'Filters',
      'filtersV2.filterResultsTemplate':
          '{{filterCount}} of {{totalCount}} results',
      'filtersV2.filterResultsSplitViewTemplate':
          '{{filterCountSV}} Depart {{filterCountRT}} Return',
      'filtersV2.applyBtnText': 'APPLY',
      'filtersV2.clearBtnText': 'CLEAR',
      'filtersV2.showMoreAirlinesText': 'Show More Airlines',
      'filtersV2.showLessAirlinesText': 'Show Less Airlines',
      'filtersV2.emptyResultsToastMessage':
          'Too many filters applied. Please de-select your last filter',
      'filtersV2.tooManyFilters.title':
          'Too many filters applied. Please de-select your last filter!',
      'filtersV2.tooManyFilters.subTitle':
          'Try a different combination of filter',
      'filtersV2.tooManyFilters.ctaBtnText': 'Remove all filters',
      'filtersV2.otherFiltersTitle': 'Other Filters',
      otherFlightsHeading: 'Other Flights',
      'loadersText.preReview': 'Fetching flight details...',
      'loadersText.pageBlock': 'Wait for a moment ...',
      'flightDetail.heading': 'Flight Details',
      'multiFare.heading': 'Fare options',
      'fareCalendar.heading': 'Fare Calendar',
      'fareCalendar.fromToTemplate': '{{fromCityName}} to {{toCityName}}',
      'fareCalendar.doneBtnText': 'DONE',
      'fareCalendar.clearBtnText': 'CLEAR',
      'subHeaderRT.tabs.departText': 'DEPART',
      'subHeaderRT.tabs.returnText': 'RETURN',
      'subHeaderRT.fareInfo.departureText': 'Departure',
      'subHeaderRT.fareInfo.returnText': 'Return',
      'subHeaderRT.returnDiscountMsg.part1': 'Return discount applied |',
      'subHeaderRT.returnDiscountMsg.part2':
          'You save {currencySymbol} {discountSum}',
      'coachmarks.buttonsTexts.skip': 'SKIP',
      'coachmarks.buttonsTexts.next': 'NEXT',
      'coachmarks.buttonsTexts.last': 'OK,GOT IT',
      'coachmarks.step1':
          '<span class="LatoBold">Scroll down</span> for more flights. <br/><span class="LatoBold">Tap</span> to select.',
      'coachmarks.step2a':
          '<span class="LatoBold"> Swipe left </span>for {fromCity} to {toCity} flights. <span class="LatoBold">Tap </span> to select.',
      'coachmarks.step2b':
          '<span class="LatoBold">Tap here </span> to get details of {fromCity} to {toCity} flights',
      'coachmarks.step3':
          '<span class="LatoBold"> Apply filters </span>for your flight search.',
      'coachmarks.step4':
          'Click here to select a<span class="LatoBold">  Quick Filter. </span>',
      'invalidCombo.moreTimeOptionInvalidTitle': 'Invalid combination',
      'invalidCombo.moreTimeOptionInvalidMessage':
          'The selected flight timings are not compatible. Kindly try a different time option.',
      'invalidCombo.rtDomInvalidTitle': 'Invalid combination',
      'invalidCombo.rtDomInvalidMessage':
          'The selected flight timings are not compatible. Please have a minimum difference of 60 minutes between onward & return journey.',
      'invalidCombo.ctaText': 'OKAY,GOT IT',
    },
    flightsUiPwa_common: {
      'searchHeader.editBtnText': 'Edit',
      'searchHeader.heading': 'Modify Flight Search',
      'searchHeader.travellerHeading': 'Traveller details',
      'fareBreakup.heading': 'Fare Breakup',
      'fareBreakup.totalAmtText': 'Total Amount:',
      autoCompleteNoOptionsText: 'No Options',
      'wheelDatePicker.captions.date': 'Date',
      'wheelDatePicker.captions.month': 'Month',
      'wheelDatePicker.captions.year': 'Year',
      'wheelDatePicker.doneBtnText': 'Done',
      'wheelDatePicker.cancelBtnText': 'Cancel',
      'errorScreen.title': 'You have encountered an error.',
      'errorScreen.ctaTexts.webview': 'CLOSE',
      'errorScreen.ctaTexts.pwa': 'REFRESH',
      'bottomOverlay.loaderText': 'Wait for a moment ...',
      genericInputErrMessage: 'Request you to type in English',
    },
    flight_widget_pwa: {
      'flight.pwa.choose.filters.text': 'CHOOSE FILTERS (OPTIONAL)',
      'flight.pwa.one.way.text': 'ONE WAY',
      'flight.pwa.roundtrip.text': 'ROUNDTRIP',
      'flight.pwa.multi.city.text': 'MULTICITY',
      'flight.pwa.enter.city.airport.text': 'Enter City/Airport Name',
      'flight.pwa.number.of.travellers.text': 'ADD NUMBER OF TRAVELLERS',
      'flight.pwa.day.of.travel.text': 'on the day of travel',
      'flight.pwa.adults.text': 'Adults',
      'flight.pwa.children.text': 'Children',
      'flight.pwa.infants.text': 'Infants',
      'flight.pwa.adult.text': 'Adult',
      'flight.pwa.child.text': 'Child',
      'flight.pwa.infant.text': 'Infant',
      'flight.pwa.choose.cabin.class.text': 'CHOOSE CABIN CLASS',
      'flight.pwa.adult.years.text': '12 yrs & above',
      'flight.pwa.children.years.text': '2 - 12 yrs',
      'flight.pwa.check.out.text': 'Check-Out',
      'flight.pwa.check.in.text': 'Check-In',
      'flight.pwa.date.text': 'date',
      'flight.pwa.select.text': 'Select',
      'flight.pwa.nights.text': 'Nights',
      'flight.pwa.today.text': 'Today',
      'flight.pwa.done.text': 'DONE',
      'flight.pwa.apply.search.text': 'APPLY AND SEARCH FLIGHTS',
      'flight.pwa.to.book.text': 'To Book',
      'flight.pwa.more.travellers.text': 'more than 9 travellers',
      'flight.pwa.call.us.text': 'Call us on',
      'flight.pwa.get.prices.text': 'and get attractive prices',
      'flight.pwa.etc.text': 'etc',
      'flight.pwa.special.fare.text': 'SPECIAL FARE (Optional)',
      'flight.pwa.select.fare.type': 'Select Fare Type',
      'flight.pwa.premium.economy.text': 'Economy/Premium Economy',
      'flight.pwa.premium.economy.short.text': 'Eco/Prem. Eco',
      'flight.pwa.prem.eco.text': 'Premium Economy',
      'flight.pwa.prem.eco.short.text': 'Prem. Eco.',
      'flight.pwa.business.text': 'Business',
      'flight.pwa.search.flights.text': 'Search Flights',
      'flight.pwa.travelling.from.text': 'TRAVELLING FROM',
      'flight.pwa.travelling.to.text': 'TRAVELLING TO',
      'flight.pwa.from.to.text': 'From-To',
      'flight.pwa.travel.dates.text': 'TRAVEL DATES',
      'flight.pwa.traveller.class.text': 'TRAVELLER & CLASS',
      'flight.pwa.filters.text': 'FILTERS',
      'flight.pwa.select.traveller.class.text': 'Select Traveller & Class',
      'flight.pwa.from.text': 'From',
      'flight.pwa.to.text': 'To',
      'flight.pwa.from.uppercase.text': 'FROM',
      'flight.pwa.to.uppercase.text': 'TO',
      'flight.pwa.save.atleast.text': 'Save more on round trips!',
      'flight.pwa.infant.years.text': 'Under 2 yrs',
      'flight.pwa.return.date.text': 'RETURN DATE',
      'flight.pwa.add.return.date.text': '+ ADD RETURN DATE',
      'flight.pwa.fare.type.text': 'FARE TYPE',
      'flight.pwa.departure.date.text': 'DEPARTURE DATE',
      'flight.pwa.non.stop.filter': 'Non-Stop',
      'flight.pwa.morning.departure.filter': 'Morning Departure',
      'flight.pwa.late.departure.filter': 'Late Departure',
      'flight.pwa.one.stop.filter': '1 stop',
      'flight.pwa.select.departure.date.text': 'Select Departure Date',
      'flight.pwa.select.return.date.text': 'Select Return Date',
      'flight.pwa.departure.date.tooltip':
          'Departure Date from the calendar above',
      'flight.pwa.return.date.tooltip': 'Return Date from the calendar above',
      'flight.pwa.infants.more.than.adults.error':
          "Number of infants can't exceed number of adults",
      'flight.pwa.max.passenger.error':
          'Upto 9 passengers can be booked at a time.',
      'flight.pwa.same.from.to.message':
          "'Source City and Destination City cannot be the same'",
      'flight.pwa.select.date.text': 'Select Date',
      'flight.pwa.add.city.text': '+ ADD CITY',
      'flight.pwa.regular.text': 'Regular',
      'flight.pwa.student.text': 'Student',
      'flight.pwa.student.description.text':
          'Only students above 12 years of age are eligible for special fares and/or additional baggage allowances. Carrying valid student ID cards and student visas (where applicable) is mandatory, else the passenger may be denied boarding or asked to pay for extra baggage.',
      'flight.pwa.defence.text': 'Armed Forces',
      'flight.pwa.defence.description.text':
          'Only serving/retired Indian Armed Forces personnel & their dependents can avail this special fare. It is mandatory to show a valid Armed Forces ID or dependent card at the airport, without which boarding will be denied.',
      'flight.pwa.senior.text': 'Senior Citizen',
      'flight.pwa.doctor.text': 'Doctor',
      'flight.pwa.doctor.description.text':
          'Special discounted fares are applicable to the Healthcare Professionals only. Passengers booked under this fare are required to produce a valid Healthcare ID card at the airport check-in counters.',
      'flight.pwa.senior.description.text':
          'Only senior citizens above the age of 60 years can avail this special fare. It is mandatory to produce proof of Date of Birth at the airport, without which prevailing fares will be charged.',
      'flight.pwa.capital.date.text': 'DATE',
      'flight.pwa.flight.search.heading': 'Flight Search',
      'flight.pwa.holiday.singular.text': 'Holiday',
      'flight.pwa.holiday.plural.text': 'Holidays',
      'flight.pwa.city.DXB': 'Dubai',
      'flight.pwa.country.united.arab.emirates': 'United Arab Emirates',
      'flight.pwa.dubai.international.airport': 'Dubai International Airport',
      'flight.pwa.city.singular.text': '+{count} City',
      'flight.pwa.city.plural.text': '+{count} Cities',
      'flight.pwa.traveller.count.error':
          'Kindly choose the value between {count}-10',
      'flight.pwa.calendar.months': [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      'flight.pwa.calendar.months.short': [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      'flight.pwa.calendar.week-days': [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      'flight.pwa.calendar.week-days.3-digit': [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
      ],
      'flight.pwa.calendar.week-days.3-digit.iso': [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun',
      ],
      'flight.pwa.calendar.week-days.2-digit': [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa',
      ],
      'flight.pwa.calendar.week-days.1-digit': [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S',
      ],
      'flight.pwa.search.results.label': 'SEARCH RESULTS',
      'flight.pwa.recent.searches.label': 'RECENT SEARCHES',
      'flight.pwa.popular.searches.label': 'POPULAR SEARCHES',
      'flight.pwa.no.result.found.label': 'Sorry, no results found for',
      'flight.pwa.please.retry.search.label':
          'Please try again with a different search',
      'flight.pwa.city.DEL': 'Delhi',
      'flight.pwa.city.NYC': 'New York',
      'flight.pwa.country.india': 'India',
      'flight.pwa.delhi.airport': 'Delhi Airport',
      'flight.pwa.country.united.states': 'US',
      'flight.pwa.all.airports': 'All Airports',
      'flight.pwa.travellers': 'Travellers',
      'flight.pwa.traveller': 'Traveller',
      'flight.pwa.city': 'City',
      'flight.pwa.cities': 'Cities',
      'flight.pwa.city.BOM': 'Mumbai',
      'flight.pwa.mumbai.airport': 'Chhatrapati Shivaji International Airport',
      'flight.pwa.city.RUH': 'Riyadh',
      'flight.pwa.country.saudi.arabia': 'Saudi Arabia',
      'flight.pwa.riyadh.international.airport': 'Riyadh International Airport',
      'flight.pwa.city.KWI': 'Kuwait City',
      'flight.pwa.country.kuwait': 'Kuwait',
      'flight.pwa.kuwait.international.airport': 'Kuwait International Airport',
      'flight.pwa.city.MCT': 'Muscat',
      'flight.pwa.country.oman': 'Oman',
      'flight.pwa.muscat.international.airport': 'Muscat International Airport',
      'flight.pwa.vaccinated.text': 'Vaccination Fares',
      'flight.pwa.vaccinated.description.text':
          'Only vaccinated citizens of India can avail this special fare. It is mandatory to show a valid vaccination certificate notifying the Vaccination Beneficiary ID at the airport, without which boarding will be denied.',
    },
    flightsUiPwa_review: {
      'loaderTexts.fetching': 'Fetching flight information...',
      'loaderTexts.waiting': 'Wait for a moment ...',
      'loaderTexts.fetchingLayover': 'Fetching layover info',
      'leg.infoNotAvailableText': 'Info not available',
      'leg.amenities.title': 'Amenities',
      'leg.amenities.showLessText': 'SHOW LESS',
      'leg.amenities.showMoreText': 'SHOW MORE',
      'leg.baggageTexts.cabin': 'Cabin Bag -',
      'leg.baggageTexts.checkin': 'Checkin Bag -',
      'leg.fareFamilyBtnTemplate': '+{{fareCount}} FARES',
      'coupons.applyBtnText': 'Apply',
      'coupons.removeBtnText': 'Remove',
      'coupons.inputPlaceholder': 'Enter Coupon Code',
      'coupons.showAllOffersText': 'VIEW ALL OFFERS',
      'coupons.showLessOffersText': 'SHOW LESS',
      'coupons.orText': 'OR',
      'impInfo.tagText': 'Important information',
      'footer.ctaBtnText': 'CONTINUE',
    },
    flightsUiPwa_reviewTraveller: {
      'loaderTexts.fetching': 'Fetching flight information...',
      'loaderTexts.waiting': 'Wait for a moment ...',
      'travellerForm.heading': 'Add Traveller',
      'travellerForm.addedTemplate': '{{travellerRatio}} added',
      'travellerForm.errorMessageTemplate': '{fieldName} is required.',
      'travellerForm.confirmCtaText': 'CONFIRM',
      'travellerForm.errorTexts.selectTraveller': 'Please select Traveller(s)',
      'travellerForm.errorTexts.selectTravellerNew':
          'Add traveller details to continue!',
      'travellerForm.errorTexts.moreTravellers':
          'You have already selected maximum number of Traveller(s)',
      'travellerForm.errorTexts.addAllTravellers':
          'Kindly add all travellers before proceeding',
      'travellerForm.nameConfirmation.heading': 'Name Confirmation',
      'travellerForm.nameConfirmation.firstNameText': 'First Name:',
      'travellerForm.nameConfirmation.lastNameText': 'Last Name:',
      'travellerForm.nameConfirmation.editBtnText': 'EDIT',
      'travellerForm.nameConfirmation.continueBtnText': 'OK, CONTINUE',
      'contactForm.label': 'Country Code',
      'contactForm.placeholder': 'Country Name or Code',
      'gstForm.heading': 'GST Information',
      'fareRules.heading': 'Refund and Baggage Policy',
      'fareRules.tabs.CANCELLATION': 'CANCELLATION',
      'fareRules.tabs.DATE CHANGE': 'DATE CHANGE',
      'fareRules.tabs.BAGGAGE': 'BAGGAGE',
      'fareRules.baggageRuleCard.cabinText': 'Cabin',
      'fareRules.baggageRuleCard.checkInText': 'Check-in',
      'fareRules.notFound.title': 'No information available',
      'fareRules.notFound.subTitle':
          'You can check this information with the airline',
      'deals.loginToastMessage': 'Log-in to apply these offers',
      'deals.viewMoreBtnText': 'View more',
      'footer.ctaBtnText': 'CONTINUE',
    },
    login_widget_pwa: {
      'login.widget.pwa.enter.valid.email.error':
          'Please enter a valid Email Id or Mobile Number',
      'login.widget.pwa.enter.valid.emailId.error':
          'Please enter a valid Email Id',
      'login.widget.pwa.valid.mobile.number':
          'Please enter a valid phone number',
      'login.widget.pwa.otp.error': 'Please enter a valid OTP',
      'login.widget.pwa.enter.otp': 'Enter OTP',
      'login.widget.pwa.enter.otp.text': 'OTP has been sent',
      'login.widget.pwa.enter.email.phone': 'Enter Mobile No./Email',
      'login.widget.pwa.enter.email': 'Enter Email',
      'login.widget.pwa.something.went.wrong': 'Some thing went wrong.',
      'login.widget.pwa.default.message':
          'We are facing some technical difficulties at the moment. Please try again.',
      'login.widget.pwa.login.default.persuation':
          'Login for the Best Travel Offers.',
      'login.widget.pwa.use.mobile.email':
          'Use Mobile No. or Email to Login/ Signup',
      'login.widget.pwa.enter.password.message':
          'Enter password associated with the account',
      'login.widget.pwa.enter.password.label': 'Enter Password',
      'login.widget.pwa.pwa.enter.pwd.error.message':
          'Please enter the correct password',
      'login.widget.pwa.user.already.registered': 'User is already registered',
      'login.widget.pwa.login.via.password': 'Login Via Password',
      'login.widget.pwa.login.via.otp': 'Login Via OTP',
      'login.widget.pwa.resend.otp': 'Resend OTP',
      'login.widget.pwa.submit': 'SUBMIT',
      'login.widget.pwa.verify': 'VERIFY',
      'login.widget.pwa.forgot.password': 'Forgot Password',
      'login.widget.pwa.save': 'SAVE',
      'login.widget.pwa.continue': 'Continue',
      'login.widget.pwa.resend.otp.whatsapp': 'Resend OTP on',
      'login.widget.pwa.resend.otp.sub.text': 'SMS & WhatsApp',
      'login.widget.pwa.whatsapp.disclaimer':
          'By pressing this, I agree to receiving critical messages such as OTP, booking details on WhatsApp',
      'login.widget.pwa.welcome.text': 'Welcome Aboard',
      'login.widget.pwa.update.name.heading':
          'Enter your name for faster checkouts',
      'login.widget.pwa.fullname.placeholder': 'Your Full Name',
      'login.widget.pwa.fullname.input.header': 'Full Name',
      'login.widget.pwa.skip': 'SKIP',
      'login.widget.pwa.link.account': 'Link Account',
      'login.widget.pwa.enter.email.id': 'Please enter valid email Id',
      'login.widget.pwa.not.valid.user':
          'There is no personal account associated with this email ID',
      'login.widget.pwa.already.have.mob':
          'This account already has a phone number associated',
      'login.widget.pwa.link.heading.msg': 'Link {mobile} with {email}?',
      'login.widget.pwa.link.account.msg':
          'Would you like to link the two accounts?',
      'login.widget.pwa.link.msg':
          'It seems your no. {mobile} is associated with an account {email}.',
      'login.widget.pwa.link.acc': 'YES, LINK ACCOUNTS',
      'login.widget.pwa.link.keep.seperate': 'NO, KEEP THESE SEPERATE',
      'login.widget.pwa.powered.by.mobile.connect': 'Powered by Mobile Connect',
      'login.widget.pwa.privacy.policy.msg': 'Privacy Policy',
      'login.widget.pwa.user.agremement.msg': 'User Agreement',
      'login.widget.pwa.google': 'Google',
      'login.widget.pwa.fb': 'Facebook',
      'login.widget.pwa.incorrect.link.text':
          'Oops, this link was to be opened on our MakeMyTrip App. However, you can:',
      'login.widget.pwa.login.on.pwa': 'Login on Mobile Web',
      'login.widget.pwa.go.to.app': 'Get MakeMyTrip App',
      'login.widget.pwa.login.signup.easily': 'Login/ Signup Easily',
      'login.widget.pwa.proceed.to.login.msg':
          "By proceeding, you agree to MakeMyTrip's ",
      'login.widget.pwa.tos.msg': 'T&Cs',
      'login.widget.pwa.create.password.label': 'Create Password',
      'login.widget.pwa.create.password.message':
          'Now let’s make sure that you never lose access to your account',
      'login.widget.pwa.one.or.numberic.msg': ' 1 or more numeric character',
      'login.widget.pwa.one.or.more.special.msg':
          ' 1 or more special character (@#$%^&*)',
      'login.widget.pwa.min.characters.msg': ' 8 characters or above',
      'login.widget.pwa.mybiz.account.msg':
          'It seems you are trying to login with your myBiz account',
      'login.widget.pwa.download.app': 'DOWNLOAD APP',
      'login.widget.pwa.create.new.personal.account':
          'CREATE NEW PERSONAL ACCOUNT',
      'login.widget.pwa.login.account.block.error.msg':
          'You have crossed the maximum limit of login attempts. Please try again after ',
      'login.widget.pwa.account.blocked':
          'Login blocked. Please try again after ',
      'login.widget.pwa.logged.in.success': 'You are logged-in successfully',
      'login.widget.pwa.signed.up.success': 'Account Created Successfully',
      'login.widget.pwa.account.linked.successfully':
          'Account linked Successfully',
      'login.widget.pwa.dismiss': 'DISMISS',
      'login.widget.pwa.mybiz.subheading':
          'myBiz is currently unavailable on mobile-web, to continue using myBiz services download our ',
      'login.widget.pwa.mybiz.subheading.bold': 'free mobile app',
      'login.widget.pwa.login.auto.fetch.otp': 'Auto fetching OTP',
      'login.widget.pwa.login.enter.here': 'Enter Here...',
      'login.widget.pwa.mconnect.tnc':
          'Your number is fetched from your operator for fast login & by continuing you consent usage of the same as per',
      'login.widget.pwa.login.country.name': 'Country Name or Code',
      'login.widget.pwa.m.tos.msg': 'as well as Mobile Connect’s',
      'login.widget.pwa.google.error': 'Google login Failed',
      'login.widget.pwa.facebook.error': 'Facebook login Failed',
      'login.widget.pwa.login.closure.text': 'to login',
      'login.widget.enter.email.link.account':
          "Enter email of the account you want your mobile number <span class='lato-bold' dir='ltr'> {mobileNumber} </span>to be linked with.",
      'login.widget.login.to.find.cheapest.flight':
          'Login to Find the Cheapest Flights',
      'login.widget.hi.traveller': 'Hi Traveller',
      'login.signup.for.best.price': 'Login/Signup for Best Prices',
      'login.autologout.title': 'Login Expired',
      'login.autologout.subtitle':
          'You have been logged-out due to inactivity. Login again to enjoy the MMT experience.',
      'login.autologout.subtitle_re_login':
          "You have been logged-out due to inactivity. <a class='blue-text latoBold'>Login again</a> to enjoy the MMT experience.",
      'login.widget.pwa.login.with.google': 'Login with Google',
    },
    flightsUiPwa_traveller: {
      'loaderTexts.fetching': 'Fetching information...',
      'loaderTexts.waiting': 'Wait for a moment ...',
      'travellerForm.heading': 'Add Traveller',
      'travellerForm.clearBtnText': 'Clear',
      'travellerForm.confirmBtnText': 'CONFIRM',
      'travellerForm.editBtnText': 'EDIT',
      'travellerForm.selectedTemplate': '{{travellerRatio}} selected',
      'travellerForm.errorTexts.selectAdults': 'Please select all Adults',
      'travellerForm.errorTexts.selectChildren': 'Please select all Children',
      'travellerForm.errorTexts.selectInfants': 'Please select all Infants',
      'travellerForm.errorTexts.moreTravellers':
          'You have already selected maximum number of Traveller(s)',
      'footer.ctaBtnTexts.createQuote': 'Create Quote',
      'footer.ctaBtnTexts.continue': 'CONTINUE',
    },
    flightsUiPwa_ancillary: {
      'header.title': 'Add-ons',
      'header.skipBtnText': 'Skip to Payment',
      'loaderTexts.fetching': 'Fetching ancillaries and add-on information',
      'loaderTexts.waiting': 'Wait for a moment ...',
      'clearWarning.title': 'Are you sure ?',
      'clearWarning.subTitle':
          'By clicking on Okay, all your seat, meal and extra baggage selections will be discarded.',
      'clearWarning.rcaText': 'OKAY',
      'clearWarning.lcaText': 'CANCEL',
      'addonsCommonTexts.addBtnText': 'ADD',
      'addonsCommonTexts.totalFareTemplate': 'Total {{fare}}',
      'addonsCommonTexts.totalFareSubtitle': 'Added to fare',
      'seats.seatTakenText': 'Sorry, This seat is taken',
      'tabs.SEATS': 'SEATS',
      'tabs.MEALS': 'MEALS',
      'tabs.ADDONS': 'ADDONS',
      'footer.ctaBtnText': 'NEXT',
    },
  },
  hin: {
    flightsUiPwa_listing: {
      'timingOptions.selectFlightTagText': 'Select a flight for this trip',
      'timingOptions.nonStopText': 'Non stop',
      'timingOptions.stopsDescText': '{{stopsCount}} stop(s)',
      'timingOptions.showMoreBtnText': 'Show More',
      'timingOptions.showLessBtnText': 'Show Less',
      'timingOptions.continueBtnText': 'CONTINUE',
      'listingCard.bookBtnText': 'Book',
      'listingCard.viewMoreBtnTextPlural': '+ {{optionsCountP}} options',
      'listingCard.viewMoreBtnTextSingular': '+ {{optionsCountS}} option',
      'listingCard.lessOptionsBtnText': 'Less',
      'listingCard.plusDayTemplatePlural':
          '<span class="font10">+{{dayCountP}}</span> DAYS',
      'listingCard.plusDayTemplateSingular':
          '<span class="font10">+{{dayCountS}}</span> DAY',
      'listingCard.discountMessage':
          'Get up to Rs.{{amount}} return discount on this flight',
      'filtersV2.filterBarTexts.sort': 'Sort Results',
      'filtersV2.filterBarTexts.filter': 'Filter Flights',
      'filtersV2.heading': 'Sort & Filters',
      'filtersV2.tabsTexts.sort': 'Sort by',
      'filtersV2.tabsTexts.filters': 'Filters',
      'filtersV2.filterResultsTemplate':
          '{{filterCount}} of {{totalCount}} results',
      'filtersV2.filterResultsSplitViewTemplate':
          '{{filterCountSV}} Depart {{filterCountRT}} Return',
      'filtersV2.applyBtnText': 'APPLY',
      'filtersV2.clearBtnText': 'CLEAR',
      'filtersV2.showMoreAirlinesText': 'Show More Airlines',
      'filtersV2.showLessAirlinesText': 'Show Less Airlines',
      'filtersV2.emptyResultsToastMessage':
          'Too many filters applied. Please de-select your last filter',
      'filtersV2.tooManyFilters.title':
          'Too many filters applied. Please de-select your last filter!',
      'filtersV2.tooManyFilters.subTitle':
          'Try a different combination of filter',
      'filtersV2.tooManyFilters.ctaBtnText': 'Remove all filters',
      'filtersV2.otherFiltersTitle': 'Other Filters',
      otherFlightsHeading: 'Other Flights',
      'loadersText.preReview': 'Fetching flight details...',
      'loadersText.pageBlock': 'Wait for a moment ...',
      'flightDetail.heading': 'Flight Details',
      'multiFare.heading': 'Fare options',
      'fareCalendar.heading': 'Fare Calendar',
      'fareCalendar.fromToTemplate': '{{fromCityName}} to {{toCityName}}',
      'fareCalendar.doneBtnText': 'DONE',
      'fareCalendar.clearBtnText': 'CLEAR',
      'subHeaderRT.tabs.departText': 'DEPART',
      'subHeaderRT.tabs.returnText': 'RETURN',
      'subHeaderRT.fareInfo.departureText': 'Departure',
      'subHeaderRT.fareInfo.returnText': 'Return',
      'subHeaderRT.returnDiscountMsg.part1': 'Return discount applied |',
      'subHeaderRT.returnDiscountMsg.part2':
          'You save {currencySymbol} {discountSum}',
      'coachmarks.buttonsTexts.skip': 'SKIP',
      'coachmarks.buttonsTexts.next': 'NEXT',
      'coachmarks.buttonsTexts.last': 'OK,GOT IT',
      'coachmarks.step1':
          '<span class="LatoBold">Scroll down</span> for more flights. <br/><span class="LatoBold">Tap</span> to select.',
      'coachmarks.step2a':
          '<span class="LatoBold"> Swipe left </span>for {fromCity} to {toCity} flights. <span class="LatoBold">Tap </span> to select.',
      'coachmarks.step2b':
          '<span class="LatoBold">Tap here </span> to get details of {fromCity} to {toCity} flights',
      'coachmarks.step3':
          '<span class="LatoBold"> Apply filters </span>for your flight search.',
      'coachmarks.step4':
          'Click here to select a<span class="LatoBold">  Quick Filter. </span>',
      'invalidCombo.moreTimeOptionInvalidTitle': 'Invalid combination',
      'invalidCombo.moreTimeOptionInvalidMessage':
          'The selected flight timings are not compatible. Kindly try a different time option.',
      'invalidCombo.rtDomInvalidTitle': 'Invalid combination',
      'invalidCombo.rtDomInvalidMessage':
          'The selected flight timings are not compatible. Please have a minimum difference of 60 minutes between onward & return journey.',
      'invalidCombo.ctaText': 'OKAY,GOT IT',
    },
    flightsUiPwa_common: {
      'searchHeader.editBtnText': 'Edit',
      'searchHeader.heading': 'Modify Flight Search',
      'searchHeader.travellerHeading': 'Traveller details',
      'fareBreakup.heading': 'Fare Breakup',
      'fareBreakup.totalAmtText': 'Total Amount:',
      autoCompleteNoOptionsText: 'No Options',
      'wheelDatePicker.captions.date': 'Date',
      'wheelDatePicker.captions.month': 'Month',
      'wheelDatePicker.captions.year': 'Year',
      'wheelDatePicker.doneBtnText': 'Done',
      'wheelDatePicker.cancelBtnText': 'Cancel',
      'errorScreen.title': 'You have encountered an error.',
      'errorScreen.ctaTexts.webview': 'CLOSE',
      'errorScreen.ctaTexts.pwa': 'REFRESH',
      'bottomOverlay.loaderText': 'Wait for a moment ...',
      genericInputErrMessage: 'Request you to type in English',
    },
    flight_widget_pwa: {
      'flight.pwa.choose.filters.text': 'CHOOSE FILTERS (OPTIONAL)',
      'flight.pwa.one.way.text': 'ONE WAY',
      'flight.pwa.roundtrip.text': 'ROUNDTRIP',
      'flight.pwa.multi.city.text': 'MULTICITY',
      'flight.pwa.enter.city.airport.text': 'Enter City/Airport Name',
      'flight.pwa.number.of.travellers.text': 'ADD NUMBER OF TRAVELLERS',
      'flight.pwa.day.of.travel.text': 'on the day of travel',
      'flight.pwa.adults.text': 'Adults',
      'flight.pwa.children.text': 'Children',
      'flight.pwa.infants.text': 'Infants',
      'flight.pwa.adult.text': 'Adult',
      'flight.pwa.child.text': 'Child',
      'flight.pwa.infant.text': 'Infant',
      'flight.pwa.choose.cabin.class.text': 'CHOOSE CABIN CLASS',
      'flight.pwa.adult.years.text': '12 yrs & above',
      'flight.pwa.children.years.text': '2 - 12 yrs',
      'flight.pwa.check.out.text': 'Check-Out',
      'flight.pwa.check.in.text': 'Check-In',
      'flight.pwa.date.text': 'date',
      'flight.pwa.select.text': 'Select',
      'flight.pwa.nights.text': 'Nights',
      'flight.pwa.today.text': 'Today',
      'flight.pwa.done.text': 'DONE',
      'flight.pwa.apply.search.text': 'APPLY AND SEARCH FLIGHTS',
      'flight.pwa.to.book.text': 'To Book',
      'flight.pwa.more.travellers.text': 'more than 9 travellers',
      'flight.pwa.call.us.text': 'Call us on',
      'flight.pwa.get.prices.text': 'and get attractive prices',
      'flight.pwa.etc.text': 'etc',
      'flight.pwa.special.fare.text': 'SPECIAL FARE (Optional)',
      'flight.pwa.select.fare.type': 'Select Fare Type',
      'flight.pwa.premium.economy.text': 'Economy/Premium Economy',
      'flight.pwa.premium.economy.short.text': 'Eco/Prem. Eco',
      'flight.pwa.prem.eco.text': 'Premium Economy',
      'flight.pwa.prem.eco.short.text': 'Prem. Eco.',
      'flight.pwa.business.text': 'Business',
      'flight.pwa.search.flights.text': 'Search Flights',
      'flight.pwa.travelling.from.text': 'TRAVELLING FROM',
      'flight.pwa.travelling.to.text': 'TRAVELLING TO',
      'flight.pwa.from.to.text': 'From-To',
      'flight.pwa.travel.dates.text': 'TRAVEL DATES',
      'flight.pwa.traveller.class.text': 'TRAVELLER & CLASS',
      'flight.pwa.filters.text': 'FILTERS',
      'flight.pwa.select.traveller.class.text': 'Select Traveller & Class',
      'flight.pwa.from.text': 'From',
      'flight.pwa.to.text': 'To',
      'flight.pwa.from.uppercase.text': 'FROM',
      'flight.pwa.to.uppercase.text': 'TO',
      'flight.pwa.save.atleast.text': 'Save more on round trips!',
      'flight.pwa.infant.years.text': 'Under 2 yrs',
      'flight.pwa.return.date.text': 'RETURN DATE',
      'flight.pwa.add.return.date.text': '+ ADD RETURN DATE',
      'flight.pwa.fare.type.text': 'FARE TYPE',
      'flight.pwa.departure.date.text': 'DEPARTURE DATE',
      'flight.pwa.non.stop.filter': 'Non-Stop',
      'flight.pwa.morning.departure.filter': 'Morning Departure',
      'flight.pwa.late.departure.filter': 'Late Departure',
      'flight.pwa.one.stop.filter': '1 stop',
      'flight.pwa.select.departure.date.text': 'Select Departure Date',
      'flight.pwa.select.return.date.text': 'Select Return Date',
      'flight.pwa.departure.date.tooltip':
          'Departure Date from the calendar above',
      'flight.pwa.return.date.tooltip': 'Return Date from the calendar above',
      'flight.pwa.infants.more.than.adults.error':
          "Number of infants can't exceed number of adults",
      'flight.pwa.max.passenger.error':
          'Upto 9 passengers can be booked at a time.',
      'flight.pwa.same.from.to.message':
          "'Source City and Destination City cannot be the same'",
      'flight.pwa.select.date.text': 'Select Date',
      'flight.pwa.add.city.text': '+ ADD CITY',
      'flight.pwa.regular.text': 'Regular',
      'flight.pwa.student.text': 'Student',
      'flight.pwa.student.description.text':
          'Only students above 12 years of age are eligible for special fares and/or additional baggage allowances. Carrying valid student ID cards and student visas (where applicable) is mandatory, else the passenger may be denied boarding or asked to pay for extra baggage.',
      'flight.pwa.defence.text': 'Armed Forces',
      'flight.pwa.defence.description.text':
          'Only serving/retired Indian Armed Forces personnel & their dependents can avail this special fare. It is mandatory to show a valid Armed Forces ID or dependent card at the airport, without which boarding will be denied.',
      'flight.pwa.senior.text': 'Senior Citizen',
      'flight.pwa.doctor.text': 'Doctor',
      'flight.pwa.doctor.description.text':
          'Special discounted fares are applicable to the Healthcare Professionals only. Passengers booked under this fare are required to produce a valid Healthcare ID card at the airport check-in counters.',
      'flight.pwa.senior.description.text':
          'Only senior citizens above the age of 60 years can avail this special fare. It is mandatory to produce proof of Date of Birth at the airport, without which prevailing fares will be charged.',
      'flight.pwa.capital.date.text': 'DATE',
      'flight.pwa.flight.search.heading': 'Flight Search',
      'flight.pwa.holiday.singular.text': 'Holiday',
      'flight.pwa.holiday.plural.text': 'Holidays',
      'flight.pwa.city.DXB': 'Dubai',
      'flight.pwa.country.united.arab.emirates': 'United Arab Emirates',
      'flight.pwa.dubai.international.airport': 'Dubai International Airport',
      'flight.pwa.city.singular.text': '+{count} City',
      'flight.pwa.city.plural.text': '+{count} Cities',
      'flight.pwa.traveller.count.error':
          'Kindly choose the value between {count}-10',
      'flight.pwa.calendar.months': [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      'flight.pwa.calendar.months.short': [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      'flight.pwa.calendar.week-days': [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      'flight.pwa.calendar.week-days.3-digit': [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
      ],
      'flight.pwa.calendar.week-days.3-digit.iso': [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun',
      ],
      'flight.pwa.calendar.week-days.2-digit': [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa',
      ],
      'flight.pwa.calendar.week-days.1-digit': [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S',
      ],
      'flight.pwa.search.results.label': 'SEARCH RESULTS',
      'flight.pwa.recent.searches.label': 'RECENT SEARCHES',
      'flight.pwa.popular.searches.label': 'POPULAR SEARCHES',
      'flight.pwa.no.result.found.label': 'Sorry, no results found for',
      'flight.pwa.please.retry.search.label':
          'Please try again with a different search',
      'flight.pwa.city.DEL': 'Delhi',
      'flight.pwa.city.NYC': 'New York',
      'flight.pwa.country.india': 'India',
      'flight.pwa.delhi.airport': 'Delhi Airport',
      'flight.pwa.country.united.states': 'US',
      'flight.pwa.all.airports': 'All Airports',
      'flight.pwa.travellers': 'Travellers',
      'flight.pwa.traveller': 'Traveller',
      'flight.pwa.city': 'City',
      'flight.pwa.cities': 'Cities',
      'flight.pwa.city.BOM': 'Mumbai',
      'flight.pwa.mumbai.airport': 'Chhatrapati Shivaji International Airport',
      'flight.pwa.city.RUH': 'Riyadh',
      'flight.pwa.country.saudi.arabia': 'Saudi Arabia',
      'flight.pwa.riyadh.international.airport': 'Riyadh International Airport',
      'flight.pwa.city.KWI': 'Kuwait City',
      'flight.pwa.country.kuwait': 'Kuwait',
      'flight.pwa.kuwait.international.airport': 'Kuwait International Airport',
      'flight.pwa.city.MCT': 'Muscat',
      'flight.pwa.country.oman': 'Oman',
      'flight.pwa.muscat.international.airport': 'Muscat International Airport',
      'flight.pwa.vaccinated.text': 'Vaccination Fares',
      'flight.pwa.vaccinated.description.text':
          'Only vaccinated citizens of India can avail this special fare. It is mandatory to show a valid vaccination certificate notifying the Vaccination Beneficiary ID at the airport, without which boarding will be denied.',
    },
    flightsUiPwa_review: {
      'loaderTexts.fetching': 'Fetching flight information...',
      'loaderTexts.waiting': 'Wait for a moment ...',
      'loaderTexts.fetchingLayover': 'Fetching layover info',
      'leg.infoNotAvailableText': 'Info not available',
      'leg.amenities.title': 'Amenities',
      'leg.amenities.showLessText': 'SHOW LESS',
      'leg.amenities.showMoreText': 'SHOW MORE',
      'leg.baggageTexts.cabin': 'Cabin Bag -',
      'leg.baggageTexts.checkin': 'Checkin Bag -',
      'leg.fareFamilyBtnTemplate': '+{{fareCount}} FARES',
      'coupons.applyBtnText': 'Apply',
      'coupons.removeBtnText': 'Remove',
      'coupons.inputPlaceholder': 'Enter Coupon Code',
      'coupons.showAllOffersText': 'VIEW ALL OFFERS',
      'coupons.showLessOffersText': 'SHOW LESS',
      'coupons.orText': 'OR',
      'impInfo.tagText': 'Important information',
      'footer.ctaBtnText': 'CONTINUE',
    },
    flightsUiPwa_reviewTraveller: {
      'loaderTexts.fetching': 'Fetching flight information...',
      'loaderTexts.waiting': 'Wait for a moment ...',
      'travellerForm.heading': 'Add Traveller',
      'travellerForm.addedTemplate': '{{travellerRatio}} added',
      'travellerForm.errorMessageTemplate': '{fieldName} is required.',
      'travellerForm.confirmCtaText': 'CONFIRM',
      'travellerForm.errorTexts.selectTraveller': 'Please select Traveller(s)',
      'travellerForm.errorTexts.selectTravellerNew':
          'Add traveller details to continue!',
      'travellerForm.errorTexts.moreTravellers':
          'You have already selected maximum number of Traveller(s)',
      'travellerForm.errorTexts.addAllTravellers':
          'Kindly add all travellers before proceeding',
      'travellerForm.nameConfirmation.heading': 'Name Confirmation',
      'travellerForm.nameConfirmation.firstNameText': 'First Name:',
      'travellerForm.nameConfirmation.lastNameText': 'Last Name:',
      'travellerForm.nameConfirmation.editBtnText': 'EDIT',
      'travellerForm.nameConfirmation.continueBtnText': 'OK, CONTINUE',
      'contactForm.label': 'Country Code',
      'contactForm.placeholder': 'Country Name or Code',
      'gstForm.heading': 'GST Information',
      'fareRules.heading': 'Refund and Baggage Policy',
      'fareRules.tabs.CANCELLATION': 'CANCELLATION',
      'fareRules.tabs.DATE CHANGE': 'DATE CHANGE',
      'fareRules.tabs.BAGGAGE': 'BAGGAGE',
      'fareRules.baggageRuleCard.cabinText': 'Cabin',
      'fareRules.baggageRuleCard.checkInText': 'Check-in',
      'fareRules.notFound.title': 'No information available',
      'fareRules.notFound.subTitle':
          'You can check this information with the airline',
      'deals.loginToastMessage': 'Log-in to apply these offers',
      'deals.viewMoreBtnText': 'View more',
      'footer.ctaBtnText': 'CONTINUE',
    },
    login_widget_pwa: {
      'login.widget.pwa.enter.valid.email.error':
          'Please enter a valid Email Id or Mobile Number',
      'login.widget.pwa.enter.valid.emailId.error':
          'Please enter a valid Email Id',
      'login.widget.pwa.valid.mobile.number':
          'Please enter a valid phone number',
      'login.widget.pwa.otp.error': 'Please enter a valid OTP',
      'login.widget.pwa.enter.otp': 'Enter OTP',
      'login.widget.pwa.enter.otp.text': 'OTP has been sent',
      'login.widget.pwa.enter.email.phone': 'Enter Mobile No./Email',
      'login.widget.pwa.enter.email': 'Enter Email',
      'login.widget.pwa.something.went.wrong': 'Some thing went wrong.',
      'login.widget.pwa.default.message':
          'We are facing some technical difficulties at the moment. Please try again.',
      'login.widget.pwa.login.default.persuation':
          'Login for the Best Travel Offers.',
      'login.widget.pwa.use.mobile.email':
          'Use Mobile No. or Email to Login/ Signup',
      'login.widget.pwa.enter.password.message':
          'Enter password associated with the account',
      'login.widget.pwa.enter.password.label': 'Enter Password',
      'login.widget.pwa.pwa.enter.pwd.error.message':
          'Please enter the correct password',
      'login.widget.pwa.user.already.registered': 'User is already registered',
      'login.widget.pwa.login.via.password': 'Login Via Password',
      'login.widget.pwa.login.via.otp': 'Login Via OTP',
      'login.widget.pwa.resend.otp': 'Resend OTP',
      'login.widget.pwa.submit': 'SUBMIT',
      'login.widget.pwa.verify': 'VERIFY',
      'login.widget.pwa.forgot.password': 'Forgot Password',
      'login.widget.pwa.save': 'SAVE',
      'login.widget.pwa.continue': 'Continue',
      'login.widget.pwa.resend.otp.whatsapp': 'Resend OTP on',
      'login.widget.pwa.resend.otp.sub.text': 'SMS & WhatsApp',
      'login.widget.pwa.whatsapp.disclaimer':
          'By pressing this, I agree to receiving critical messages such as OTP, booking details on WhatsApp',
      'login.widget.pwa.welcome.text': 'Welcome Aboard',
      'login.widget.pwa.update.name.heading':
          'Enter your name for faster checkouts',
      'login.widget.pwa.fullname.placeholder': 'Your Full Name',
      'login.widget.pwa.fullname.input.header': 'Full Name',
      'login.widget.pwa.skip': 'SKIP',
      'login.widget.pwa.link.account': 'Link Account',
      'login.widget.pwa.enter.email.id': 'Please enter valid email Id',
      'login.widget.pwa.not.valid.user':
          'There is no personal account associated with this email ID',
      'login.widget.pwa.already.have.mob':
          'This account already has a phone number associated',
      'login.widget.pwa.link.heading.msg': 'Link {mobile} with {email}?',
      'login.widget.pwa.link.account.msg':
          'Would you like to link the two accounts?',
      'login.widget.pwa.link.msg':
          'It seems your no. {mobile} is associated with an account {email}.',
      'login.widget.pwa.link.acc': 'YES, LINK ACCOUNTS',
      'login.widget.pwa.link.keep.seperate': 'NO, KEEP THESE SEPERATE',
      'login.widget.pwa.powered.by.mobile.connect': 'Powered by Mobile Connect',
      'login.widget.pwa.privacy.policy.msg': 'Privacy Policy',
      'login.widget.pwa.user.agremement.msg': 'User Agreement',
      'login.widget.pwa.google': 'Google',
      'login.widget.pwa.fb': 'Facebook',
      'login.widget.pwa.incorrect.link.text':
          'Oops, this link was to be opened on our MakeMyTrip App. However, you can:',
      'login.widget.pwa.login.on.pwa': 'Login on Mobile Web',
      'login.widget.pwa.go.to.app': 'Get MakeMyTrip App',
      'login.widget.pwa.login.signup.easily': 'Login/ Signup Easily',
      'login.widget.pwa.proceed.to.login.msg':
          "By proceeding, you agree to MakeMyTrip's ",
      'login.widget.pwa.tos.msg': 'T&Cs',
      'login.widget.pwa.create.password.label': 'Create Password',
      'login.widget.pwa.create.password.message':
          'Now let’s make sure that you never lose access to your account',
      'login.widget.pwa.one.or.numberic.msg': ' 1 or more numeric character',
      'login.widget.pwa.one.or.more.special.msg':
          ' 1 or more special character (@#$%^&*)',
      'login.widget.pwa.min.characters.msg': ' 8 characters or above',
      'login.widget.pwa.mybiz.account.msg':
          'It seems you are trying to login with your myBiz account',
      'login.widget.pwa.download.app': 'DOWNLOAD APP',
      'login.widget.pwa.create.new.personal.account':
          'CREATE NEW PERSONAL ACCOUNT',
      'login.widget.pwa.login.account.block.error.msg':
          'You have crossed the maximum limit of login attempts. Please try again after ',
      'login.widget.pwa.account.blocked':
          'Login blocked. Please try again after ',
      'login.widget.pwa.logged.in.success': 'You are logged-in successfully',
      'login.widget.pwa.signed.up.success': 'Account Created Successfully',
      'login.widget.pwa.account.linked.successfully':
          'Account linked Successfully',
      'login.widget.pwa.dismiss': 'DISMISS',
      'login.widget.pwa.mybiz.subheading':
          'myBiz is currently unavailable on mobile-web, to continue using myBiz services download our ',
      'login.widget.pwa.mybiz.subheading.bold': 'free mobile app',
      'login.widget.pwa.login.auto.fetch.otp': 'Auto fetching OTP',
      'login.widget.pwa.login.enter.here': 'Enter Here...',
      'login.widget.pwa.mconnect.tnc':
          'Your number is fetched from your operator for fast login & by continuing you consent usage of the same as per',
      'login.widget.pwa.login.country.name': 'Country Name or Code',
      'login.widget.pwa.m.tos.msg': 'as well as Mobile Connect’s',
      'login.widget.pwa.google.error': 'Google login Failed',
      'login.widget.pwa.facebook.error': 'Facebook login Failed',
      'login.widget.pwa.login.closure.text': 'to login',
      'login.widget.enter.email.link.account':
          "Enter email of the account you want your mobile number <span class='lato-bold' dir='ltr'> {mobileNumber} </span>to be linked with.",
      'login.widget.login.to.find.cheapest.flight':
          'Login to Find the Cheapest Flights',
      'login.widget.hi.traveller': 'Hi Traveller',
      'login.signup.for.best.price': 'Login/Signup for Best Prices',
      'login.autologout.title': 'Login Expired',
      'login.autologout.subtitle':
          'You have been logged-out due to inactivity. Login again to enjoy the MMT experience.',
      'login.autologout.subtitle_re_login':
          "You have been logged-out due to inactivity. <a class='blue-text latoBold'>Login again</a> to enjoy the MMT experience.",
      'login.widget.pwa.login.with.google': 'Login with Google',
    },
    flightsUiPwa_traveller: {
      'loaderTexts.fetching': 'Fetching information...',
      'loaderTexts.waiting': 'Wait for a moment ...',
      'travellerForm.heading': 'Add Traveller',
      'travellerForm.clearBtnText': 'Clear',
      'travellerForm.confirmBtnText': 'CONFIRM',
      'travellerForm.editBtnText': 'EDIT',
      'travellerForm.selectedTemplate': '{{travellerRatio}} selected',
      'travellerForm.errorTexts.selectAdults': 'Please select all Adults',
      'travellerForm.errorTexts.selectChildren': 'Please select all Children',
      'travellerForm.errorTexts.selectInfants': 'Please select all Infants',
      'travellerForm.errorTexts.moreTravellers':
          'You have already selected maximum number of Traveller(s)',
      'footer.ctaBtnTexts.createQuote': 'Create Quote',
      'footer.ctaBtnTexts.continue': 'CONTINUE',
    },
    flightsUiPwa_ancillary: {
      'header.title': 'Add-ons',
      'header.skipBtnText': 'Skip to Payment',
      'loaderTexts.fetching': 'Fetching ancillaries and add-on information',
      'loaderTexts.waiting': 'Wait for a moment ...',
      'clearWarning.title': 'Are you sure ?',
      'clearWarning.subTitle':
          'By clicking on Okay, all your seat, meal and extra baggage selections will be discarded.',
      'clearWarning.rcaText': 'OKAY',
      'clearWarning.lcaText': 'CANCEL',
      'addonsCommonTexts.addBtnText': 'ADD',
      'addonsCommonTexts.totalFareTemplate': 'Total {{fare}}',
      'addonsCommonTexts.totalFareSubtitle': 'Added to fare',
      'seats.seatTakenText': 'Sorry, This seat is taken',
      'tabs.SEATS': 'SEATS',
      'tabs.MEALS': 'MEALS',
      'tabs.ADDONS': 'ADDONS',
      'footer.ctaBtnText': 'NEXT',
    },
  },
};
